import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** ISO8601 Date string */
  Date: { input: any; output: any; }
  /** Postgres Interval value */
  Interval: { input: any; output: any; }
  /** A bounded JSON object */
  JSON: { input: any; output: any; }
  LowercaseStringValue: { input: any; output: any; }
  /** Expression representing some range, can be single number e.g. 1 or range e.g. 1-3 */
  RangeExp: { input: any; output: any; }
  /** JS regular expression */
  RegExp: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type AccessToken = {
  __typename?: 'AccessToken';
  baseUser?: Maybe<BaseUser>;
  consent?: Maybe<Scalars['Boolean']['output']>;
  expireAt?: Maybe<Scalars['Date']['output']>;
  revoked?: Maybe<Scalars['Boolean']['output']>;
  status?: Maybe<AccessTokenStatus>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum AccessTokenStatus {
  ConsentNotFound = 'CONSENT_NOT_FOUND',
  Expired = 'EXPIRED',
  Revoked = 'REVOKED',
  Valid = 'VALID'
}

export type AdditionalRespondentDataFromTeamio = {
  __typename?: 'AdditionalRespondentDataFromTeamio';
  addedOn?: Maybe<Scalars['String']['output']>;
  channelId: Scalars['ID']['output'];
  managers?: Maybe<Array<Scalars['String']['output']>>;
  position?: Maybe<Scalars['String']['output']>;
  recruiter?: Maybe<Scalars['String']['output']>;
};

/** Aggregate of answers by their values */
export type AggregateAnswersByValue = {
  __typename?: 'AggregateAnswersByValue';
  /** Count of answers with same value|text */
  count: Scalars['Int']['output'];
  /** Text of answer */
  text: Scalars['String']['output'];
  /** Answer value, not null for SelectAnswer */
  value?: Maybe<Scalars['Int']['output']>;
};

export type AiCallLogData = {
  __typename?: 'AiCallLogData';
  data: Array<AiCallLogEntry>;
  totalCount: Scalars['Int']['output'];
};

export type AiCallLogDetail = {
  __typename?: 'AiCallLogDetail';
  cachedInputTokens?: Maybe<Scalars['Int']['output']>;
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  deployment: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  languageId?: Maybe<Scalars['ID']['output']>;
  model: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
  respondentId?: Maybe<Scalars['ID']['output']>;
  responseText?: Maybe<Scalars['String']['output']>;
  retries: Scalars['Int']['output'];
  status: Scalars['String']['output'];
  stream: Scalars['Boolean']['output'];
  surveyId?: Maybe<Scalars['ID']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  useCase: Scalars['String']['output'];
  userPrompt: Scalars['String']['output'];
};

export type AiCallLogEntry = {
  __typename?: 'AiCallLogEntry';
  cost?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['Date']['output'];
  deployment: Scalars['String']['output'];
  durationMs?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  inputTokens?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  organizationId?: Maybe<Scalars['ID']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  promptPreview: Scalars['String']['output'];
  responsePreview?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  stream: Scalars['Boolean']['output'];
  useCase: Scalars['String']['output'];
};

/** AI use-case configuration row — hot-swappable, picked up by the API/worker within ~60s (SysAdmin only) */
export type AiGenerationConfig = {
  __typename?: 'AiGenerationConfig';
  deployment: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jsonMode: Scalars['Boolean']['output'];
  maxOutputTokens?: Maybe<Scalars['Int']['output']>;
  model: Scalars['String']['output'];
  reasoningEffort?: Maybe<Scalars['String']['output']>;
  systemPrompt?: Maybe<Scalars['String']['output']>;
  temperature?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<Scalars['String']['output']>;
  useCase: Scalars['String']['output'];
};

/** Partial override on top of a saved AiGenerationConfig row — used for both saving and as an unsaved test draft */
export type AiGenerationConfigInput = {
  deployment?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  jsonMode?: InputMaybe<Scalars['Boolean']['input']>;
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  reasoningEffort?: InputMaybe<Scalars['String']['input']>;
  systemPrompt?: InputMaybe<Scalars['String']['input']>;
  temperature?: InputMaybe<Scalars['Float']['input']>;
};

export type AiGenerationConfigTestInput = {
  /** Unsaved form state, tested as an override without persisting anything */
  draft?: InputMaybe<AiGenerationConfigInput>;
  testPrompt: Scalars['String']['input'];
  useCase: Scalars['String']['input'];
};

export type AiGenerationTestResult = {
  __typename?: 'AiGenerationTestResult';
  cachedTokens?: Maybe<Scalars['Int']['output']>;
  costUsd?: Maybe<Scalars['Float']['output']>;
  durationMs: Scalars['Int']['output'];
  /** Provider or config error message; present instead of throwing so the test button can show it inline */
  error?: Maybe<Scalars['String']['output']>;
  inputTokens?: Maybe<Scalars['Int']['output']>;
  outputText?: Maybe<Scalars['String']['output']>;
  outputTokens?: Maybe<Scalars['Int']['output']>;
  reasoningTokens?: Maybe<Scalars['Int']['output']>;
};

export type AiModelPricing = {
  __typename?: 'AiModelPricing';
  cachedInputCostPerToken?: Maybe<Scalars['Float']['output']>;
  fetchedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  inputCostPerToken: Scalars['Float']['output'];
  manualOverride: Scalars['Boolean']['output'];
  model: Scalars['String']['output'];
  outputCostPerToken: Scalars['Float']['output'];
  source: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export enum AiSurveySummaryAbInteractionAction {
  Exposed = 'EXPOSED',
  SelectedA = 'SELECTED_A',
  SelectedB = 'SELECTED_B',
  WholeAbSummaryRevealed = 'WHOLE_AB_SUMMARY_REVEALED'
}

export type AiSurveySummaryAbInteractionInput = {
  accessToken: Scalars['String']['input'];
  action: AiSurveySummaryAbInteractionAction;
  answersTotal?: InputMaybe<Scalars['Int']['input']>;
  experimentId: Scalars['ID']['input'];
  freeTextAnswersTotal?: InputMaybe<Scalars['Int']['input']>;
  languageCode: Scalars['String']['input'];
  surveyQuestionsTotal?: InputMaybe<Scalars['Int']['input']>;
  surveyRespondentsAnswered?: InputMaybe<Scalars['Int']['input']>;
  viewerSysAdmin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AiSurveySummaryAbTestData = {
  __typename?: 'AiSurveySummaryAbTestData';
  experimentId?: Maybe<Scalars['ID']['output']>;
  layout?: Maybe<AiSurveySummaryAbTestLayout>;
  left?: Maybe<AiSurveySummaryAbTestVariantStream>;
  mode: AiSurveySummaryAbTestMode;
  right?: Maybe<AiSurveySummaryAbTestVariantStream>;
  single?: Maybe<AiSurveySummaryData>;
};

export enum AiSurveySummaryAbTestLayout {
  ALeft = 'A_LEFT',
  BLeft = 'B_LEFT'
}

export enum AiSurveySummaryAbTestMode {
  Ab = 'AB',
  Single = 'SINGLE'
}

export type AiSurveySummaryAbTestVariantStream = {
  __typename?: 'AiSurveySummaryAbTestVariantStream';
  done: Scalars['Boolean']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  variantKey: AiSurveySummaryAbVariantKey;
};

export enum AiSurveySummaryAbVariantKey {
  A = 'A',
  B = 'B'
}

export type AiSurveySummaryCacheClearResult = {
  __typename?: 'AiSurveySummaryCacheClearResult';
  cacheCleared: Scalars['Boolean']['output'];
  limitReached: Scalars['Boolean']['output'];
};

export type AiSurveySummaryData = {
  __typename?: 'AiSurveySummaryData';
  done: Scalars['Boolean']['output'];
  hash?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type AiTranslateNodeInput = {
  choices: Array<Scalars['String']['input']>;
  questionIndex: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  statements: Array<Scalars['String']['input']>;
};

export type AiTranslateTopicNodesResult = {
  __typename?: 'AiTranslateTopicNodesResult';
  description?: Maybe<Scalars['String']['output']>;
  limitReached: Scalars['Boolean']['output'];
  nodes: Array<AiTranslatedNode>;
  title?: Maybe<Scalars['String']['output']>;
};

export type AiTranslatedNode = {
  __typename?: 'AiTranslatedNode';
  choices: Array<Scalars['String']['output']>;
  questionIndex: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  statements: Array<Scalars['String']['output']>;
  /** false when the node could not be fully translated (partial failure) — the client should skip it and leave it for retry */
  translated: Scalars['Boolean']['output'];
};

export enum AiUsageGroupBy {
  Day = 'DAY',
  Model = 'MODEL',
  Organization = 'ORGANIZATION',
  UseCase = 'USE_CASE'
}

export type AiUsageRow = {
  __typename?: 'AiUsageRow';
  avgDurationMs: Scalars['Float']['output'];
  calls: Scalars['Int']['output'];
  costUsd: Scalars['Float']['output'];
  errors: Scalars['Int']['output'];
  inputTokens: Scalars['Int']['output'];
  /** The group's key: a use case, model, organization id, or ISO day depending on groupBy */
  key?: Maybe<Scalars['String']['output']>;
  /** Populated only when grouping by ORGANIZATION; null means no organization */
  organizationName?: Maybe<Scalars['String']['output']>;
  outputTokens: Scalars['Int']['output'];
};

/** Special rule that always matches given input */
export type AlwaysMatchingRule = Rule & {
  __typename?: 'AlwaysMatchingRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
};

/** Pair anonymityLevel -> label */
export type Anonymity = {
  __typename?: 'Anonymity';
  /** Label that will be shown in UI for this anonymity level */
  label: Scalars['String']['output'];
  /** AnonymityLevel */
  level: AnonymityLevel;
};

/** Tuple of desired anonymity and ui presentable label */
export type AnonymityChoice = {
  __typename?: 'AnonymityChoice';
  /** Text associated with this choice */
  text: Scalars['String']['output'];
  /** Anonymity that will be set if user selects this choice */
  value: AnonymityChoiceValue;
};

/**
 * Set anonymity of channel to which value?
 * This should extend AnonymityLevel enum but IDL doesn't support that nor scalar unions
 */
export enum AnonymityChoiceValue {
  /** Do NOT change anonymity */
  Cancel = 'CANCEL',
  /** We can identify respondent directly */
  None = 'NONE',
  /** Only respondent's organization is known */
  Organization = 'ORGANIZATION'
}

/** Level of anonymity, answers in particular channel have */
export enum AnonymityLevel {
  /** We can identify respondent directly */
  None = 'NONE',
  /** Only respondent's organization is known */
  Organization = 'ORGANIZATION'
}

/** Survey anonymity settings */
export type AnonymitySettings = {
  __typename?: 'AnonymitySettings';
  /** Allowed anonymity levels that can be set via setChannelAnonymity. */
  allowedLevels?: Maybe<Array<AnonymityLevel>>;
  /** Default anonymity for channels that are created from this survey. */
  default?: Maybe<AnonymityLevel>;
};

/** Union of all answer types. Should be interface extending Message type, but graphql doesn't allow that */
export type Answer = FreeTextAnswer | SelectAnswer;

/**
 * Question definition that can be answered.
 * Better would be if this extended QuestionDefinition interface
 * but graphql doesn't allow interfaces extend interfaces
 */
export type Answerable = {
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: AnswersConnection;
  /** ID of question */
  id: Scalars['ID']['output'];
  /** Question wording */
  text: Scalars['String']['output'];
};


/**
 * Question definition that can be answered.
 * Better would be if this extended QuestionDefinition interface
 * but graphql doesn't allow interfaces extend interfaces
 */
export type AnswerableAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for Answer. */
export type AnswersConnection = {
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<AnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type AnswersEdge = {
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The answer at the end of the edge. */
  node: Answer;
};

export type ArielAiChatAttachmentInput = {
  dataBase64: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type ArielAiChatData = {
  __typename?: 'ArielAiChatData';
  done: Scalars['Boolean']['output'];
  error?: Maybe<ArielAiChatError>;
  patch?: Maybe<Array<ArielAiNodeData>>;
  text: Scalars['String']['output'];
};

export type ArielAiChatError = {
  __typename?: 'ArielAiChatError';
  code: ArielAiChatErrorCode;
  message: Scalars['String']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ArielAiChatErrorCode {
  AccessDenied = 'ACCESS_DENIED',
  AttachmentInvalid = 'ATTACHMENT_INVALID',
  GenerationFailed = 'GENERATION_FAILED',
  ValidationFailed = 'VALIDATION_FAILED'
}

export type ArielAiChatMessageInput = {
  attachments?: InputMaybe<Array<ArielAiChatAttachmentInput>>;
  content: Scalars['String']['input'];
  role: ArielAiChatRole;
};

export enum ArielAiChatRole {
  Assistant = 'ASSISTANT',
  User = 'USER'
}

export type ArielAiComment = {
  __typename?: 'ArielAiComment';
  id?: Maybe<Scalars['ID']['output']>;
  originator?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type ArielAiCommentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  originator?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ArielAiNodeChoice = {
  __typename?: 'ArielAiNodeChoice';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ArielAiNodeChoiceInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type ArielAiNodeData = {
  __typename?: 'ArielAiNodeData';
  answersToHighlight?: Maybe<Array<ArielAiNodeChoice>>;
  choices: Array<ArielAiNodeChoice>;
  commentGroupId?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Array<ArielAiComment>>;
  input: Scalars['Boolean']['output'];
  isQuestionTrigger: Scalars['Boolean']['output'];
  isRankingScale?: Maybe<Scalars['Boolean']['output']>;
  isRequired: Scalars['Boolean']['output'];
  metrics: Array<Metrics>;
  outputs: Array<ArielAiNodeOutput>;
  position?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  questionIndex: Scalars['Int']['output'];
  questionText: Scalars['String']['output'];
  randomizeOrder?: Maybe<Scalars['Boolean']['output']>;
  range?: Maybe<ArielAiSelectedRange>;
  reportOrder?: Maybe<Scalars['Int']['output']>;
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  statementIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  statements?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  type: Scalars['String']['output'];
};

export type ArielAiNodeDataInput = {
  answersToHighlight?: InputMaybe<Array<ArielAiNodeChoiceInput>>;
  choices: Array<ArielAiNodeChoiceInput>;
  commentGroupId?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Array<ArielAiCommentInput>>;
  input: Scalars['Boolean']['input'];
  isQuestionTrigger: Scalars['Boolean']['input'];
  isRankingScale?: InputMaybe<Scalars['Boolean']['input']>;
  isRequired: Scalars['Boolean']['input'];
  metrics: Array<Metrics>;
  outputs: Array<ArielAiNodeOutputInput>;
  position?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  questionIndex: Scalars['Int']['input'];
  questionText: Scalars['String']['input'];
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  range?: InputMaybe<SelectedRange>;
  reportOrder?: InputMaybe<Scalars['Int']['input']>;
  showEscapeOption?: InputMaybe<Scalars['Boolean']['input']>;
  statementIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  statements?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
};

export type ArielAiNodeOutput = {
  __typename?: 'ArielAiNodeOutput';
  key: Scalars['String']['output'];
  targetQuestionIndex?: Maybe<Scalars['Int']['output']>;
};

export type ArielAiNodeOutputInput = {
  key: Scalars['String']['input'];
  targetQuestionIndex?: InputMaybe<Scalars['Int']['input']>;
};

export type ArielAiSelectedRange = {
  __typename?: 'ArielAiSelectedRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

/** Rule that can match aray of integers. */
export type ArrayRule = Rule & {
  __typename?: 'ArrayRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** rule operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** Expression for this rule */
  value?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type BaseUser = {
  __typename?: 'BaseUser';
  /** users first name */
  firstname?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  /** users last name */
  surname?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type BasicSurveyInfo = {
  __typename?: 'BasicSurveyInfo';
  /** Date when was the survey archived, null if not archived */
  archivedAt?: Maybe<Scalars['Date']['output']>;
  endsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** Indicates if the survey is public */
  public?: Maybe<Scalars['Boolean']['output']>;
  sendAt: Scalars['Date']['output'];
  seqDate?: Maybe<Scalars['Date']['output']>;
  status: SurveyStatus;
};

export enum BusinessUnit {
  Central = 'CENTRAL',
  South = 'SOUTH'
}

export type CategoryCode = {
  __typename?: 'CategoryCode';
  code: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  translations?: Maybe<Array<CategoryCodeTranslation>>;
};

/** Category code translation */
export type CategoryCodeTranslation = {
  __typename?: 'CategoryCodeTranslation';
  language: Language;
  name: Scalars['String']['output'];
};

/**
 * Channel represents one conversation of respondent with BOT.
 * Can have various levels of anonymity, default is inherited from parent topic.
 */
export type Channel = {
  __typename?: 'Channel';
  /** True if channel has at least one alert-raising answer */
  alert: Scalars['Boolean']['output'];
  /** Allowed anonymity levels that can be set via setChannelAnonymity. */
  allowedAnonymities: Array<AnonymityLevel>;
  /** Allowed languages for channel */
  allowedLanguages: Array<Language>;
  /** Level of anonymity this channel currently have */
  anonymityLevel: AnonymityLevel;
  /** True if changing anonymity is disabled */
  anonymityLocked: Scalars['Boolean']['output'];
  /** True if channel has at least one respondent message */
  answered: Scalars['Boolean']['output'];
  containsOriginalAnonymity: Scalars['Boolean']['output'];
  /** When this channel was created */
  createdAt: Scalars['Date']['output'];
  /** True if channel was created dissabled */
  disabled: Scalars['Boolean']['output'];
  /** Reason why this channel was disabled, if known */
  disabledReason?: Maybe<ChannelDisabledReason>;
  /** end of underlying survey */
  endsAt?: Maybe<Scalars['Date']['output']>;
  /** Channel events */
  events?: Maybe<Array<ChannelEvent>>;
  /** Date of FINISHED event if exists */
  finishedAt?: Maybe<Scalars['Date']['output']>;
  /** Channel ID */
  id: Scalars['ID']['output'];
  /** True if events contain FINISHED event */
  isFinished: Scalars['Boolean']['output'];
  isFinishedByRespondent: Scalars['Boolean']['output'];
  /** True if channel was already opened */
  isOpen: Scalars['Boolean']['output'];
  /** Channel language */
  language: Language;
  lastRemindedAt?: Maybe<Scalars['Date']['output']>;
  /** All sent messages in chronological order */
  messages?: Maybe<Array<Message>>;
  /** Date of first OPENED event if exists */
  openedAt?: Maybe<Scalars['Date']['output']>;
  /** If survey for channel is public */
  public: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<Reaction>>;
  remainingQuestions: Scalars['Int']['output'];
  /** Respondent of the channel */
  respondent?: Maybe<Respondent>;
  /** start of underlying survey */
  sendAt: Scalars['Date']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  /** Parent survey */
  survey: Survey;
  /** flag if underlying survey is finished */
  surveyFinished: Scalars['Boolean']['output'];
  /**
   * Target of this channel based on anonymityLevel
   * Whole Organization, single team or in case of no anonymity responder himself
   * Currently it's set after channel is finished,
   * before finishing it points to respondent to whom this channel was sent
   */
  target: ChannelTarget;
  /** Indicates wheter survey runs in test mode or not */
  testing?: Maybe<Scalars['Boolean']['output']>;
  /** name of channel topic */
  topicName: Scalars['String']['output'];
  totalQuestions: Scalars['Int']['output'];
};

/** Reason why a channel was disabled */
export enum ChannelDisabledReason {
  /** Response was manually deactivated */
  Manual = 'MANUAL',
  /** Response was filled too quickly (below minimum filling time) */
  TooFast = 'TOO_FAST'
}

/** Channel event what else to say? */
export type ChannelEvent = {
  __typename?: 'ChannelEvent';
  /** Parent channel */
  channel: Channel;
  /** When this event happened */
  createdAt: Scalars['Date']['output'];
  /** ID of event */
  id: Scalars['ID']['output'];
  /** type of event */
  type: ChannelEventType;
};

/** Channel event type */
export enum ChannelEventType {
  /** Channel has been anonymized */
  Anonymized = 'ANONYMIZED',
  /** Channel finished */
  Finished = 'FINISHED',
  /** Some channel messages were deleted */
  MessagesDeleted = 'MESSAGES_DELETED',
  /** Channel opened */
  Opened = 'OPENED',
  /** SourceId for channel was set */
  SetSourceId = 'SET_SOURCE_ID'
}

export type ChannelOverview = {
  __typename?: 'ChannelOverview';
  respondents?: Maybe<Array<PublicRespondent>>;
  user?: Maybe<OverviewUser>;
};

/**
 * For what most particular entity this channel answers.
 * e.g. Respondent can choose that he wants to be completely anonymous
 * so channel will target Organization and his answers won't be trackable
 * to him
 */
export type ChannelTarget = Organization | Respondent | Team;

/** Side of conversation */
export enum ChannelUserType {
  /** Message was sent by BOT */
  Bot = 'BOT',
  /** Message was sent by respondent */
  Respondent = 'RESPONDENT'
}

export type ChannelWithStartingMessages = {
  __typename?: 'ChannelWithStartingMessages';
  channel: Channel;
  displayLinkToOneplace?: Maybe<Scalars['Boolean']['output']>;
  messages?: Maybe<Array<Message>>;
  someReport?: Maybe<Scalars['Boolean']['output']>;
  someUnfilledChannel?: Maybe<Scalars['Boolean']['output']>;
  /** Created messages */
  startingMessages?: Maybe<Array<Message>>;
};

export type ChoiceAnswer = {
  choice: Scalars['String']['input'];
  count: Scalars['Int']['input'];
};

export type Comment = {
  __typename?: 'Comment';
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  originator?: Maybe<User>;
  text: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type CommentGroup = {
  __typename?: 'CommentGroup';
  comments?: Maybe<Array<Comment>>;
  id: Scalars['ID']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  topicId: Scalars['ID']['output'];
};

/** Comment "question" that doesn't expect answer, instead will immediately send following question */
export type CommentQuestionDefinition = QuestionDefinition & {
  __typename?: 'CommentQuestionDefinition';
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rule what question will be sent next. Always should be single value. */
  rules: Array<AlwaysMatchingRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};

/** Respondent contact */
export type Contact = {
  __typename?: 'Contact';
  /** Parsed phone number */
  phoneNumber?: Maybe<PhoneNumber>;
  /** Contact Source */
  source?: Maybe<ContactSource>;
  /** Type of contact */
  type: ContactType;
  /** Contact information */
  value: Scalars['String']['output'];
};

/** Respondent contact */
export type ContactInput = {
  /** Type of contact */
  contactType: ContactType;
  /** Contact Source */
  source: ContactSource;
  /** Contact information */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Type of contact source */
export enum ContactSource {
  /** Contact was created via admin or internal */
  Primary = 'PRIMARY',
  /** Contact was created when respondent answered question of type EMAIL or SMS contact */
  Respondent = 'RESPONDENT'
}

/** Type of contact */
export enum ContactType {
  /** Email type */
  Email = 'EMAIL',
  /** SMS type */
  Sms = 'SMS'
}

export type ConversationSubjectInput = {
  id: Scalars['ID']['input'];
  type: ConversationSubjectType;
};

/** Type of allowed conversataion subject for organization */
export enum ConversationSubjectType {
  /** Specific topic */
  Topic = 'TOPIC',
  /** Set of topics */
  TopicGroup = 'TOPIC_GROUP'
}

export type CreateCommentGroupInput = {
  comment?: InputMaybe<CreateCommentInput>;
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  topicId: Scalars['ID']['input'];
};

export type CreateCommentInput = {
  commentGroupId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  /** Allowed survey languages for organization. Code is ISO 639-1 */
  allowedLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  /** Business unit of the organization */
  businessUnit?: InputMaybe<BusinessUnit>;
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Custom organization name */
  customName?: InputMaybe<Scalars['String']['input']>;
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  garantEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of organizations group */
  groupOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** is organization inactive after create */
  inactive?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  /** Licence count */
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  /** custom attribute do DB */
  microlearningAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: InputMaybe<Scalars['Int']['input']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** ID of originator */
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  /** Name of organization purchased product name */
  product?: InputMaybe<Scalars['String']['input']>;
  productHistorySurveyTypes?: InputMaybe<Array<ProductHistorySurveyTypeInput>>;
  /** Organization language code */
  selfRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization name */
  systemName: Scalars['String']['input'];
  testOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trialProduct?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  /** Organization valid period */
  validPeriod: Scalars['Int']['input'];
};

export type CreateProcessStepInput = {
  candidateLanguageCode?: InputMaybe<Scalars['String']['input']>;
  copyTg?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldsCheck?: InputMaybe<Array<CustomFieldsCheckInput>>;
  endOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  eventDateField?: InputMaybe<Scalars['String']['input']>;
  payloadCheck?: InputMaybe<Array<PayloadCheckInput>>;
  previousEventsCheck?: InputMaybe<Array<PreviousEventsCheckInput>>;
  processTopicGroupId: Scalars['ID']['input'];
  remindersOffsetMins?: InputMaybe<Array<Scalars['Int']['input']>>;
  startOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  stepTopicGroupId: Scalars['ID']['input'];
  triggeredOn?: InputMaybe<Scalars['String']['input']>;
  useEmailFromNote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateProductVersionInput = {
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  product: Scalars['String']['input'];
  productHistorySurveyTypes?: InputMaybe<Array<InputMaybe<ProductHistorySurveyTypeInput>>>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom: Scalars['Date']['input'];
  validPeriod: Scalars['Int']['input'];
};

/** Parameters for createPublicSurvey mutation */
export type CreatePublicSurveyInput = {
  /** Descriptor for anonymity related behaviour. Pass null for defaults */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  /** Language of public survey */
  language: Scalars['String']['input'];
  /** Owner of survey. Will came later from auth probably */
  organizationId: Scalars['ID']['input'];
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  /** Topic to start */
  topicId: Scalars['ID']['input'];
};

export type CreateSalesOrganizationInput = {
  adminEmail: Scalars['String']['input'];
  adminName: Scalars['String']['input'];
  adminSurname: Scalars['String']['input'];
  ignoreOrgAdminAlreadyExists?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  respondentsCount: Scalars['Int']['input'];
  vatNumber: Scalars['String']['input'];
};

export type CreateSurveyGroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  topicGroupId: Scalars['ID']['input'];
};

/** Parameters for createSurvey mutation */
export type CreateSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** Descriptor for anonymity related behaviour. Pass null for defaults */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  /** Conversation subject to start */
  conversationSubjectId: Scalars['ID']['input'];
  /** Conversation subject type */
  conversationSubjectType: ConversationSubjectType;
  /** Custom topic ID */
  customTopicId?: InputMaybe<Scalars['ID']['input']>;
  /** When survey ends. Must be later than sendAt */
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  forceActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language of survey. Topic must have translation for this language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Recipients for empty organization to be de-deleted or created */
  newRecipientEmails?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Owner of survey. Will came later from auth probably */
  organizationId: Scalars['ID']['input'];
  /** Only allowed channels for these recipients */
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Teams that will answer in this survey.
   * If null, whole organization will answer
   */
  recipients?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reminders to be sent at specified time. */
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  /** ID of report definition */
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When survey sends out invitation emails and becomes ONGOING */
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference date for the survey group respondents */
  seqDate?: InputMaybe<Scalars['Date']['input']>;
  /** Id of survey group for the survey */
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeTemplateUid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInput = {
  changedPassword?: InputMaybe<Scalars['Boolean']['input']>;
  confirmedEmail?: InputMaybe<Scalars['Boolean']['input']>;
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  systemRole?: InputMaybe<UserSysRole>;
  username: Scalars['String']['input'];
};

export type CreditHistory = {
  __typename?: 'CreditHistory';
  createdAt: Scalars['Date']['output'];
  creditsUsed: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  organization: Organization;
  type: Scalars['String']['output'];
  user?: Maybe<User>;
};

export enum CreditHistoryType {
  Exit = 'EXIT',
  Hiring = 'HIRING',
  ManualDeduction = 'MANUAL_DEDUCTION',
  Onboarding = 'ONBOARDING',
  OneTime = 'ONE_TIME',
  Process = 'PROCESS',
  PublicSurvey = 'PUBLIC_SURVEY',
  Pulser = 'PULSER'
}

export type CreditsToReturn = {
  __typename?: 'CreditsToReturn';
  creditsToReturn?: Maybe<Scalars['Int']['output']>;
  respondentId: Scalars['ID']['output'];
};

export type CronJob = {
  __typename?: 'CronJob';
  createdAt?: Maybe<Scalars['Date']['output']>;
  entityId?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  jobKey: Scalars['String']['output'];
  runAt?: Maybe<Scalars['Date']['output']>;
  taskIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
  workerTask?: Maybe<Job>;
};

export type CronJobInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  payload?: InputMaybe<Scalars['String']['input']>;
  runAt?: InputMaybe<Scalars['Date']['input']>;
  taskIdentifier: Scalars['String']['input'];
};

export enum Currency {
  Czk = 'CZK',
  Eur = 'EUR'
}

export type CustomFieldsCheck = {
  __typename?: 'CustomFieldsCheck';
  key: Scalars['String']['output'];
  values: Array<Scalars['String']['output']>;
};

export type CustomFieldsCheckInput = {
  key: Scalars['String']['input'];
  values: Array<Scalars['String']['input']>;
};

export type DateRangeInput = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};

export type DatesForNewSurvey = {
  __typename?: 'DatesForNewSurvey';
  /** When survey will end. When it ends it will finish all channels */
  endsAt?: Maybe<Scalars['Date']['output']>;
  /** Time when reminder will be send */
  reminderAt?: Maybe<Scalars['Date']['output']>;
  /** Time when second reminder will be send */
  secondReminderAt?: Maybe<Scalars['Date']['output']>;
  /** Time when this survey is scheduled to be send */
  sendAt: Scalars['Date']['output'];
};

export type DeleteMessagesResult = {
  __typename?: 'DeleteMessagesResult';
  deletedMessages: Array<Message>;
  remainingQuestions: Scalars['Int']['output'];
};

export type EmailContactQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'EmailContactQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Email */
  email: Scalars['String']['output'];
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type EmailContactQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Message that ends the channel, after this message channel is closed and sending messages to it will fail */
export type EndingMessage = Message & {
  __typename?: 'EndingMessage';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type EndingQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'EndingQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<AlwaysMatchingRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type EndingQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type ErrorReportInput = {
  browserData: Scalars['String']['input'];
  /** Error report from browser to slack */
  componentStack: Scalars['String']['input'];
  email: Scalars['String']['input'];
  error: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  systemRole?: InputMaybe<UserSysRole>;
  url: Scalars['String']['input'];
};

export type FeEventPayload = {
  detail?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  orgRole?: InputMaybe<UserOrgRole>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
  reportAccess?: InputMaybe<Scalars['String']['input']>;
  reportAccessId?: InputMaybe<Scalars['ID']['input']>;
  respondentId?: InputMaybe<Scalars['ID']['input']>;
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export enum FeEventType {
  AdminReopenSurvey = 'ADMIN_REOPEN_SURVEY',
  AdminSendReminder = 'ADMIN_SEND_REMINDER',
  AnalyzeKeyWords = 'ANALYZE_KEY_WORDS',
  BulkAddRespondentsInSurvey = 'BULK_ADD_RESPONDENTS_IN_SURVEY',
  DownloadChart = 'DOWNLOAD_CHART',
  DownloadRespondentDetail = 'DOWNLOAD_RESPONDENT_DETAIL',
  DownloadRespondentPartialDetail = 'DOWNLOAD_RESPONDENT_PARTIAL_DETAIL',
  HideKeyWords = 'HIDE_KEY_WORDS',
  OneplaceLoaded = 'ONEPLACE_LOADED',
  ReportAiKeywordsFilter = 'REPORT_AI_KEYWORDS_FILTER',
  ReportAiSurveySummaryOpened = 'REPORT_AI_SURVEY_SUMMARY_OPENED',
  ReportExport = 'REPORT_EXPORT',
  ReportReopenSurvey = 'REPORT_REOPEN_SURVEY',
  ReportSendReminder = 'REPORT_SEND_REMINDER',
  ShowKeyWords = 'SHOW_KEY_WORDS',
  SurveyGroupChangeDate = 'SURVEY_GROUP_CHANGE_DATE',
  TeamioOnboardingCandidateClicked = 'TEAMIO_ONBOARDING_CANDIDATE_CLICKED',
  TeamioOnboardingPageLoaded = 'TEAMIO_ONBOARDING_PAGE_LOADED',
  TeamioOnboardingParticipantReportOpened = 'TEAMIO_ONBOARDING_PARTICIPANT_REPORT_OPENED',
  TeamioOnboardingRespondentCreated = 'TEAMIO_ONBOARDING_RESPONDENT_CREATED',
  TeamioOnboardingRespondentRemoved = 'TEAMIO_ONBOARDING_RESPONDENT_REMOVED',
  TeamioOnboardingSummaryReportOpened = 'TEAMIO_ONBOARDING_SUMMARY_REPORT_OPENED',
  TeamioOpenForm = 'TEAMIO_OPEN_FORM',
  TeamioOpenFormFail = 'TEAMIO_OPEN_FORM_FAIL',
  TeamioOpenFormSuccess = 'TEAMIO_OPEN_FORM_SUCCESS',
  TopLevelReportOpen = 'TOP_LEVEL_REPORT_OPEN'
}

export enum Features {
  /** generate keywords using ChatGPT */
  AiKeywords = 'aiKeywords',
  /** enable ai summary of respondent in process reports */
  AiSummaryOfRespondent = 'ai_summary_of_respondent',
  /** generate summary for survey and phase report */
  AiSummaryOfSurveyAndPhase = 'ai_summary_of_survey_and_phase',
  /** ai summary - A/B testing */
  AiSummaryOfSurveyAndPhaseAbTest = 'ai_summary_of_survey_and_phase_ab_test',
  /** enable AI translation in topic editor */
  AiTranslation = 'ai_translation',
  /** allow duplicate contacts for respondents in organization import via API */
  AllowDuplicateImportContacts = 'allow_duplicate_import_contacts',
  /** AI chat assistant in Ariel topic editor */
  ArielAi = 'ariel_ai',
  /** all new reports are automatically approved if they fit some rules */
  AutomaticApprovedProcessReports = 'automatic_approved_process_reports',
  /** all new reports are automatically approved if they fit some rules */
  AutomaticApprovedStandaloneReports = 'automatic_approved_standalone_reports',
  /** enables creating and editing of topics */
  CreateAndEditTopics = 'create_and_edit_topics',
  /** add another sheet to excel report with data that can be used to easily uncover anonymized respondents */
  DangerouslyRemoveAnonymityInExcel = 'dangerously_remove_anonymity_in_excel',
  /** disabled employee management - used for companies that are only using API to update employees */
  DisableEmployeeManagement = 'disable_employee_management',
  /** display table with respondent answers in report */
  DisplayTableWithRespondentAnswers = 'display_table_with_respondent_answers',
  /** enable external API tasks */
  EnableExternalApi = 'enable_external_api',
  /** enable SMS as a preferred contact method for hiring */
  HiringPreferredContactSms = 'hiring_preferred_contact_sms',
  KeepPeopleInProcessSurveyDuringImport = 'keep_people_in_process_survey_during_import',
  /** enable 2FA login to admim */
  Login_2fa = 'login_2fa',
  /** enable Pulser module in Admin */
  PulserModule = 'pulser_module',
  ReportReactionToMessage = 'report_reaction_to_message',
  ReportReactionToWholeConversation = 'report_reaction_to_whole_conversation',
  /** remove respondents from process survey in report */
  ReportRemoveRespondentFromProcessSurvey = 'report_remove_respondent_from_process_survey',
  /** require login in reports */
  RequireLoginInReports = 'require_login_in_reports',
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  SendEmailSms = 'send_email_sms',
  /** send an email to help increase response rate */
  SendEmailToIncreaseResponseRate = 'send_email_to_increase_response_rate',
  SendInfoOnboardingEmail = 'send_info_onboarding_email',
  /** send invitation to respondents from report */
  SendInvitationFromReport = 'send_invitation_from_report',
  /** show Notification settings in Admin */
  ShowNotificationSettings = 'show_notification_settings',
  /** control if the respondents will see link to the Oneplace after finishing the conversation */
  ShowOneplaceLinkFromChat = 'show_oneplace_link_from_chat',
  /** combined with sso_forced: users whose email domain is not in allowedEmailDomains are completely blocked from logging in, even via other organizations that would otherwise permit password login (SysAdmins excluded) */
  SsoExclusive = 'sso_exclusive',
  /** users of the organization can ONLY log in via SSO; password and magic-link login are hidden (SysAdmins excluded) */
  SsoForced = 'sso_forced',
  /** show 'Log in with SSO' as an additional login option for users of the organization */
  SsoLogin = 'sso_login',
  /** log events from Teamio for candidates */
  TeamioEventLogging = 'teamio_event_logging',
  /** flags company as teamio Onboarding */
  TeamioOnboardingV2 = 'teamio_onboarding_v2',
  /** organization is migrated to Teamio - used by Teamio user sync, NOT by login (see sso_login / sso_forced) */
  TeamioSso = 'teamio_sso'
}

/** File type for graphql-upload */
export type File = {
  __typename?: 'File';
  /** Unique ID of file - name */
  id?: Maybe<Scalars['String']['output']>;
  /** File name */
  name?: Maybe<Scalars['String']['output']>;
  /** URL of the file */
  url?: Maybe<Scalars['String']['output']>;
};

export type Filter = {
  name: Scalars['String']['input'];
};

/** Answer to plain text question */
export type FreeTextAnswer = Message & {
  __typename?: 'FreeTextAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Value of answer, for this Answer type, it's equal to text field */
  value: Scalars['String']['output'];
};

/** The connection type for FreeTextAnswer. */
export type FreeTextAnswersConnection = AnswersConnection & {
  __typename?: 'FreeTextAnswersConnection';
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<FreeTextAnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type FreeTextAnswersEdge = AnswersEdge & {
  __typename?: 'FreeTextAnswersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The plain text answer at the end of the edge. */
  node: FreeTextAnswer;
};

/** Free form field question */
export type FreeTextQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'FreeTextQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: FreeTextAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<TextRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Free form field question */
export type FreeTextQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Template group attribute */
export enum GroupTemplateType {
  Uid = 'uid',
  UidAndType = 'uidAndType'
}

export type GroupTemplateValue = {
  __typename?: 'GroupTemplateValue';
  items: Array<MessageTemplate>;
  value?: Maybe<Scalars['String']['output']>;
};

export type GroupedRespondents = {
  __typename?: 'GroupedRespondents';
  addedOn: Scalars['Date']['output'];
  creditsToReturn?: Maybe<Array<CreditsToReturn>>;
  deletedRespondents?: Maybe<Array<Scalars['ID']['output']>>;
  hasUnreadMessages?: Maybe<Array<HasUnreadMessages>>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  hiringSurveys?: Maybe<Array<Survey>>;
  metricQuestionsForRespondent: Array<MetricQuestionForRespondent>;
  respondents: Array<Respondent>;
  surveys: Array<Survey>;
  undeliveredInvitations?: Maybe<Array<Maybe<UndeliveredInvitations>>>;
};

export type HasUnreadMessages = {
  __typename?: 'HasUnreadMessages';
  respondentId: Scalars['ID']['output'];
  unreadMessages?: Maybe<Array<Scalars['ID']['output']>>;
};

export type HiringAdditionalData = {
  __typename?: 'HiringAdditionalData';
  isHired?: Maybe<Scalars['Boolean']['output']>;
  isRejected?: Maybe<Scalars['Boolean']['output']>;
  position?: Maybe<Scalars['String']['output']>;
  recruiterName?: Maybe<Scalars['String']['output']>;
  respondentId: Scalars['ID']['output'];
  surveyId?: Maybe<Scalars['ID']['output']>;
};

export type HiringInfo = {
  __typename?: 'HiringInfo';
  managers: Array<HiringInfoItem>;
  positions: Array<HiringInfoItem>;
  recruiters: Array<HiringInfoItem>;
};

export type HiringInfoItem = {
  __typename?: 'HiringInfoItem';
  candidateIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

export type ICreateTestSurveyInput = {
  language: Scalars['String']['input'];
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};

export type ImportReportTranslationResult = {
  __typename?: 'ImportReportTranslationResult';
  inserted?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type ImportRespondentInput = {
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  managerOfTeam: Array<Scalars['String']['input']>;
  otherEmail?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredContactType?: InputMaybe<ContactType>;
  surname: Scalars['String']['input'];
  surveyGroups?: InputMaybe<Array<NewRespondentSurveyGroupInput>>;
  surveyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  team?: InputMaybe<Scalars['String']['input']>;
};

export type IndustryCategory = {
  __typename?: 'IndustryCategory';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  value: Scalars['String']['output'];
};

export type Job = {
  __typename?: 'Job';
  attempts: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  lastError?: Maybe<Scalars['String']['output']>;
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  maxAttempts: Scalars['Int']['output'];
  payload?: Maybe<Scalars['String']['output']>;
  queueName?: Maybe<Scalars['String']['output']>;
  runAt?: Maybe<Scalars['Date']['output']>;
  taskIdentifier: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Date']['output']>;
};

export type JobQueue = {
  __typename?: 'JobQueue';
  lockedAt?: Maybe<Scalars['Date']['output']>;
  lockedBy?: Maybe<Scalars['String']['output']>;
  queueName: Scalars['ID']['output'];
};

export type KeyPoint = {
  __typename?: 'KeyPoint';
  answerIds: Array<Scalars['ID']['output']>;
  point: Scalars['String']['output'];
  sentiment: Sentiment;
};

export type Language = {
  __typename?: 'Language';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type LanguageFilterInput = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Array<Scalars['ID']['input']>>;
  product?: InputMaybe<Scalars['String']['input']>;
};

export type LinkToReport = {
  __typename?: 'LinkToReport';
  isOwned: Scalars['Boolean']['output'];
  link: Scalars['String']['output'];
  reportId: Scalars['ID']['output'];
  surveyGroupId: Scalars['ID']['output'];
};

export type MarketingChannel = {
  __typename?: 'MarketingChannel';
  code: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Message that was sent to channel */
export type Message = {
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  /** Internal */
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type MessageData = {
  __typename?: 'MessageData';
  data: Array<MessageQueue>;
  totalCount: Scalars['Int']['output'];
};

export enum MessageEventType {
  Blocked = 'BLOCKED',
  BottomPixel = 'BOTTOM_PIXEL',
  Bounced = 'BOUNCED',
  Click = 'CLICK',
  Delayed = 'DELAYED',
  Delivered = 'DELIVERED',
  Error = 'ERROR',
  Injected = 'INJECTED',
  Spam = 'SPAM',
  TopPixel = 'TOP_PIXEL',
  Unsubscribed = 'UNSUBSCRIBED'
}

export type MessageFilterInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  sentAtFrom?: InputMaybe<Scalars['Date']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
  undelivered?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageQueue = {
  __typename?: 'MessageQueue';
  body?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  htmlBody?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  messageStatus?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  processed?: Maybe<Scalars['Boolean']['output']>;
  recipient?: Maybe<Respondent>;
  sentAt?: Maybe<Scalars['Date']['output']>;
  serviceProvider?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MessageStatus = {
  __typename?: 'MessageStatus';
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageStatus?: Maybe<Scalars['String']['output']>;
  processed: Scalars['Boolean']['output'];
  respondentId: Scalars['ID']['output'];
  surveyId: Scalars['ID']['output'];
};

/** Message template that is send to respondent */
export type MessageTemplate = {
  __typename?: 'MessageTemplate';
  /** Business unit this template belongs to (Central or South) */
  businessUnit: BusinessUnit;
  /** CTA Text for HTML emails */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** CTA URL for HTML emails */
  ctaUrl?: Maybe<Scalars['String']['output']>;
  /** Main body for HTML emails */
  description?: Maybe<Scalars['String']['output']>;
  /** Headline for HTML emails */
  headline?: Maybe<Scalars['String']['output']>;
  /** ID of message template */
  id: Scalars['ID']['output'];
  /** Language code of messageTemplate */
  languageCode: Scalars['String']['output'];
  /** Preheader for HTML emails */
  preheader?: Maybe<Scalars['String']['output']>;
  /** Message subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** Message text */
  text: Scalars['String']['output'];
  /** Message type EMAIL or SMS */
  type: ContactType;
  /** String ID of message template */
  uid: Scalars['String']['output'];
};

/**  Input of Message template that is send to respondent */
export type MessageTemplateInput = {
  /** Business unit this template belongs to (Central or South) */
  businessUnit: BusinessUnit;
  /** CTA Text for HTML emails */
  ctaText?: InputMaybe<Scalars['String']['input']>;
  /** CTA URL for HTML emails */
  ctaUrl?: InputMaybe<Scalars['String']['input']>;
  /** Main body for HTML emails */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Headline for HTML emails */
  headline?: InputMaybe<Scalars['String']['input']>;
  /** Language code of messageTemplate */
  language: Scalars['String']['input'];
  /** Preheader for HTML emails */
  preheader?: InputMaybe<Scalars['String']['input']>;
  /** Message subject */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** Message text */
  text: Scalars['String']['input'];
  /** Message type EMAIL or SMS */
  type?: InputMaybe<ContactType>;
  /** String ID of message template */
  uid: Scalars['String']['input'];
};

/** Rendered preview of a message template (placeholders left as-is) */
export type MessageTemplatePreview = {
  __typename?: 'MessageTemplatePreview';
  /** Plain-text body / SMS text */
  body?: Maybe<Scalars['String']['output']>;
  /** Rendered HTML email body (null for SMS or templates without HTML fields) */
  htmlBody?: Maybe<Scalars['String']['output']>;
  /** Rendered subject line */
  subject?: Maybe<Scalars['String']['output']>;
};

export enum MessageTemplateUid {
  Ending = 'ENDING',
  Reaction = 'REACTION',
  Reminder_1St = 'REMINDER_1ST',
  Reminder_2Nd = 'REMINDER_2ND',
  Reminder_3Rd = 'REMINDER_3RD',
  ReminderFromManager = 'REMINDER_FROM_MANAGER',
  Reopen = 'REOPEN',
  Welcome = 'WELCOME',
  WelcomeAnonymityMode = 'WELCOME_ANONYMITY_MODE'
}

export type MetricAnswer = {
  __typename?: 'MetricAnswer';
  topicGroupId: Scalars['ID']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type MetricQuestionForRespondent = {
  __typename?: 'MetricQuestionForRespondent';
  answers: Array<MetricAnswer>;
  respondentId: Scalars['ID']['output'];
};

export enum Metrics {
  ChatSatisfaction = 'chat_satisfaction',
  LockedQuestion = 'locked_question',
  OnboardingFeeling = 'onboarding_feeling'
}

/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type Mutation = {
  __typename?: 'Mutation';
  /** Approve reports for sent to managers */
  acceptReports: Scalars['Boolean']['output'];
  /** Adds respondents as survey group respondent from defined date or from now */
  addRespondentsToSurveyGroup: Scalars['Boolean']['output'];
  /** create displayFilters for select questions in widgets */
  addWidgetDisplayFilters?: Maybe<Scalars['Boolean']['output']>;
  /** AI batch translation of topic nodes using Azure OpenAI */
  aiTranslateTopicNodes: AiTranslateTopicNodesResult;
  /** approve report definition */
  approveReportDefinition: Scalars['Boolean']['output'];
  /** Approve a survey report for client visibility and emails (Internal only) */
  approveSurveyReport: Survey;
  /** assign allowed organization to signeed user */
  assignOrganization: Scalars['Boolean']['output'];
  /** Change password for user */
  changePassword: BaseUser;
  clearAiSurveySummaryCache: AiSurveySummaryCacheClearResult;
  cloneProcessStep: ProcessStep;
  cloneProcessTopicGroup?: Maybe<TopicGroup>;
  cloneTopicWithTopicGroup?: Maybe<Topic>;
  confirmEmail: Scalars['String']['output'];
  /** Creates, and opens channel on public survey */
  createChannel?: Maybe<ChannelWithStartingMessages>;
  createComment: CommentGroup;
  createCommentGroup: CommentGroup;
  /** Creates SectionStartingQuestions for topics without sections */
  createMissingTopicStructures?: Maybe<Scalars['Boolean']['output']>;
  /** Creates channel for new respondents not involved in ongoing survey */
  createNewRespondentChannels?: Maybe<Array<Maybe<Channel>>>;
  /** Create organization */
  createOrganization: Organization;
  createOrganizationSecret: OrganizationSecret;
  createProcessStep: ProcessStep;
  /** Create product version */
  createProductVersion: ProductVersion;
  /** Creates public survey */
  createPublicSurvey: Survey;
  createQuestionMetric: Scalars['Boolean']['output'];
  createQuestionTrigger: QuestionTrigger;
  createRespondent: Respondent;
  /** Create organization from sales form */
  createSalesOrganization: Organization;
  /** Creates survey */
  createSurvey: Survey;
  /** Creates survey group */
  createSurveyGroup: SurveyGroup;
  /** Create the metrics snapshot of a released survey that finished before snapshots existed (Internal only) */
  createSurveyMetricsSnapshot: SurveyMetricsSnapshot;
  /** Create and plans surveys for steps not planned for survey group */
  createSurveysForNewSteps: Scalars['Boolean']['output'];
  createSurveysForRespondents: Scalars['Boolean']['output'];
  /** Creates team */
  createTeam: Team;
  createTestOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** Creates public survey */
  createTestSurvey: Scalars['String']['output'];
  createTopicGroup: TopicGroup;
  /** Create a new topic group with topic containing simple example */
  createTopicGroupFromDefault?: Maybe<TopicGroup>;
  /** Create user */
  createUser: User;
  /**
   * Delete messages from channel, starting from "fromMessageId".
   * Which must be message from respondent
   * Returns deleted messages.
   */
  deleteChannelMessages: DeleteMessagesResult;
  deleteCommentGroup: Scalars['Boolean']['output'];
  /** Delete organization logo (removes DB record, file stays in S3) */
  deleteOrganizationLogo: Scalars['Boolean']['output'];
  deleteOrganizationSecret: Scalars['Boolean']['output'];
  /** Delete the OIDC SSO configuration of an organization (SysAdmin only) */
  deleteOrganizationSsoConfig: Scalars['Boolean']['output'];
  deleteOrganizationSurvey: Scalars['Int']['output'];
  /** delete organization and anonymize all of it respondents */
  deleteOrganizationWithAnonymization: Organization;
  deleteProcessStep: Scalars['Boolean']['output'];
  /** delete product version */
  deleteProductVersion: Scalars['Int']['output'];
  deleteQuestionMetric: Scalars['Boolean']['output'];
  deleteQuestionTrigger?: Maybe<QuestionTrigger>;
  deleteRespondent: Scalars['Boolean']['output'];
  /** delete respondent and anonymize it */
  deleteRespondentWithAnonymization: Scalars['Boolean']['output'];
  /** Delete a survey attachment (removes DB record and the S3 object) */
  deleteSurveyAttachment: Scalars['Boolean']['output'];
  deleteSurveyGroup: Scalars['Boolean']['output'];
  deleteTeam: Scalars['Boolean']['output'];
  deleteTopic: Scalars['Boolean']['output'];
  deleteTopicGroup: Scalars['Boolean']['output'];
  deleteUser: Scalars['Boolean']['output'];
  disableFeature: Scalars['Boolean']['output'];
  enableFeature: Scalars['Boolean']['output'];
  generateAccessTokenForTeamio: Scalars['String']['output'];
  generateOtp: Scalars['Boolean']['output'];
  /** generate simple report definition from all questions in a topic and their translations */
  generateReportDefinition: Scalars['ID']['output'];
  /** grant access to all report recipients */
  grantReportAccessToRecipients: Scalars['Boolean']['output'];
  grantReportAccessesForSurveyGroup: Scalars['Boolean']['output'];
  importAnswers: Scalars['Boolean']['output'];
  importOrganization: Scalars['Boolean']['output'];
  importQuestions: Scalars['Boolean']['output'];
  importReportDefinition: PubReportDefinition;
  importReportTranslation: ImportReportTranslationResult;
  importTopic: Topic;
  importTranslation: Scalars['Boolean']['output'];
  /** Join two survey groups to one - target survey group */
  joinSurveyGroups: Scalars['Boolean']['output'];
  logAiSurveySummaryAbInteraction: Scalars['Boolean']['output'];
  /** Error report from browser to slack */
  logErrorReport: Scalars['Boolean']['output'];
  /** Log FE Event to EventLog */
  logFEEvent: Scalars['Boolean']['output'];
  /** Mark a translation as reviewed (sets translationStatus to null) */
  markTranslationAsReviewed: Scalars['Boolean']['output'];
  /** Opens channel. Should be called on each time respondent opens it in browser */
  openChannel?: Maybe<ChannelWithStartingMessages>;
  /** Registration - creates new user and new organization */
  registration?: Maybe<User>;
  /** delete planned cron jobs and initialize them again */
  reinitializeCronJobs: Scalars['Boolean']['output'];
  removeRespondentFromSurveyGroup: Scalars['Boolean']['output'];
  removeRespondentFromSurveyGroupWithDate: Scalars['Boolean']['output'];
  renameSurveyGroup: SurveyGroup;
  reopenSurvey: Survey;
  /** Reset password for user */
  resetPassword: Scalars['Boolean']['output'];
  saveReportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  /** Connects a new report definition to the survey's topic. primary makes that connection the topic default */
  saveReportDefinitionNewForTopic: ReportDefinitionNewVersion;
  sendEmailConfirmation: Scalars['Boolean']['output'];
  sendInvitationAgain: Scalars['Boolean']['output'];
  /** Send magic link to email */
  sendMagicLink: Scalars['Boolean']['output'];
  sendNewReports: Scalars['Boolean']['output'];
  sendPreviewConversation: Scalars['Boolean']['output'];
  sendPreviewReport: Scalars['Boolean']['output'];
  /** Send a reaction to a channel or specific message inside a report context */
  sendReaction: Reaction;
  sendReportOpenMetrics: Scalars['Boolean']['output'];
  /** For scale question answers - one choice per statement with optional comment */
  sendScaleAnswer: Array<ScaleAnswer>;
  /**
   * For select,range,anonymity answers
   * value is index of one choice
   */
  sendSelectAnswer: SelectAnswer;
  /** Resend channel invitation or reminder to respondent */
  sendSurveyInvitation: MessageQueue;
  /** For Plain answers */
  sendTextAnswer: FreeTextAnswer;
  setCategoryCode: CategoryCode;
  /** Sets given channel anonymity to given level */
  setChannelAnonymity: Channel;
  setConsent: Scalars['Boolean']['output'];
  setFeatureAsDefault: Scalars['Boolean']['output'];
  setLanguageForRespondent?: Maybe<Respondent>;
  setManualDeduction: Scalars['Boolean']['output'];
  /** Creates message template with specified ID */
  setMessageTemplate: MessageTemplate;
  setPrimaryReportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  /** Makes a saved version the primary report definition for the survey's topic. The version must already belong to the survey or the topic */
  setPrimaryReportDefinitionNewForTopic: ReportDefinitionNewVersion;
  /** Replaces the product / business unit availability of a public topic group (SysAdmin only) */
  setProductTopicGroups: TopicGroup;
  setRespondentNewAnswersNotifications: Scalars['Boolean']['output'];
  /** Set Survey status to archived */
  setSurveyArchived: Scalars['Boolean']['output'];
  /** Archive or dearchive all surveys connected to survey group */
  setSurveyGroupArchived: Scalars['Boolean']['output'];
  /** Include or exclude a survey's metrics snapshot from leaderboard and benchmark inputs (Internal only) */
  setSurveyMetricsSnapshotPublic: SurveyMetricsSnapshot;
  setTopicGroupDefaults: TopicGroup;
  setUserSummaryNotifications: Scalars['Boolean']['output'];
  /** Test-run an AI use case with optional unsaved draft overrides — provider/config errors land in the result, never thrown (SysAdmin only) */
  testAiGenerationConfig: AiGenerationTestResult;
  unlockGraphileJob: Scalars['Boolean']['output'];
  unlockGraphileJobQueue: Scalars['Boolean']['output'];
  unlockUser: Scalars['Boolean']['output'];
  unsetFeatureAsDefault: Scalars['Boolean']['output'];
  /** Update an AI use-case config's editable fields (SysAdmin only) */
  updateAiGenerationConfig: AiGenerationConfig;
  /** update anonymity of respondents, returning number of newly revealed respondents */
  updateAnonymity: Scalars['Int']['output'];
  updateComment: CommentGroup;
  updateCommentGroupPosition: CommentGroup;
  /** Update organization */
  updateOrganization: Organization;
  /** Updates Organization details */
  updateOrganizationConfig: OrganizationConfig;
  updateProcessStep: ProcessStep;
  /** Update product version */
  updateProductVersion: ProductVersion;
  updateReportAccessMetrics?: Maybe<Scalars['Boolean']['output']>;
  updateRespondent: Respondent;
  updateRespondentFromReport: Respondent;
  updateSurvey: Survey;
  updateTeam: Team;
  updateTopic: Topic;
  /** Update user */
  updateUser: User;
  /** Upload organization logo */
  uploadOrganizationLogo: OrganizationLogo;
  /** Upload one Pulser JSON file and enqueue the import job (SysAdmin only) */
  uploadPulserImport: PulserImport;
  /** Upload a document attachment to a survey */
  uploadSurveyAttachment: SurveyAttachment;
  /** Create or update the OIDC SSO configuration of an organization (SysAdmin only) */
  upsertOrganizationSsoConfig: OrganizationSsoConfig;
  /** Add topic group translation for topic code. Translation will be paired to topic Group via specified code automatically */
  upsertTopicGroupTranslation: TopicGroupTranslation;
  verifyPhoneNumbers: Array<TwilioLookUpResponse>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAcceptReportsArgs = {
  reportAccepts: Array<ReportAccept>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAddRespondentsToSurveyGroupArgs = {
  addedOn: Scalars['Date']['input'];
  respondents: Array<SurveyGroupRespondentImportInput>;
  runOngoingSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAddWidgetDisplayFiltersArgs = {
  questionDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportDefinitionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAiTranslateTopicNodesArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  nodes: Array<AiTranslateNodeInput>;
  sourceLang: Scalars['String']['input'];
  targetLang: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationApproveReportDefinitionArgs = {
  approved: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationApproveSurveyReportArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationAssignOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationChangePasswordArgs = {
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  newPassword: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationClearAiSurveySummaryCacheArgs = {
  accessToken: Scalars['String']['input'];
  hash: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneProcessStepArgs = {
  processStepId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneProcessTopicGroupArgs = {
  shallowClone?: InputMaybe<Scalars['Boolean']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCloneTopicWithTopicGroupArgs = {
  topicId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationConfirmEmailArgs = {
  deviceToken: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateChannelArgs = {
  accessKey: Scalars['String']['input'];
  sourceId?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateCommentArgs = {
  input: CreateCommentInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateCommentGroupArgs = {
  input: CreateCommentGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateNewRespondentChannelsArgs = {
  respondentIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
  orgAdmin?: InputMaybe<RespondentInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateOrganizationSecretArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateProcessStepArgs = {
  input: CreateProcessStepInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateProductVersionArgs = {
  input: CreateProductVersionInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreatePublicSurveyArgs = {
  input: CreatePublicSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateQuestionMetricArgs = {
  identifier: Metrics;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateQuestionTriggerArgs = {
  input: QuestionTriggerInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateRespondentArgs = {
  input: RespondentInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSalesOrganizationArgs = {
  input: CreateSalesOrganizationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyArgs = {
  input: CreateSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyGroupArgs = {
  input: CreateSurveyGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveyMetricsSnapshotArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveysForNewStepsArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateSurveysForRespondentsArgs = {
  addedOn: Scalars['Date']['input'];
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTeamArgs = {
  organizationId: Scalars['ID']['input'];
  respondentId?: InputMaybe<Scalars['ID']['input']>;
  supervisorTeamId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTestOrganizationArgs = {
  name: Scalars['String']['input'];
  numberOfRespondents: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTestSurveyArgs = {
  input: ICreateTestSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTopicGroupArgs = {
  input: CreateTopicGroupInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateTopicGroupFromDefaultArgs = {
  description: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  typeCode?: InputMaybe<TopicGroupTypeCode>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationCreateUserArgs = {
  input: CreateUserInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteChannelMessagesArgs = {
  channelId: Scalars['ID']['input'];
  fromMessageId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteCommentGroupArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationLogoArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSecretArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSsoConfigArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationSurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteOrganizationWithAnonymizationArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteProcessStepArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteProductVersionArgs = {
  productId: Scalars['ID']['input'];
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteQuestionMetricArgs = {
  identifier?: InputMaybe<Metrics>;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteQuestionTriggerArgs = {
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['ID']['input'];
  value: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteRespondentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteRespondentWithAnonymizationArgs = {
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteSurveyAttachmentArgs = {
  attachmentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteSurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTeamArgs = {
  teamId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTopicArgs = {
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteTopicGroupArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDeleteUserArgs = {
  email: Scalars['String']['input'];
  orgId: Scalars['ID']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationDisableFeatureArgs = {
  feature: Features;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationEnableFeatureArgs = {
  feature: Features;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateAccessTokenForTeamioArgs = {
  companyG2Id: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateOtpArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGenerateReportDefinitionArgs = {
  fromScratch?: InputMaybe<Scalars['Boolean']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGrantReportAccessToRecipientsArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationGrantReportAccessesForSurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportAnswersArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportOrganizationArgs = {
  orgId: Scalars['ID']['input'];
  respondents: Array<ImportRespondentInput>;
  teams: Array<TeamInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportQuestionsArgs = {
  file: Scalars['Upload']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportReportDefinitionArgs = {
  file: Scalars['Upload']['input'];
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportReportTranslationArgs = {
  file: Scalars['Upload']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportTopicArgs = {
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderManuallyModified?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderModified?: InputMaybe<Scalars['Boolean']['input']>;
  questions: Array<QuestionDefinitionInput>;
  topic: TopicInput;
  translateViaAi?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationImportTranslationArgs = {
  file?: InputMaybe<Scalars['Upload']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationJoinSurveyGroupsArgs = {
  sourceSurveyGroupId: Scalars['ID']['input'];
  targetSurveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogAiSurveySummaryAbInteractionArgs = {
  input: AiSurveySummaryAbInteractionInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogErrorReportArgs = {
  errorReport: ErrorReportInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationLogFeEventArgs = {
  eventType: FeEventType;
  payload: FeEventPayload;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationMarkTranslationAsReviewedArgs = {
  languageCode: Scalars['String']['input'];
  questionDefinitionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationOpenChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRegistrationArgs = {
  organizationInput: RegistrationOrganizationInput;
  password: Scalars['String']['input'];
  userInput: UserInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRemoveRespondentFromSurveyGroupArgs = {
  addedOn: Scalars['Date']['input'];
  respondentId: Scalars['ID']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRemoveRespondentFromSurveyGroupWithDateArgs = {
  accessToken: Scalars['String']['input'];
  dateFrom: Scalars['Date']['input'];
  respondentId: Scalars['ID']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationRenameSurveyGroupArgs = {
  name: Scalars['String']['input'];
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationReopenSurveyArgs = {
  input: ReopenSurveyInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationResetPasswordArgs = {
  origin: Origin;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSaveReportDefinitionNewForSurveyArgs = {
  definition: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSaveReportDefinitionNewForTopicArgs = {
  definition: Scalars['JSON']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  primary?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendEmailConfirmationArgs = {
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendInvitationAgainArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentId: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
  templateUid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendMagicLinkArgs = {
  redirect?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendNewReportsArgs = {
  respondentId: Scalars['ID']['input'];
  surveyIds: Array<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendPreviewConversationArgs = {
  contactType: ContactType;
  contactValue: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendPreviewReportArgs = {
  email: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendReactionArgs = {
  accessToken: Scalars['String']['input'];
  channelId: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendReportOpenMetricsArgs = {
  channelIds: Array<Scalars['ID']['input']>;
  orgAdmin: Scalars['Boolean']['input'];
  reportAccessKey: Scalars['String']['input'];
  reportView: ReportOpenMetricsView;
  sysAdmin: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendScaleAnswerArgs = {
  answers: Array<ScaleStatementAnswerInput>;
  channelId: Scalars['ID']['input'];
  previousQuestionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendSelectAnswerArgs = {
  channelId: Scalars['ID']['input'];
  message: Scalars['String']['input'];
  previousQuestionId: Scalars['ID']['input'];
  values: Array<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendSurveyInvitationArgs = {
  messageType?: InputMaybe<MessageTemplateUid>;
  respondentEmail: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSendTextAnswerArgs = {
  channelId: Scalars['ID']['input'];
  previousQuestionId: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetCategoryCodeArgs = {
  categoryCode: Scalars['String']['input'];
  language: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetChannelAnonymityArgs = {
  channelId: Scalars['ID']['input'];
  level: AnonymityLevel;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetConsentArgs = {
  consent: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetFeatureAsDefaultArgs = {
  feature: Features;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetLanguageForRespondentArgs = {
  channelId: Scalars['ID']['input'];
  language: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetManualDeductionArgs = {
  creditsUsed: Scalars['Float']['input'];
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetMessageTemplateArgs = {
  messageTemplate?: InputMaybe<MessageTemplateInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetPrimaryReportDefinitionNewForSurveyArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetPrimaryReportDefinitionNewForTopicArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetProductTopicGroupsArgs = {
  items: Array<ProductTopicGroupInput>;
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetRespondentNewAnswersNotificationsArgs = {
  auth?: InputMaybe<OnePlaceAuthInput>;
  notificationLevel: NotificationLevel;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyArchivedArgs = {
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyGroupArchivedArgs = {
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetSurveyMetricsSnapshotPublicArgs = {
  public: Scalars['Boolean']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetTopicGroupDefaultsArgs = {
  input: SetTopicGroupDefaultsInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationSetUserSummaryNotificationsArgs = {
  auth?: InputMaybe<OnePlaceAuthInput>;
  on: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationTestAiGenerationConfigArgs = {
  input: AiGenerationConfigTestInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockGraphileJobArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockGraphileJobQueueArgs = {
  queueName: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnlockUserArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUnsetFeatureAsDefaultArgs = {
  feature: Features;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateAiGenerationConfigArgs = {
  input: AiGenerationConfigInput;
  useCase: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateAnonymityArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateCommentArgs = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateCommentGroupPositionArgs = {
  id: Scalars['ID']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateOrganizationConfigArgs = {
  input: UpdateOrganizationConfigInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateProcessStepArgs = {
  id: Scalars['ID']['input'];
  input: UpdateProcessStepInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateProductVersionArgs = {
  input: UpdateProductVersionInput;
  productId: Scalars['ID']['input'];
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateReportAccessMetricsArgs = {
  bottomSeen?: InputMaybe<Scalars['Boolean']['input']>;
  questionsSeen?: InputMaybe<Scalars['Int']['input']>;
  questionsTotal?: InputMaybe<Scalars['Int']['input']>;
  reportAccessKey: Scalars['String']['input'];
  timeSpentInSec?: InputMaybe<Scalars['Int']['input']>;
  topSeen?: InputMaybe<Scalars['Boolean']['input']>;
  topicGroupId?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateRespondentArgs = {
  input: UpdateRespondentInput;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateRespondentFromReportArgs = {
  accessToken: Scalars['String']['input'];
  input: UpdateRespondentFromReportInput;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateSurveyArgs = {
  input: UpdateSurveyInput;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateTeamArgs = {
  input: UpdateTeamInput;
  teamId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateTopicArgs = {
  input: UpdateTopicInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpdateUserArgs = {
  input: UpdateUserInput;
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadOrganizationLogoArgs = {
  file: Scalars['Upload']['input'];
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadPulserImportArgs = {
  file: Scalars['Upload']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUploadSurveyAttachmentArgs = {
  file: Scalars['Upload']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpsertOrganizationSsoConfigArgs = {
  input: OrganizationSsoConfigInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationUpsertTopicGroupTranslationArgs = {
  input: UpsertTopicGroupTranslationInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The mutation type defines GraphQL operations that change data on the server.
 * It is analogous to performing HTTP verbs such as POST, PATCH, and DELETE.
 */
export type MutationVerifyPhoneNumbersArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumbers: Array<Scalars['String']['input']>;
};

export type NewReport = {
  __typename?: 'NewReport';
  anonymityEnabled: Scalars['Boolean']['output'];
  anonymityForced: Scalars['Boolean']['output'];
  /** Survey settings regarding anonymity (chosen for this survey; fallback to topic group defaults) */
  anonymitySettings?: Maybe<AnonymitySettings>;
  id: Scalars['ID']['output'];
  metadata: PubMetadata;
  /** Stored AI themes, loaded on demand and restricted to messages available in this report */
  questionLabels: Array<QuestionLabel>;
  questions: Array<PubQuestion>;
  reportDefinition?: Maybe<NewReportDefinition>;
  reportRoots: Array<Scalars['ID']['output']>;
  respondents: Array<PubRespondent>;
  responses: Array<PubResponse>;
  surveyId: Scalars['ID']['output'];
  surveys: Array<Survey>;
  teams: Array<PubTeams>;
  topicGroup: TopicGroup;
  totalRespondents: Scalars['Int']['output'];
};

export type NewReportDefinition = {
  __typename?: 'NewReportDefinition';
  definition: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
};

export type NewRespondentSurveyGroupInput = {
  /** Added on date */
  addedOn: Scalars['Date']['input'];
  /** Recruiter ID from external system */
  recruiterId?: InputMaybe<Scalars['String']['input']>;
  /** Recruiter name from external system */
  recruiterName?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment ID from external system */
  recruitmentId?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment name from external system */
  recruitmentInternalName?: InputMaybe<Scalars['String']['input']>;
  /** Recruitment name from external system */
  recruitmentName?: InputMaybe<Scalars['String']['input']>;
  runOngoingSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Survey group ID */
  surveyGroupId: Scalars['ID']['input'];
};

export enum NotificationLevel {
  AlertsOnly = 'alerts_only',
  All = 'all',
  Never = 'never'
}

/** Notstarted survey reasons */
export enum NotstartedSurveyReason {
  IsInFuture = 'IS_IN_FUTURE',
  IsInPast = 'IS_IN_PAST',
  LicenceExceeded = 'LICENCE_EXCEEDED',
  NotCompletedTranslations = 'NOT_COMPLETED_TRANSLATIONS',
  NoRespondents = 'NO_RESPONDENTS',
  NoRespondentsInSg = 'NO_RESPONDENTS_IN_SG',
  NoTopic = 'NO_TOPIC',
  OrganizationNotActive = 'ORGANIZATION_NOT_ACTIVE',
  TgNotAllowed = 'TG_NOT_ALLOWED'
}

export type OnePlaceAuthInput = {
  channelSlug?: InputMaybe<Scalars['String']['input']>;
  reportAccessToken?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderByDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Organization that orders surveys */
export type Organization = {
  __typename?: 'Organization';
  /** toggle notifications for channels with alerting answers */
  activeOnboadings: Array<SurveyGroup>;
  activeProcessSurveys: Array<SurveyGroup>;
  /** All active respondents that belong to organization teams */
  activeRespondents: Array<Respondent>;
  /** Number of respondents applied in current 30-days period */
  activeRespondentsInCurrentPeriodCount?: Maybe<Scalars['Int']['output']>;
  /** All respondents that belong to organization teams */
  allRespondents: Array<Respondent>;
  /** Topics that are allowed for organization. Instead of topicGroup id used latest valid */
  allowedTopics: Array<Topic>;
  /** Indicate if before first survey card was checked */
  beforeFirstSurvey: Scalars['Boolean']['output'];
  /** Business unit of the organization */
  businessUnit: BusinessUnit;
  /** Source channel */
  channel?: Maybe<Scalars['String']['output']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: Maybe<Scalars['String']['output']>;
  /** Organization config */
  config?: Maybe<OrganizationConfig>;
  /** Country */
  country?: Maybe<Scalars['String']['output']>;
  /** Time stamp when organization was created */
  createdAt: Scalars['Date']['output'];
  currentSurveys: Array<Survey>;
  /** Number of enabled respondents in organization */
  enabledRespondentsCount: Scalars['Int']['output'];
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: Maybe<Scalars['String']['output']>;
  /** List of features allowed for organization */
  featureNames?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** E-mail contact to organization garant */
  garantEmail?: Maybe<Scalars['String']['output']>;
  /** ID of organizations group */
  groupOrganizationId?: Maybe<Scalars['ID']['output']>;
  /** Org has survey groups that are not onboardings */
  hasProcessSurveys: Scalars['Boolean']['output'];
  /** ID of organization */
  id: Scalars['ID']['output'];
  /** Industry */
  industry?: Maybe<Scalars['String']['output']>;
  /** Languages of organization */
  languages: Array<Language>;
  /** Date of last failed API update */
  lastFailedApiUpdate?: Maybe<Scalars['Date']['output']>;
  /** Date of last successful API update */
  lastSuccessfulApiUpdate?: Maybe<Scalars['Date']['output']>;
  /** e-mail contact to organization garant */
  limitExceededEmailSent?: Maybe<Scalars['Boolean']['output']>;
  /** Organization logo */
  logo?: Maybe<OrganizationLogo>;
  marketingChannel?: Maybe<MarketingChannel>;
  /** Custom field for analytics */
  microlearningAllowed?: Maybe<Scalars['Boolean']['output']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: Maybe<Scalars['Int']['output']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: Maybe<Scalars['Int']['output']>;
  /** Short identification for humans */
  name: Scalars['String']['output'];
  /** Number of employees */
  numberOfEmployees?: Maybe<Scalars['Int']['output']>;
  /** List of all ORG admins in organization */
  organizationAdmins: Array<Respondent>;
  /** Version of organisation */
  organizationVersion: Scalars['Int']['output'];
  /** user who created the organization */
  originator?: Maybe<User>;
  /** Primary language of organization */
  primaryLanguageCode: Scalars['String']['output'];
  /** Primary language id of organization */
  primaryLanguageId: Scalars['Int']['output'];
  processNotificationsDefault: NotificationLevel;
  processNotificationsLocked: Scalars['Boolean']['output'];
  /** Active version of product */
  productVersion?: Maybe<ProductVersion>;
  /** Complete history of product */
  productVersionHistory?: Maybe<Array<ProductVersion>>;
  /** Reminder 1 template */
  reminder1Template?: Maybe<Scalars['String']['output']>;
  /** Reminder 2 template */
  reminder2Template?: Maybe<Scalars['String']['output']>;
  /** Reminder 3 template */
  reminder3Template?: Maybe<Scalars['String']['output']>;
  /** Number of respondents in organization */
  respondentsCount: Scalars['Int']['output'];
  /** Organization status */
  status: OrganizationStatus;
  /** ID of organizations group */
  surveyGroups: Array<SurveyGroup>;
  /** All surveys for organization */
  surveys: Array<Survey>;
  /** Count of surveys created for this organization */
  surveysCount?: Maybe<Scalars['Int']['output']>;
  /** Organization system name */
  systemName: Scalars['String']['output'];
  /** Teams that this organization have */
  teams: Array<Team>;
  testOrganization?: Maybe<Scalars['Boolean']['output']>;
  /** all users connected to Organization */
  users?: Maybe<Array<User>>;
  /** Welcome template */
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

/** Organization configuration */
export type OrganizationConfig = {
  __typename?: 'OrganizationConfig';
  /** Default country calling code */
  countryCallingCode: Scalars['String']['output'];
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Organization that belongs organization config */
  organization: Organization;
  /** Maximum of surveys that can be run in trial */
  testSurveys: Scalars['Int']['output'];
  /** Timezone */
  timezone: Scalars['String']['output'];
};

export type OrganizationFilterInput = {
  businessUnit?: InputMaybe<BusinessUnit>;
  country?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OrganizationStatus>;
};

export type OrganizationLevel = {
  __typename?: 'OrganizationLevel';
  level: Scalars['String']['output'];
  respondents?: Maybe<Array<Maybe<ReportRespondent>>>;
};

/** Organization logo */
export type OrganizationLogo = {
  __typename?: 'OrganizationLogo';
  /** Upload timestamp */
  createdAt: Scalars['Date']['output'];
  /** ID of logo record */
  id: Scalars['ID']['output'];
  /** Original file name */
  originalName: Scalars['String']['output'];
  /** S3 object key */
  s3Key: Scalars['String']['output'];
  /** Public URL via CDN */
  url: Scalars['String']['output'];
};

export type OrganizationSecret = {
  __typename?: 'OrganizationSecret';
  clientId: Scalars['ID']['output'];
  clientSecret: Scalars['String']['output'];
};

/** Per-organization OIDC SSO configuration. The client secret is write-only and never exposed. */
export type OrganizationSsoConfig = {
  __typename?: 'OrganizationSsoConfig';
  /** comma-separated email domains that may use this SSO config, e.g. 'acme.com, acme.eu'. */
  allowedEmailDomains: Scalars['String']['output'];
  /** optional override when the provider does not support discovery */
  authorizationEndpoint?: Maybe<Scalars['String']['output']>;
  clientId: Scalars['String']['output'];
  hasClientSecret: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** OIDC issuer URL used for discovery, e.g. https://login.microsoftonline.com/<tenantId>/v2.0 */
  issuer: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  /** space separated OIDC scopes, e.g. 'openid profile email offline_access' */
  scopes: Scalars['String']['output'];
  /** optional override when the provider does not support discovery */
  tokenEndpoint?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
  /** optional override when the provider does not support discovery */
  userinfoEndpoint?: Maybe<Scalars['String']['output']>;
};

export type OrganizationSsoConfigInput = {
  /** comma-separated email domains that may use this SSO config, e.g. 'acme.com, acme.eu'. */
  allowedEmailDomains?: InputMaybe<Scalars['String']['input']>;
  authorizationEndpoint?: InputMaybe<Scalars['String']['input']>;
  clientId: Scalars['String']['input'];
  /** omit or pass null to keep the existing secret on update; required when creating */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  issuer: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  scopes?: InputMaybe<Scalars['String']['input']>;
  tokenEndpoint?: InputMaybe<Scalars['String']['input']>;
  userinfoEndpoint?: InputMaybe<Scalars['String']['input']>;
};

export enum OrganizationStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Inactive = 'INACTIVE'
}

export type OrganizationWithLinksToReport = {
  __typename?: 'OrganizationWithLinksToReport';
  linksToReport: Array<LinkToReport>;
  organizations: Array<Organization>;
};

export type OrganizationsData = {
  __typename?: 'OrganizationsData';
  data: Array<Organization>;
  totalCount: Scalars['Int']['output'];
};

export enum Origin {
  Dashboard = 'DASHBOARD',
  SelfCare = 'SELF_CARE',
  Talk = 'TALK'
}

/** Unspecified message, with no special meaning */
export type OtherMessage = Message & {
  __typename?: 'OtherMessage';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

export type OverviewUser = {
  __typename?: 'OverviewUser';
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  intercomHash: Scalars['String']['output'];
  summaryNotifications: Scalars['Boolean']['output'];
  surname: Scalars['String']['output'];
  username: Scalars['String']['output'];
};

/** Pagination info as per relay spec */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

export type Pagination = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type PayloadCheck = {
  __typename?: 'PayloadCheck';
  fieldPath: Scalars['String']['output'];
  regex: Scalars['String']['output'];
};

export type PayloadCheckInput = {
  fieldPath: Scalars['String']['input'];
  regex: Scalars['String']['input'];
};

export type PersonMultiselectQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'PersonMultiselectQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** Choices of possible avatars which question can set */
  organizationRespondents: Array<Respondent>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange: Scalars['RangeExp']['output'];
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type PersonMultiselectQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCallingCode: Scalars['String']['output'];
  nationalNumber: Scalars['String']['output'];
};

export type PreviewConversationUsage = {
  __typename?: 'PreviewConversationUsage';
  contact: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  language: Scalars['String']['output'];
  openedAt?: Maybe<Scalars['Date']['output']>;
  organizationName: Scalars['String']['output'];
  topicGroup: PublicTopicGroup;
};

export type PreviousEventsCheck = {
  __typename?: 'PreviousEventsCheck';
  check: PayloadCheck;
  type: Scalars['String']['output'];
};

export type PreviousEventsCheckInput = {
  check: PayloadCheckInput;
  type: Scalars['String']['input'];
};

export type ProcessReportComparsion = {
  __typename?: 'ProcessReportComparsion';
  id: Scalars['ID']['output'];
  stepStatistics: Array<StepStatistics>;
};

export type ProcessReportInfoSub = {
  __typename?: 'ProcessReportInfoSub';
  addedOnFrom?: Maybe<Scalars['Date']['output']>;
  addedOnTo?: Maybe<Scalars['Date']['output']>;
  filteredRespondents?: Maybe<Scalars['Int']['output']>;
  /** Fourth stage */
  groupedRespondents?: Maybe<SurveyGroupRespondentsResult>;
  hiringInfo?: Maybe<HiringInfo>;
  /** First stage */
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  metadata: PubMetadata;
  reportRoots: Array<Scalars['ID']['output']>;
  /** Third stage */
  rootTeamsStatistics?: Maybe<Array<RootTeamsStatistics>>;
  /** Second stage */
  surveyGroup?: Maybe<SurveyGroup>;
  teams?: Maybe<Array<PubTeams>>;
  totalRespondents?: Maybe<Scalars['Int']['output']>;
  widgets?: Maybe<ProcessWidgets>;
};

export type ProcessReportRespondentDetail = {
  __typename?: 'ProcessReportRespondentDetail';
  groupedRespondents: Array<GroupedRespondents>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  keyPoints?: Maybe<Array<KeyPoint>>;
  metadata: PubMetadata;
  questions: Array<PubQuestion>;
  reportRoots: Array<Scalars['ID']['output']>;
  respondents: Array<PubRespondent>;
  responses: Array<PubResponse>;
  surveyGroup?: Maybe<SurveyGroup>;
  teams: Array<PubTeams>;
  totalRespondents: Scalars['Int']['output'];
};

/** Survey status */
export enum ProcessStatus {
  Anonymized = 'ANONYMIZED',
  Archived = 'ARCHIVED',
  /** Last survey in the sequence step is not active, ends_at date is in past */
  Completed = 'COMPLETED',
  /** All surveys are in state PREPARED or NOTSTARTED */
  Notstarted = 'NOTSTARTED',
  /** Some survey in the sequence step is active, send_at date is in past and ends_at date is in future */
  Ongoing = 'ONGOING',
  /** First survey in the sequence step is not active, send_at date is in future */
  Prepared = 'PREPARED'
}

export type ProcessStep = {
  __typename?: 'ProcessStep';
  candidateLanguage?: Maybe<Language>;
  copyTg?: Maybe<Scalars['Boolean']['output']>;
  customFieldsCheck?: Maybe<Array<CustomFieldsCheck>>;
  endOffsetMins?: Maybe<Scalars['Int']['output']>;
  eventDateField?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  payloadCheck?: Maybe<Array<PayloadCheck>>;
  previousEventsCheck?: Maybe<Array<PreviousEventsCheck>>;
  processTopicGroup: TopicGroup;
  reminders: Array<ProcessStepReminder>;
  startOffsetMins?: Maybe<Scalars['Int']['output']>;
  stepTopicGroup: TopicGroup;
  triggeredOn?: Maybe<Scalars['String']['output']>;
  useEmailFromNote?: Maybe<Scalars['Boolean']['output']>;
};

export type ProcessStepReminder = {
  __typename?: 'ProcessStepReminder';
  id: Scalars['ID']['output'];
  processStepId: Scalars['ID']['output'];
  reminderOffsetMins: Scalars['Int']['output'];
};

export type ProcessWidgets = {
  __typename?: 'ProcessWidgets';
  anonymityRate: Widget;
  finishedRate: Widget;
  responseRate: Widget;
  withoutProblems: Widget;
};

export type Product = {
  __typename?: 'Product';
  code: Scalars['String']['output'];
};

export type ProductHistorySurveyType = {
  __typename?: 'ProductHistorySurveyType';
  id: Scalars['ID']['output'];
  numOfEmployees?: Maybe<Scalars['Int']['output']>;
  numOfPositions?: Maybe<Scalars['Int']['output']>;
  numOfSurveys?: Maybe<Scalars['Int']['output']>;
  productHistoryId: Scalars['ID']['output'];
  type: ProductVersionSurveyType;
};

export type ProductHistorySurveyTypeInput = {
  numOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  numOfPositions?: InputMaybe<Scalars['Int']['input']>;
  numOfSurveys?: InputMaybe<Scalars['Int']['input']>;
  type: ProductVersionSurveyType;
};

/** Row of product_topic_group: the topic group is visible to organizations with this product and business unit */
export type ProductTopicGroup = {
  __typename?: 'ProductTopicGroup';
  businessUnit: BusinessUnit;
  /** Hidden from the Admin topic list, already scheduled surveys still start */
  deprecated: Scalars['Boolean']['output'];
  product: Scalars['String']['output'];
};

export type ProductTopicGroupInput = {
  businessUnit: BusinessUnit;
  deprecated?: InputMaybe<Scalars['Boolean']['input']>;
  product: Scalars['String']['input'];
};

export type ProductVersion = {
  __typename?: 'ProductVersion';
  activePeriodEnd?: Maybe<Scalars['Date']['output']>;
  boughtCredits?: Maybe<Scalars['Float']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  licenceCount?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['ID']['output'];
  product: Scalars['String']['output'];
  productHistorySurveyTypes: Array<Maybe<ProductHistorySurveyType>>;
  transferredCredits?: Maybe<Scalars['Float']['output']>;
  trial?: Maybe<Scalars['Boolean']['output']>;
  /** Number of used credits */
  usedCredits?: Maybe<Scalars['Float']['output']>;
  validFrom: Scalars['Date']['output'];
  validTo: Scalars['Date']['output'];
};

export enum ProductVersionSurveyType {
  Exit = 'EXIT',
  Fms = 'FMS',
  Hiring = 'HIRING',
  Onboarding = 'ONBOARDING',
  OneTime = 'ONE_TIME',
  Pulser = 'PULSER',
  Seduo = 'SEDUO',
  Sequential = 'SEQUENTIAL'
}

export type PubDisplayFilter = {
  __typename?: 'PubDisplayFilter';
  operator: Scalars['String']['output'];
  questionDefinitionIndex: Scalars['ID']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type PubMessage = {
  __typename?: 'PubMessage';
  anonymous: Scalars['Boolean']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  date: Scalars['Date']['output'];
  hasAlert: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  originalAnonymous: Scalars['Boolean']['output'];
  questionDefinitionIndex: Scalars['ID']['output'];
  relevance: Scalars['Float']['output'];
  statementIndex?: Maybe<Scalars['Int']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PubMetadata = {
  __typename?: 'PubMetadata';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  adminEmails?: Maybe<Array<Scalars['String']['output']>>;
  language?: Maybe<Language>;
  organization: Organization;
  organizationDepth: Scalars['Int']['output'];
  productVersion?: Maybe<ProductVersion>;
  respondent?: Maybe<Respondent>;
  status: SurveyStatus;
  surveyEnd?: Maybe<Scalars['Date']['output']>;
  surveyStart?: Maybe<Scalars['Date']['output']>;
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  user?: Maybe<User>;
};

export type PubQuestion = {
  __typename?: 'PubQuestion';
  answersLocal?: Maybe<Array<Scalars['String']['output']>>;
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  index: Scalars['ID']['output'];
  isRankingScale?: Maybe<Scalars['Boolean']['output']>;
  metrics: Array<Maybe<Scalars['String']['output']>>;
  reportIndex?: Maybe<Scalars['ID']['output']>;
  reportOrder?: Maybe<Scalars['Int']['output']>;
  selectedRange?: Maybe<Scalars['String']['output']>;
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  statementsLocal?: Maybe<Array<Scalars['String']['output']>>;
  text: Scalars['String']['output'];
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  type: QuestionType;
};

export type PubReport = {
  __typename?: 'PubReport';
  addedOnFrom?: Maybe<Scalars['Date']['output']>;
  addedOnTo?: Maybe<Scalars['Date']['output']>;
  additionalRespondentData?: Maybe<Array<AdditionalRespondentDataFromTeamio>>;
  anonymityEnabled: Scalars['Boolean']['output'];
  anonymityForced: Scalars['Boolean']['output'];
  /** Survey settings regarding anonymity (chosen for this survey; fallback to topic group defaults) */
  anonymitySettings?: Maybe<AnonymitySettings>;
  /** First survey in the report (for single surveys) or first survey in the sequence */
  firstSurvey?: Maybe<Survey>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  keywordsVersion: Scalars['Int']['output'];
  metadata?: Maybe<PubMetadata>;
  questionLabels?: Maybe<Array<QuestionLabel>>;
  questions?: Maybe<Array<PubQuestion>>;
  reportDefinition?: Maybe<PubReportDefinition>;
  reportRoots?: Maybe<Array<Scalars['ID']['output']>>;
  respondents?: Maybe<Array<PubRespondent>>;
  responses?: Maybe<Array<PubResponse>>;
  sequenceFrom?: Maybe<Scalars['Date']['output']>;
  sequenceTo?: Maybe<Scalars['Date']['output']>;
  source?: Maybe<Array<PubSource>>;
  surveyGroup?: Maybe<SurveyGroup>;
  surveyKeywordsGenerated: Scalars['Boolean']['output'];
  teams?: Maybe<Array<PubTeams>>;
  /** Total respondents including disqualified (disabled with disabledReason) */
  totalRespondents?: Maybe<Scalars['Int']['output']>;
};

export type PubReportDefinition = {
  __typename?: 'PubReportDefinition';
  aboutLocal?: Maybe<Scalars['String']['output']>;
  approved: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  intro?: Maybe<Array<PubWidget>>;
  sections?: Maybe<Array<PubSection>>;
  titleLocal?: Maybe<Scalars['String']['output']>;
};

export type PubRespondent = {
  __typename?: 'PubRespondent';
  addedOn?: Maybe<Scalars['Date']['output']>;
  firstname: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  surname: Scalars['String']['output'];
};

export type PubResponse = {
  __typename?: 'PubResponse';
  additionallyAnonymized: Scalars['Boolean']['output'];
  anonymous: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['Date']['output']>;
  finished: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  messages?: Maybe<Array<PubMessage>>;
  originalAnonymous: Scalars['Boolean']['output'];
  reactions?: Maybe<Array<Reaction>>;
  respondentId: Scalars['ID']['output'];
  seqDate?: Maybe<Scalars['Date']['output']>;
  surveyId: Scalars['ID']['output'];
  topicGroupId: Scalars['ID']['output'];
};

export type PubSection = {
  __typename?: 'PubSection';
  descriptionLocal?: Maybe<Scalars['String']['output']>;
  displayFilters?: Maybe<Array<PubDisplayFilter>>;
  heading: Scalars['String']['output'];
  headingLocal: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  titleFilters?: Maybe<Array<PubDisplayFilter>>;
  type: ReportSectionType;
  widgets?: Maybe<Array<PubWidget>>;
};

export type PubSource = {
  __typename?: 'PubSource';
  respondentId: Scalars['ID']['output'];
  sourceId: Scalars['String']['output'];
};

export type PubTeams = {
  __typename?: 'PubTeams';
  directMembers?: Maybe<Array<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  memberTeams?: Maybe<Array<Scalars['ID']['output']>>;
  teamLeader?: Maybe<Scalars['ID']['output']>;
  teamName: Scalars['String']['output'];
};

export type PubWidget = {
  __typename?: 'PubWidget';
  additionallyAnonymized?: Maybe<Scalars['Boolean']['output']>;
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  denominator?: Maybe<Scalars['Int']['output']>;
  descriptionLocal?: Maybe<Scalars['String']['output']>;
  displayFilters?: Maybe<Array<PubDisplayFilter>>;
  headingLocal: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  numerator?: Maybe<Scalars['Int']['output']>;
  questionDefinitionIndex?: Maybe<Scalars['ID']['output']>;
  titleFilters?: Maybe<Array<PubDisplayFilter>>;
  type: Scalars['String']['output'];
  values?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type PublicChannel = {
  __typename?: 'PublicChannel';
  /** Date of FINISHED event if exists */
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isFinishedByRespondent: Scalars['Boolean']['output'];
  lastRemindedAt?: Maybe<Scalars['Date']['output']>;
  maxAnonymousHighlightedLevel: Scalars['Int']['output'];
  respondentId: Scalars['ID']['output'];
  withAnswer: Scalars['Boolean']['output'];
};

export type PublicRespondent = {
  __typename?: 'PublicRespondent';
  channels?: Maybe<Array<Channel>>;
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isLeader: Scalars['Boolean']['output'];
  isReportRecipient: Scalars['Boolean']['output'];
  newAnswersNotifications?: Maybe<NotificationLevel>;
  organization: Organization;
  organizationRole: UserOrgRole;
  reports?: Maybe<Array<ReportAccess>>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type PublicTopicGroup = {
  __typename?: 'PublicTopicGroup';
  /** Translation of TopicGroupCategory */
  categoryCode?: Maybe<Scalars['String']['output']>;
  /** Translation of TopicGroupCategory */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Translation of TopicGroup */
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Translation of TopicGroup */
  name: Scalars['String']['output'];
  /** Is topic group of conversation subject a process? */
  process: Scalars['Boolean']['output'];
  steps: Array<PublicTopicGroup>;
};

/** One Pulser JSON upload. The row stays after Graphile removes the finished job. */
export type PulserImport = {
  __typename?: 'PulserImport';
  byteSize: Scalars['Int']['output'];
  createdAt: Scalars['Date']['output'];
  error?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  finishedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organizationExternalUid?: Maybe<Scalars['String']['output']>;
  organizationName?: Maybe<Scalars['String']['output']>;
  startedAt?: Maybe<Scalars['Date']['output']>;
  status: PulserImportStatus;
  summary?: Maybe<Scalars['String']['output']>;
  surveyCount?: Maybe<Scalars['Int']['output']>;
};

export enum PulserImportStatus {
  Failed = 'FAILED',
  Queued = 'QUEUED',
  Running = 'RUNNING',
  Succeeded = 'SUCCEEDED'
}

/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type Query = {
  __typename?: 'Query';
  /** Paged AI call log listing with truncated previews (SysAdmin only) */
  aiCallLog: AiCallLogData;
  /** Full detail, including full prompt/response text, for one AI call log row (SysAdmin only) */
  aiCallLogDetail?: Maybe<AiCallLogDetail>;
  /** A single AI use-case config by use case key (SysAdmin only) */
  aiGenerationConfig?: Maybe<AiGenerationConfig>;
  /** All AI use-case configs (SysAdmin only) */
  aiGenerationConfigs: Array<AiGenerationConfig>;
  /** Current AI model pricing table (SysAdmin only) */
  aiModelPricing: Array<AiModelPricing>;
  aiSurveySummary: AiSurveySummaryData;
  /** On-demand usage aggregation over the AI call log, bounded by its 7-day retention (SysAdmin only) */
  aiUsage: Array<AiUsageRow>;
  /** Retrieves all surveys */
  allSurveys: Array<Survey>;
  allSurveysCount: Scalars['Int']['output'];
  /** Return all topic groups */
  allowedTopicGroups?: Maybe<Array<TopicGroup>>;
  /** Retrieves specific channel */
  channel?: Maybe<Channel>;
  channelOverview: ChannelOverview;
  /** Check which login modes are available for the given email (no auth required) */
  checkSso: SsoLoginMode;
  /** Get suitable dates for new survey */
  datesForNewSurvey: DatesForNewSurvey;
  defaultFeatureFlags: Array<Features>;
  /** Exports survey answers as 'File' */
  exportSurveyAnswers?: Maybe<TextFile>;
  /** Exports file for translation import for selected topic */
  exportTranslations?: Maybe<TextFile>;
  getAccessToken: Scalars['String']['output'];
  getCategoryCodes: Array<CategoryCode>;
  /** Get slug for survey channel by respondent ID No. in organization */
  getChannelSlugForIdNumber: Scalars['String']['output'];
  /** Get last open channel for respondent surname and validate using pin */
  getChannelSlugForName: Scalars['String']['output'];
  /** Compare statistics for given periods */
  getComparsionDataForProcessReport: ProcessReportComparsion;
  getCompletedSurveys: Array<Survey>;
  getCreditHistory: Array<CreditHistory>;
  /** get paginated workerTasks references */
  getCronJobs?: Maybe<Array<CronJob>>;
  getGraphileJobQueues?: Maybe<Array<JobQueue>>;
  /** get paginated workerTasks references */
  getGraphileJobs?: Maybe<Array<Job>>;
  /** Return simplified report data */
  getNewReport: NewReport;
  getOrganizationsWithExternalUid: OrganizationWithLinksToReport;
  getProcessReport: ProcessReportInfoSub;
  /** Return all details about respondent in report sequence */
  getProcessReportRespondentDetail: ProcessReportRespondentDetail;
  getProcessReportRespondents: SurveyGroupRespondentsResult;
  /** Return all informations for report */
  getReport: PubReport;
  /** List all reports */
  getReports: Array<ReportList>;
  getRespondentsWithOnboardingInfo?: Maybe<Array<RespondentWithLinksToReport>>;
  getResponseRateStatistics: ResponseRateStatistics;
  getSecureRespondentDetail: ProcessReportRespondentDetail;
  getSurveyGroupResponseRateStatistics: Array<ResponseRateSurveyGroupStatistics>;
  getTotalUnprocessedGraphileJobsCount: Scalars['Int']['output'];
  getUserOtp?: Maybe<Scalars['String']['output']>;
  groupedMessageTemplate?: Maybe<Array<Maybe<GroupTemplateValue>>>;
  industries: Array<IndustryCategory>;
  /** Check if access token can be used for authenticated resources */
  isAccessTokenValid: AccessToken;
  /** Return all supported languages in DB */
  languages: Array<Language>;
  lastMessagesForRespondent: Array<MessageStatus>;
  /** List of all marketing channels */
  marketingChannels?: Maybe<Array<Maybe<MarketingChannel>>>;
  messageQueues?: Maybe<Array<Maybe<MessageQueue>>>;
  /** List of langs */
  messageTemplates?: Maybe<Array<Maybe<MessageTemplate>>>;
  /** Retrieves messages of specific channel */
  messages?: Maybe<Array<Message>>;
  /** Retrieves organization structure */
  organization?: Maybe<Organization>;
  organizationAdmins?: Maybe<Array<Maybe<Respondent>>>;
  /** SSO configuration of an organization (SysAdmin only; clientSecret is never returned) */
  organizationSsoConfig?: Maybe<OrganizationSsoConfig>;
  organizationSurveys: Array<Survey>;
  /** All teams in organization */
  organizationTeams: Array<Team>;
  /** List of all organizations */
  organizations?: Maybe<Array<Maybe<Organization>>>;
  paginatedMessages: MessageData;
  paginatedMessagesForRespondent: MessageData;
  /** Return all topic groups */
  paginatedOrganizations: OrganizationsData;
  /** Return all respondents */
  paginatedRespondents: RespondentsData;
  /** Return information about usage of preview conversation */
  previewConversationUsage: Array<PreviewConversationUsage>;
  /** Render a preview of a message template without persisting it. Placeholders are left as-is. */
  previewMessageTemplate: MessageTemplatePreview;
  /** List of all products */
  products?: Maybe<Array<Maybe<Product>>>;
  /** Return all topic groups */
  publicTopicGroups: Array<Maybe<PublicTopicGroup>>;
  /** Pulser JSON imports and their status after the worker finishes (SysAdmin only) */
  pulserImports: Array<PulserImport>;
  /** Retrieves specific question definition */
  questionDefinition?: Maybe<QuestionDefinition>;
  questionTriggers: Array<QuestionTrigger>;
  reportDefinitionNewForSurvey: ReportDefinitionNewVersion;
  reportDefinitionNewForTopic: ReportDefinitionNewVersion;
  reportDefinitionsNewForSurvey: Array<ReportDefinitionNewVersion>;
  reportDefinitionsNewForTopic: Array<ReportDefinitionNewVersion>;
  /** Return recipients of reports for teams in organization */
  reportRecipients: Array<ReportRecipient>;
  /** Return all details about respondent */
  respondent: Respondent;
  /** Retrieves specific survey */
  survey?: Maybe<Survey>;
  /** Short-lived presigned download URL for a survey attachment */
  surveyAttachmentDownloadUrl: Scalars['String']['output'];
  /** Retrieves specific survey group */
  surveyGroup?: Maybe<SurveyGroup>;
  /** Retrieves respondents for specific survey group */
  surveyGroupRespondents: SurveyGroupRespondents;
  /** Retrieves organization survey groups for defined topic group */
  surveyGroups?: Maybe<Array<SurveyGroup>>;
  /** Retrieves public information about specific survey */
  surveyPublicInfo?: Maybe<SurveyPublicInfo>;
  /** Return all system admins */
  systemAdmins: Array<User>;
  /** get detail of topic */
  topicDetail: Topic;
  /** Topic group is collection of topics */
  topicGroup: TopicGroup;
  /** Return all topic groups */
  topicGroups: TopicGroupsData;
  /** List of all topics */
  topics?: Maybe<Array<Maybe<Topic>>>;
  /** Return user that is derived from used accessToken */
  user: User;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiCallLogArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  onlyErrors?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  useCase?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiCallLogDetailArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiGenerationConfigArgs = {
  useCase: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiSurveySummaryArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  languageCode: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAiUsageArgs = {
  from: Scalars['Date']['input'];
  groupBy: AiUsageGroupBy;
  model?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  to: Scalars['Date']['input'];
  useCase?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllSurveysArgs = {
  filter?: InputMaybe<SurveyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllSurveysCountArgs = {
  filter?: InputMaybe<SurveyFilterInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryAllowedTopicGroupsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryChannelArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryChannelOverviewArgs = {
  channelSlug: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryCheckSsoArgs = {
  email: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryDatesForNewSurveyArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryExportSurveyAnswersArgs = {
  surveyId: Scalars['ID']['input'];
  unfinished: Scalars['Boolean']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryExportTranslationsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetAccessTokenArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetChannelSlugForIdNumberArgs = {
  respondentIdNo: Scalars['String']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetChannelSlugForNameArgs = {
  organizationId: Scalars['ID']['input'];
  pin: Scalars['Int']['input'];
  surname: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetComparsionDataForProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  periods: Array<DateRangeInput>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCompletedSurveysArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCreditHistoryArgs = {
  productId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetCronJobsArgs = {
  direction?: InputMaybe<OrderByDirection>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskIdentifierFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetGraphileJobQueuesArgs = {
  queueNameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetGraphileJobsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  showLockedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  taskIdentifierFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetNewReportArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetOrganizationsWithExternalUidArgs = {
  companyExternalUid: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  respondentFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportRespondentDetailArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  respondentId: Scalars['ID']['input'];
  seqDate?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetProcessReportRespondentsArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  pagination?: InputMaybe<Pagination>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetRespondentsWithOnboardingInfoArgs = {
  candidateExternalUids?: InputMaybe<Array<Scalars['ID']['input']>>;
  candidates?: InputMaybe<Array<RespondentsWithOnboardingInfoInput>>;
  companyExternalUid: Scalars['ID']['input'];
  userEmail: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetResponseRateStatisticsArgs = {
  contactType?: InputMaybe<ResponseRateStatisticsContactType>;
  dateFrom: Scalars['Date']['input'];
  dateTo: Scalars['Date']['input'];
  hasSentReport?: InputMaybe<Scalars['Boolean']['input']>;
  prevSurveyDays?: InputMaybe<Scalars['Int']['input']>;
  reminders: ResponseRateStatisticsReminders;
  respondentsCountFrom?: InputMaybe<Scalars['Int']['input']>;
  respondentsCountTo?: InputMaybe<Scalars['Int']['input']>;
  timeFrom?: InputMaybe<Scalars['Date']['input']>;
  timeTo?: InputMaybe<Scalars['Date']['input']>;
  weekDay?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetSecureRespondentDetailArgs = {
  accessToken: Scalars['String']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  seqDate?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetSurveyGroupResponseRateStatisticsArgs = {
  hasSentReport?: InputMaybe<Scalars['Boolean']['input']>;
  sequenceTopicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGetUserOtpArgs = {
  username: Scalars['String']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryGroupedMessageTemplateArgs = {
  businessUnit?: InputMaybe<BusinessUnit>;
  groupBy: GroupTemplateType;
  type?: InputMaybe<ContactType>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryLanguagesArgs = {
  filter?: InputMaybe<LanguageFilterInput>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryLastMessagesForRespondentArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  respondentIds: Array<Scalars['ID']['input']>;
  surveyIds: Array<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryMessagesArgs = {
  channelId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationAdminsArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationSsoConfigArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationSurveysArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryOrganizationTeamsArgs = {
  organizationId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedMessagesArgs = {
  filter?: InputMaybe<MessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedMessagesForRespondentArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedOrganizationsArgs = {
  filter?: InputMaybe<OrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPaginatedRespondentsArgs = {
  filter?: InputMaybe<RespondentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPreviewMessageTemplateArgs = {
  messageTemplate: MessageTemplateInput;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPublicTopicGroupsArgs = {
  businessUnit?: InputMaybe<BusinessUnit>;
  language: Scalars['String']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryPulserImportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryQuestionDefinitionArgs = {
  questionId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryQuestionTriggersArgs = {
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionNewForSurveyArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionNewForTopicArgs = {
  id: Scalars['ID']['input'];
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionsNewForSurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportDefinitionsNewForTopicArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryReportRecipientsArgs = {
  organizationId: Scalars['ID']['input'];
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryRespondentArgs = {
  respondentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyArgs = {
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyAttachmentDownloadUrlArgs = {
  attachmentId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupArgs = {
  surveyGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupRespondentsArgs = {
  pagination?: InputMaybe<Pagination>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  surveyGroupId: Scalars['ID']['input'];
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyGroupsArgs = {
  organizationId: Scalars['ID']['input'];
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySurveyPublicInfoArgs = {
  langCode?: InputMaybe<Scalars['String']['input']>;
  surveyId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QuerySystemAdminsArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicDetailArgs = {
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
  topicId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicGroupArgs = {
  language?: InputMaybe<Scalars['ID']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  topicGroupId: Scalars['ID']['input'];
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryTopicGroupsArgs = {
  filter?: InputMaybe<TopicGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Every GraphQL schema has a root type for both queries and mutations.
 * The query type defines GraphQL operations that retrieve data from the server.
 */
export type QueryUserArgs = {
  languageCode?: InputMaybe<Scalars['String']['input']>;
};

/** Inquiry about something, currently sent by bot */
export type Question = Message & {
  __typename?: 'Question';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** QuestionDefinition bot used to create message */
  definition: QuestionDefinition;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Message text */
  text?: Maybe<Scalars['String']['output']>;
};

/**
 * Definition of single question bot sents. This is template, bot uses to create message from.
 * Also based on previous question and answer determines which question definition it sends next
 */
export type QuestionDefinition = {
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};

export type QuestionDefinitionInput = {
  answersToHighlight?: InputMaybe<Array<Scalars['ID']['input']>>;
  index?: InputMaybe<Scalars['Int']['input']>;
  isFirstInSectionWithNumber?: InputMaybe<Scalars['Int']['input']>;
  /** If scale question should rank statements */
  isRankingScale?: InputMaybe<Scalars['Boolean']['input']>;
  optional?: InputMaybe<Scalars['Boolean']['input']>;
  /** X position in the topic editor */
  positionX?: InputMaybe<Scalars['Int']['input']>;
  /** Y position in the topic editor */
  positionY?: InputMaybe<Scalars['Int']['input']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder?: InputMaybe<Scalars['Boolean']['input']>;
  reportIndex?: InputMaybe<Scalars['Int']['input']>;
  /** Question order for reporting */
  reportOrder?: InputMaybe<Scalars['Int']['input']>;
  rules: Array<Routing>;
  selectedRange?: InputMaybe<SelectedRange>;
  /** If skip option should be shown */
  showEscapeOption?: InputMaybe<Scalars['Boolean']['input']>;
  translations: Array<QuestionDefinitionTranslationInput>;
  type: QuestionType;
};

/** Question translation */
export type QuestionDefinitionTranslation = {
  __typename?: 'QuestionDefinitionTranslation';
  choices?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isDefault: Scalars['Boolean']['output'];
  /** Language of this translation */
  language: Language;
  /** Statements (sub-questions) of scale question */
  statements?: Maybe<Array<Scalars['String']['output']>>;
  /** Text of the translation */
  text: Scalars['String']['output'];
  /** Translation status: same_as_source = the same as source, source_changed = source language was updated after this translation was saved */
  translationStatus?: Maybe<TranslationStatus>;
};

export type QuestionDefinitionTranslationInput = {
  choices?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDefault: Scalars['Boolean']['input'];
  languageId: Scalars['ID']['input'];
  /** Statements (sub-questions) of scale question */
  statements?: InputMaybe<Array<Scalars['String']['input']>>;
  text: Scalars['String']['input'];
};

/** An edge in a connection. */
export type QuestionDefinitionsEdge = {
  __typename?: 'QuestionDefinitionsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The questionDefinition at the end of the edge. */
  node: QuestionDefinition;
};

export type QuestionLabel = {
  __typename?: 'QuestionLabel';
  questionDefinitionIndex: Scalars['ID']['output'];
  questionLabelComments?: Maybe<Array<QuestionLabelComments>>;
};

export type QuestionLabelComments = {
  __typename?: 'QuestionLabelComments';
  commentIds?: Maybe<Array<Scalars['ID']['output']>>;
  label: Scalars['String']['output'];
};

export type QuestionTrigger = {
  __typename?: 'QuestionTrigger';
  index: Scalars['Int']['output'];
  topicGroupId: Scalars['ID']['output'];
  triggerIdentifier: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type QuestionTriggerInput = {
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['ID']['input'];
  triggerIdentifier: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export enum QuestionType {
  EmailContact = 'EMAIL_CONTACT',
  Ending = 'ENDING',
  Freetext = 'FREETEXT',
  Multiselect = 'MULTISELECT',
  PersonMultiselect = 'PERSON_MULTISELECT',
  Scale = 'SCALE',
  Select = 'SELECT',
  SmsContact = 'SMS_CONTACT',
  Tell = 'TELL'
}

export type QuestionWithAnswer = {
  answers?: InputMaybe<Array<Scalars['String']['input']>>;
  choices?: InputMaybe<Array<ChoiceAnswer>>;
  id: Scalars['ID']['input'];
  question: Scalars['String']['input'];
  type: QuestionType;
};

/** Rule that can match range of integers. */
export type RangeRule = Rule & {
  __typename?: 'RangeRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** rule operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** Expression for this rule */
  value?: Maybe<Scalars['RangeExp']['output']>;
};

export type Reaction = {
  __typename?: 'Reaction';
  channelId: Scalars['ID']['output'];
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
  respondentFullName?: Maybe<Scalars['String']['output']>;
  respondentId: Scalars['ID']['output'];
  text: Scalars['String']['output'];
};

/** Organization input for self-service registration - only what the sign-up form actually collects. */
export type RegistrationOrganizationInput = {
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  /** Organization country code. ISO 3166-1 alpha-2 */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language: Scalars['String']['input'];
  /** Organization name */
  systemName: Scalars['String']['input'];
};

export type Reminder = {
  __typename?: 'Reminder';
  /** Time when reminder will be send */
  reminderAt: Scalars['Date']['output'];
};

export type ReopenSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['Date']['input'];
  messageTemplateUid?: InputMaybe<Scalars['String']['input']>;
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  sendMessage?: InputMaybe<Scalars['Boolean']['input']>;
  surveyId: Scalars['ID']['input'];
};

export type ReportAccept = {
  accepted: Scalars['Boolean']['input'];
  reportAccessId: Scalars['ID']['input'];
};

export type ReportAccess = {
  __typename?: 'ReportAccess';
  accepted?: Maybe<Scalars['Boolean']['output']>;
  accessKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  language?: Maybe<Language>;
  readAt?: Maybe<Scalars['Date']['output']>;
  respondent?: Maybe<Respondent>;
  resultsInfo?: Maybe<SurveyResultsInfo>;
  sent: Scalars['Boolean']['output'];
  survey?: Maybe<Survey>;
  surveyGroup?: Maybe<SurveyGroup>;
  teams?: Maybe<Array<Team>>;
  topicName: Scalars['String']['output'];
  totalCount?: Maybe<Scalars['Int']['output']>;
  unreadCount?: Maybe<Scalars['Int']['output']>;
  unreadMessages?: Maybe<UnreadMessages>;
  visitsInLastYear?: Maybe<Scalars['Int']['output']>;
};

export type ReportBasicStatistics = {
  __typename?: 'ReportBasicStatistics';
  anonymous: Scalars['Int']['output'];
  answered: Scalars['Int']['output'];
  avgMetric: Scalars['Float']['output'];
  total: Scalars['Int']['output'];
  withProblems: Scalars['Int']['output'];
};

/** Admin-only immutable version metadata and optional payload */
export type ReportDefinitionNewVersion = {
  __typename?: 'ReportDefinitionNewVersion';
  createdAt: Scalars['Date']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  definition?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isPrimary: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type ReportList = {
  __typename?: 'ReportList';
  approved: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  languagesWithMissingTranslations: Array<Maybe<Scalars['String']['output']>>;
  reportTopic?: Maybe<Topic>;
  reportTopicGroup?: Maybe<TopicGroup>;
  reportTopics: Array<Maybe<Topic>>;
  title?: Maybe<Scalars['String']['output']>;
};

export enum ReportOpenMetricsView {
  ProcessTable = 'PROCESS_TABLE',
  RespondentDetail = 'RESPONDENT_DETAIL',
  RespondentInPhase = 'RESPONDENT_IN_PHASE'
}

export type ReportOrganization = {
  __typename?: 'ReportOrganization';
  language: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  respondents: Array<Maybe<ReportRespondent>>;
};

export type ReportRecipient = {
  __typename?: 'ReportRecipient';
  id: Scalars['ID']['output'];
  language: Language;
  respondent?: Maybe<Respondent>;
  /** whether linked respondent is deleted */
  respondentDeleted: Scalars['Boolean']['output'];
  team?: Maybe<Team>;
  /** whether linked team is deleted */
  teamDeleted: Scalars['Boolean']['output'];
  type: ReportType;
  validFrom?: Maybe<Scalars['Date']['output']>;
  validTo?: Maybe<Scalars['Date']['output']>;
};

export type ReportRespondent = {
  __typename?: 'ReportRespondent';
  channel_id?: Maybe<Scalars['ID']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  respondent_email?: Maybe<Scalars['String']['output']>;
  respondent_firstname?: Maybe<Scalars['String']['output']>;
  respondent_supervisor_email?: Maybe<Scalars['String']['output']>;
  respondent_supervisor_id?: Maybe<Scalars['ID']['output']>;
  respondent_surname?: Maybe<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  team_id?: Maybe<Scalars['ID']['output']>;
  team_name?: Maybe<Scalars['String']['output']>;
};

export enum ReportSectionType {
  Charts = 'charts',
  Pulser = 'pulser'
}

export enum ReportType {
  Team = 'TEAM',
  Unit = 'UNIT'
}

export enum ReportWidgetType {
  AnonymityRate = 'ANONYMITY_RATE',
  CommentTable = 'COMMENT_TABLE',
  Filter = 'FILTER',
  FinishedRate = 'FINISHED_RATE',
  Nps = 'NPS',
  ResponseRate = 'RESPONSE_RATE',
  ScaleChart = 'SCALE_CHART',
  StackedChart = 'STACKED_CHART',
  WithoutIssuesRate = 'WITHOUT_ISSUES_RATE'
}

/** User that answers surveys */
export type Respondent = {
  __typename?: 'Respondent';
  /** all channels of respondent */
  channels?: Maybe<Array<Channel>>;
  /** All respondent contacts */
  contacts?: Maybe<Array<Contact>>;
  /** Date of record creation */
  createdAt: Scalars['Date']['output'];
  /** is respondent deleted */
  deleted: Scalars['Boolean']['output'];
  /** is Respondent disabled - all channels will be disabled */
  disabled: Scalars['Boolean']['output'];
  externalUid?: Maybe<Scalars['String']['output']>;
  /** Respondent name */
  firstname?: Maybe<Scalars['String']['output']>;
  /** ID of respondent */
  id: Scalars['ID']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  /** participated survey groups */
  involvedSurveyGroups?: Maybe<Array<SurveyGroupRespondent>>;
  /** Has subordinates? */
  isLeader: Scalars['Boolean']['output'];
  isReportRecipient: Scalars['Boolean']['output'];
  /** Preferred respondent language */
  language?: Maybe<Language>;
  newAnswersNotifications?: Maybe<NotificationLevel>;
  notificationTeamIds: Array<Scalars['ID']['output']>;
  /** Team organization */
  organization: Organization;
  /** Organization role of respondent */
  organizationRole: UserOrgRole;
  originator?: Maybe<RespondentOriginator>;
  /** Pin code for channel access */
  pin: Scalars['Int']['output'];
  /** Preferred type of contact */
  preferredContactType: ContactType;
  /** reportAccess for respondent */
  reports?: Maybe<Array<ReportAccess>>;
  /** Respondent surname */
  surname?: Maybe<Scalars['String']['output']>;
  /** Team to which respondent belong */
  team?: Maybe<Team>;
  /** user entity if exists */
  user?: Maybe<User>;
};

export type RespondentFilterInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  surname?: InputMaybe<Scalars['String']['input']>;
};

export type RespondentInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** is Respondent disabled - all channels will be disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** respondent email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Id from external system */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  /** First name of user */
  firstname: Scalars['String']['input'];
  /** Preferred respondent language. Code is ISO 639-1 */
  language?: InputMaybe<Scalars['String']['input']>;
  notificationTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** organization for respondent */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization role of respondent */
  organizationRole?: InputMaybe<UserOrgRole>;
  /** Originiator */
  originator?: InputMaybe<Scalars['String']['input']>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
  /** Teams for which respondent will receive reports */
  reportTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Last name of user */
  surname: Scalars['String']['input'];
  surveyGroups?: InputMaybe<Array<NewRespondentSurveyGroupInput>>;
  /** Respondent will be added to surveys */
  surveyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Team to which respondent belong */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

export enum RespondentOriginator {
  Administrator = 'ADMINISTRATOR',
  ApiImport = 'API_IMPORT',
  Autogenerated = 'AUTOGENERATED',
  AutomaticImport = 'AUTOMATIC_IMPORT',
  Import = 'IMPORT',
  Pulser = 'PULSER',
  Teamio = 'TEAMIO'
}

export type RespondentWithLinksToReport = {
  __typename?: 'RespondentWithLinksToReport';
  linksToReport: Array<LinkToReport>;
  respondent: Respondent;
};

export type RespondentsData = {
  __typename?: 'RespondentsData';
  data: Array<Respondent>;
  totalCount: Scalars['Int']['output'];
};

export type RespondentsWithOnboardingInfoInput = {
  email: Scalars['String']['input'];
  externalUid: Scalars['ID']['input'];
  firstname: Scalars['String']['input'];
  hireDate: Scalars['Date']['input'];
  surname: Scalars['String']['input'];
};

export type ResponseRateStatistics = {
  __typename?: 'ResponseRateStatistics';
  total: Scalars['Int']['output'];
  withAnswer: Scalars['Int']['output'];
};

export enum ResponseRateStatisticsContactType {
  Email = 'EMAIL',
  EmailSms = 'EMAIL_SMS',
  Sms = 'SMS'
}

export enum ResponseRateStatisticsReminders {
  All = 'ALL',
  MoreReminders = 'MORE_REMINDERS',
  NoReminder = 'NO_REMINDER',
  OneReminder = 'ONE_REMINDER'
}

export type ResponseRateSurveyGroupStatistics = {
  __typename?: 'ResponseRateSurveyGroupStatistics';
  all: ResponseRateStatistics;
  email: ResponseRateStatistics;
  emailSms: ResponseRateStatistics;
  sms: ResponseRateStatistics;
  topicGroupId: Scalars['ID']['output'];
  topicGroupName: Scalars['String']['output'];
};

export type RootTeamsStatistics = {
  __typename?: 'RootTeamsStatistics';
  statistics: ProcessWidgets;
  teamId: Scalars['ID']['output'];
};

export type Routing = {
  /** Secondary rule based on anonymity. If undefined, anonymity does not matters */
  anonymity?: InputMaybe<AnonymityLevel>;
  /** Is from default - rule is created from question default rule */
  isFromDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** next question index relative for import file/query */
  nextQuestionIndex?: InputMaybe<Scalars['ID']['input']>;
  /** rule for routing to next question. If empty, match all answers */
  rule?: InputMaybe<Scalars['String']['input']>;
  /** Rule Operator */
  ruleOperator?: InputMaybe<RuleOperator>;
};

/**
 * Question rule, basicly this is one row in state-transition table of underlying FSM.
 * We don't have value here because graphql doesn't support union of scalars
 */
export type Rule = {
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
};

export enum RuleOperator {
  In = 'IN',
  Inany = 'INANY'
}

export type ScaleAnswer = Message & {
  __typename?: 'ScaleAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** Optional comment provided with the statement answer */
  comment?: Maybe<Scalars['String']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Index of statement within Scale question */
  statementIndex?: Maybe<Scalars['Int']['output']>;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Selected value index for the statement */
  value: Array<Scalars['Int']['output']>;
};

/** Question scale - multiple choices (only 1 selectable) and multiple sub-questions */
export type ScaleQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'ScaleQuestionDefinition';
  /**
   * Answers to this question.
   * Optionally can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Available choices for this question */
  choices: Array<Scalars['String']['output']>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption: Scalars['Boolean']['output'];
  /** Statements (sub-questions) of scale question */
  statements: Array<Scalars['String']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Question scale - multiple choices (only 1 selectable) and multiple sub-questions */
export type ScaleQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Input for one statement answer in a scale question */
export type ScaleStatementAnswerInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  statementIndex: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

/** Answer to question with choices */
export type SelectAnswer = Message & {
  __typename?: 'SelectAnswer';
  anonymityLevel: AnonymityLevel;
  anonymousInReport?: Maybe<Scalars['Boolean']['output']>;
  /** Optional comment provided with the statement answer */
  comment?: Maybe<Scalars['String']['output']>;
  /** When message was created */
  createdAt: Scalars['Date']['output'];
  /** Entity that sent this message, bot or respondent */
  createdBy: ChannelUserType;
  /** ID of message */
  id: Scalars['ID']['output'];
  isLast?: Maybe<Scalars['Boolean']['output']>;
  /** Answer is to this question */
  question: Question;
  remainingQuestions: Scalars['Int']['output'];
  /** Response on answer */
  response?: Maybe<Array<Message>>;
  /** Channel to which message was sent */
  sentOn: Channel;
  /** Index of statement within Scale question */
  statementIndex?: Maybe<Scalars['Int']['output']>;
  /** Display value of answer */
  text: Scalars['String']['output'];
  /** Value of answer, it's index to questionDefinition choices */
  value: Array<Scalars['Int']['output']>;
};

/** The connection type for SelectAnswer. */
export type SelectAnswersConnection = AnswersConnection & {
  __typename?: 'SelectAnswersConnection';
  /** Aggregate of answers by value */
  aggregate?: Maybe<Array<AggregateAnswersByValue>>;
  /** A list of edges. */
  edges?: Maybe<Array<SelectAnswersEdge>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
};

/** An edge in a connection. */
export type SelectAnswersEdge = AnswersEdge & {
  __typename?: 'SelectAnswersEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The select answer at the end of the edge. */
  node: SelectAnswer;
};

/** Question with choices. Respondent needs to select one of choices */
export type SelectQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'SelectQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** Available choices for this question */
  choices: Array<Scalars['String']['output']>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<Rule>;
  /** How many choices user needs to select */
  selectedRange: Scalars['RangeExp']['output'];
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


/** Question with choices. Respondent needs to select one of choices */
export type SelectQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

export type SelectedRange = {
  /** Maximum of selectable options */
  max: Scalars['Int']['input'];
  /** Minimum of selectable options */
  min: Scalars['Int']['input'];
};

export enum Sentiment {
  Negative = 'NEGATIVE',
  Neutral = 'NEUTRAL',
  Positive = 'POSITIVE'
}

export type SmsContactQuestionDefinition = Answerable & QuestionDefinition & {
  __typename?: 'SmsContactQuestionDefinition';
  /**
   * Answers to this question.
   * Optionaly can return only answers for given channel or survey
   */
  answers: SelectAnswersConnection;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** ID of question definition */
  id: Scalars['ID']['output'];
  /** Question index */
  index?: Maybe<Scalars['Int']['output']>;
  /** Flag if question is first in section */
  isFirstInSectionWithNumber?: Maybe<Scalars['Int']['output']>;
  /** If question is a question trigger */
  isQuestionTrigger: Scalars['Boolean']['output'];
  /** If scale question should rank statements */
  isRankingScale: Scalars['Boolean']['output'];
  metrics?: Maybe<Array<Metrics>>;
  /** If questions can be skipped */
  optional?: Maybe<Scalars['Boolean']['output']>;
  /** International phone code or respondents phone number */
  phoneNumber: Scalars['String']['output'];
  /** X position in the topic editor */
  positionX?: Maybe<Scalars['Int']['output']>;
  /** Y position in the topic editor */
  positionY?: Maybe<Scalars['Int']['output']>;
  /** If scale question statements should be shown in randomized order */
  randomizeOrder: Scalars['Boolean']['output'];
  /** Question index for reporting */
  reportIndex?: Maybe<Scalars['Int']['output']>;
  /** Question order for reporting */
  reportOrder?: Maybe<Scalars['Int']['output']>;
  /** Rules how to choose next question */
  rules: Array<RangeRule>;
  /** How many choices user needs to select */
  selectedRange?: Maybe<Scalars['RangeExp']['output']>;
  /** If skip option should be shown */
  showEscapeOption?: Maybe<Scalars['Boolean']['output']>;
  /** Question wording */
  text: Scalars['String']['output'];
  /** Parent topic */
  topic: Topic;
  /** All translations of question */
  translations: Array<QuestionDefinitionTranslation>;
};


export type SmsContactQuestionDefinitionAnswersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  surveyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Which login modes the login page should offer for an email */
export enum SsoLoginMode {
  /** login is completely blocked - email domain is not authorized for SSO in a strict (sso_forced + sso_exclusive) organization */
  Blocked = 'BLOCKED',
  /** SSO not available - regular password / magic-link login */
  None = 'NONE',
  /** SSO available as an additional option next to password / magic-link login */
  Optional = 'OPTIONAL',
  /** SSO is the only allowed login method */
  Required = 'REQUIRED'
}

export type StepStatistics = {
  __typename?: 'StepStatistics';
  avgMetric: Scalars['Float']['output'];
  periodIndex: Scalars['Int']['output'];
  statistics: ProcessWidgets;
  stepId: Scalars['ID']['output'];
};

/** Root subscription type. */
export type Subscription = {
  __typename?: 'Subscription';
  aiSurveySummary: AiSurveySummaryData;
  aiSurveySummaryAbTest: AiSurveySummaryAbTestData;
  arielAiChat: ArielAiChatData;
  getProcessKeywords: GetProcessKeywordsData;
  getProcessReport: ProcessReportInfoSub;
  /** Return all informations for report */
  getReport: PubReport;
  watchSurveyGroupChanges?: Maybe<SurveyGroupChange>;
};


/** Root subscription type. */
export type SubscriptionAiSurveySummaryArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  languageCode: Scalars['String']['input'];
  systemMessage?: InputMaybe<Scalars['String']['input']>;
};


/** Root subscription type. */
export type SubscriptionAiSurveySummaryAbTestArgs = {
  accessToken: Scalars['String']['input'];
  answers?: InputMaybe<Array<QuestionWithAnswer>>;
  defaultSystemMessage: Scalars['String']['input'];
  languageCode: Scalars['String']['input'];
};


/** Root subscription type. */
export type SubscriptionArielAiChatArgs = {
  graph: Array<ArielAiNodeDataInput>;
  languageCode: Scalars['String']['input'];
  messages: Array<ArielAiChatMessageInput>;
  topicId: Scalars['ID']['input'];
};


/** Root subscription type. */
export type SubscriptionGetProcessKeywordsArgs = {
  accessToken: Scalars['String']['input'];
  answersIds: Array<Scalars['String']['input']>;
  generate: Scalars['Boolean']['input'];
  languageCode: Scalars['String']['input'];
  questionIdx: Scalars['String']['input'];
};


/** Root subscription type. */
export type SubscriptionGetProcessReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  managerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  positionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  recruiterIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  respondentFilter?: InputMaybe<Array<Scalars['ID']['input']>>;
  showOnlyUnread?: InputMaybe<Scalars['Boolean']['input']>;
  teamFilters?: InputMaybe<Array<Scalars['String']['input']>>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Root subscription type. */
export type SubscriptionGetReportArgs = {
  accessToken: Scalars['String']['input'];
  addedOnFrom?: InputMaybe<Scalars['Date']['input']>;
  addedOnTo?: InputMaybe<Scalars['Date']['input']>;
  filters?: InputMaybe<Array<Filter>>;
  languageCode?: InputMaybe<Scalars['String']['input']>;
  publicAccess?: InputMaybe<Scalars['Boolean']['input']>;
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};


/** Root subscription type. */
export type SubscriptionWatchSurveyGroupChangesArgs = {
  surveyGroupId: Scalars['ID']['input'];
};

export enum SubscriptionDuration {
  Month = 'MONTH',
  Year = 'YEAR'
}

/**
 * Survey binds one topic to respondents that will be surveyed.
 * Will send emails with channel links to recipients on scheduled time.
 */
export type Survey = {
  __typename?: 'Survey';
  /** Access key for public survey */
  accessKey?: Maybe<Scalars['String']['output']>;
  /** Survey settings regarding anonymity */
  anonymitySettings: AnonymitySettings;
  /** Date when was the survey archived, null if not archived */
  archivedAt?: Maybe<Scalars['Date']['output']>;
  /** Documents attached to this survey */
  attachments: Array<SurveyAttachment>;
  availableInLanguages: Array<Language>;
  /** Channels where responders answer surveys. Only when ONGOING || FINISHED */
  channels?: Maybe<Array<Channel>>;
  /** When survey was created */
  createdAt: Scalars['Date']['output'];
  /** When survey will end. When it ends it will finish all channels */
  endsAt?: Maybe<Scalars['Date']['output']>;
  hasReports: Scalars['Boolean']['output'];
  /** ID of survey */
  id: Scalars['ID']['output'];
  /** If this survey is finished, respondents cannot answer questions anymore */
  isFinished: Scalars['Boolean']['output'];
  /** True when the topic requires Internal approval and the survey report is not yet approved */
  isReportPendingApproval: Scalars['Boolean']['output'];
  /** default js report short id for survey topic */
  jsReportShortId?: Maybe<Scalars['String']['output']>;
  keywordsGenerated: Scalars['Boolean']['output'];
  keywordsVersion: Scalars['Int']['output'];
  /** Language of survey */
  languageCode?: Maybe<Scalars['String']['output']>;
  /** Stored company-wide values of identified report metrics, created when the results are released (Internal only) */
  metricsSnapshot?: Maybe<SurveyMetricsSnapshot>;
  notstartedReason?: Maybe<NotstartedSurveyReason>;
  /** Organization that ordered this survey. */
  organization: Organization;
  /** If survey is free to all users */
  public?: Maybe<Scalars['Boolean']['output']>;
  publicChannels: Array<PublicChannel>;
  /** Who this survey is for. Those teams need to be in same org */
  recipients: Array<Team>;
  /** Survey reminders */
  reminders: Array<Reminder>;
  /** Whether Internal has approved the client-facing report */
  reportApproved: Scalars['Boolean']['output'];
  /** Report definition ID */
  reportDefinitionId?: Maybe<Scalars['ID']['output']>;
  /** note for report */
  reportNote?: Maybe<Scalars['String']['output']>;
  /** Params for report genratero */
  reportParams?: Maybe<Scalars['String']['output']>;
  reportRecipients?: Maybe<Array<Maybe<ReportRecipient>>>;
  /** Free-text grouping key for metric calculation */
  reportSeries?: Maybe<Scalars['String']['output']>;
  /** List of reports for this survey */
  reports?: Maybe<Array<ReportAccess>>;
  respondentIds: Array<Scalars['ID']['output']>;
  /** Aggregate results info */
  resultsInfo?: Maybe<SurveyResultsInfo>;
  /** Time when this survey is scheduled to be send */
  sendAt: Scalars['Date']['output'];
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: Maybe<Scalars['Boolean']['output']>;
  /** Survey status */
  status: SurveyStatus;
  /** Survey group where survey belongs to */
  surveyGroup?: Maybe<SurveyGroup>;
  teamIds: Array<Maybe<Scalars['ID']['output']>>;
  /** Results info aggregated by teams */
  teamsResultInfo?: Maybe<Array<Maybe<TeamsSurveyResultsInfo>>>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: Maybe<Scalars['Boolean']['output']>;
  /** Top level report for this survey */
  topLevelReport?: Maybe<ReportAccess>;
  /** Surveyed topic */
  topic?: Maybe<Topic>;
  /** Surveyed topic group */
  topicGroup?: Maybe<TopicGroup>;
  /** When survey was last time updated */
  updatedAt: Scalars['Date']['output'];
  /** User which created survey */
  user: User;
  /** Who this survey is for. Whitelist with respondents. */
  whitelistedRespondents: Array<Respondent>;
  whitelistedRespondentsLength?: Maybe<Scalars['Int']['output']>;
};

/** Descriptor for survey anonymity */
export type SurveyAnonymityInput = {
  allowedLevels?: InputMaybe<Array<InputMaybe<AnonymityLevel>>>;
  /**
   * Default anonymity for channels that are created from this survey.
   * Will default to ORGANIZATION
   */
  default?: InputMaybe<AnonymityLevel>;
};

export type SurveyAttachment = {
  __typename?: 'SurveyAttachment';
  /** Upload timestamp */
  createdAt: Scalars['Date']['output'];
  /** ID of attachment record */
  id: Scalars['ID']['output'];
  /** MIME type as reported on upload */
  mimeType: Scalars['String']['output'];
  /** Original file name */
  originalName: Scalars['String']['output'];
  /** File size in bytes */
  sizeBytes: Scalars['Int']['output'];
};

export type SurveyFilterInput = {
  endsAtTo?: InputMaybe<Scalars['Date']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  sendAtFrom?: InputMaybe<Scalars['Date']['input']>;
  status?: InputMaybe<Array<SurveyStatus>>;
  topic?: InputMaybe<Scalars['String']['input']>;
};

export type SurveyGroup = {
  __typename?: 'SurveyGroup';
  from?: Maybe<Scalars['Date']['output']>;
  groupedRespondents: Array<GroupedRespondents>;
  hasOutOfLicenceInterval?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isAnySurveyComplete: Scalars['Boolean']['output'];
  isDefault: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  notstartedReason?: Maybe<Array<NotstartedSurveyReason>>;
  organization?: Maybe<Organization>;
  reportRecipients?: Maybe<Array<Maybe<ReportRecipient>>>;
  reports: Array<ReportAccess>;
  statistics?: Maybe<ReportBasicStatistics>;
  status: ProcessStatus;
  steps: Array<SurveyGroupStep>;
  surveyGroupRespondents?: Maybe<Array<SurveyGroupRespondent>>;
  to?: Maybe<Scalars['Date']['output']>;
  /** Top level report for this survey group */
  topLevelReport?: Maybe<ReportAccess>;
  topicGroup: TopicGroup;
  topicGroupId: Scalars['ID']['output'];
};

export type SurveyGroupChange = {
  __typename?: 'SurveyGroupChange';
  surveyGroupId: Scalars['ID']['output'];
};

export type SurveyGroupRespondent = {
  __typename?: 'SurveyGroupRespondent';
  addedOn?: Maybe<Scalars['Date']['output']>;
  deleted: Scalars['Boolean']['output'];
  isCompleted?: Maybe<Scalars['Boolean']['output']>;
  numberOfSurveys?: Maybe<Scalars['Int']['output']>;
  respondent: Respondent;
  respondentId: Scalars['ID']['output'];
  respondentStatus?: Maybe<SurveyGroupRespondentStatus>;
  surveyGroup: SurveyGroup;
  surveyGroupId: Scalars['ID']['output'];
};

export type SurveyGroupRespondentImport = {
  id: Scalars['ID']['input'];
  settings: Array<SurveyGroupRespondentSettings>;
};

export type SurveyGroupRespondentImportInput = {
  id: Scalars['ID']['input'];
  type?: InputMaybe<SurveyGroupRespondentImportType>;
};

export enum SurveyGroupRespondentImportType {
  ChangeDate = 'change_date',
  CreateNewRun = 'create_new_run'
}

export type SurveyGroupRespondentSettings = {
  addedOn: Scalars['String']['input'];
  respondentEmails: Array<Scalars['String']['input']>;
};

export enum SurveyGroupRespondentStatus {
  Canceled = 'CANCELED',
  Completed = 'COMPLETED',
  Notplanned = 'NOTPLANNED',
  Ongoing = 'ONGOING',
  Prepared = 'PREPARED'
}

export type SurveyGroupRespondentWithDetails = {
  __typename?: 'SurveyGroupRespondentWithDetails';
  addedOn: Scalars['Date']['output'];
  answers: Array<MetricAnswer>;
  channels?: Maybe<Array<Channel>>;
  creditsToReturn?: Maybe<Scalars['Int']['output']>;
  deleted: Scalars['Boolean']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  hiringAdditionalData?: Maybe<Array<HiringAdditionalData>>;
  hiringSurveys?: Maybe<Array<Survey>>;
  isCreatingSurveys: Scalars['Boolean']['output'];
  isLastRun: Scalars['Boolean']['output'];
  recruiterName: Scalars['String']['output'];
  recruitmentId?: Maybe<Scalars['String']['output']>;
  respondent: Respondent;
  surveys: Array<Survey>;
  undeliveredInvitations?: Maybe<Array<Maybe<UndeliveredInvitations>>>;
};

export type SurveyGroupRespondents = {
  __typename?: 'SurveyGroupRespondents';
  data: Array<SurveyGroupRespondentWithDetails>;
  totalCount: Scalars['Int']['output'];
};

export type SurveyGroupRespondentsResult = {
  __typename?: 'SurveyGroupRespondentsResult';
  data: Array<GroupedRespondents>;
  totalCount: Scalars['Int']['output'];
};

export type SurveyGroupStep = {
  __typename?: 'SurveyGroupStep';
  avgMetric?: Maybe<Scalars['Float']['output']>;
  channels: Array<Channel>;
  daysFromStart: Scalars['Int']['output'];
  hasMetricQuestion: Scalars['Boolean']['output'];
  hasNotStarted?: Maybe<Scalars['Boolean']['output']>;
  hasOutOfLicenceInterval?: Maybe<Scalars['Boolean']['output']>;
  notstartedReason?: Maybe<Array<NotstartedSurveyReason>>;
  processStep: ProcessStep;
  reportDefinition?: Maybe<PubReportDefinition>;
  statistics?: Maybe<ReportBasicStatistics>;
  status: ProcessStatus;
  surveyGroupId: Scalars['Int']['output'];
  surveys: Array<BasicSurveyInfo>;
};

/**
 * Company-wide values of the identified metrics of a survey's primary report definition, stored once for trends
 * and benchmarks. Organization data is copied as it was when the snapshot was created.
 */
export type SurveyMetricsSnapshot = {
  __typename?: 'SurveyMetricsSnapshot';
  /** Organization number of employees */
  companySize?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  /** Map of metric identifier to { value: Float | null, count: Int } */
  metrics: Scalars['JSON']['output'];
  /** Non-public snapshots are excluded from leaderboard and benchmark inputs */
  public: Scalars['Boolean']['output'];
  /** Report definition version the values were calculated from */
  reportDefinitionId: Scalars['ID']['output'];
  reportSeries: Scalars['String']['output'];
  /** Organization industry code */
  sector?: Maybe<Scalars['String']['output']>;
};

/**
 * Survey binds one topic to respondents that will be surveyed.
 * Will send emails with channel links to recipients on scheduled time.
 */
export type SurveyPublicInfo = {
  __typename?: 'SurveyPublicInfo';
  endsAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  organizationName: Scalars['String']['output'];
  status: SurveyStatus;
  topicGroupName?: Maybe<Scalars['String']['output']>;
};

/** Reminder to be sent at given time */
export type SurveyReminderInput = {
  /** Time when is the reminder supposed to be sent */
  reminderAt: Scalars['Date']['input'];
};

export type SurveyRespondentImport = {
  id: Scalars['ID']['input'];
  respondentEmails: Array<Scalars['String']['input']>;
};

/** Aggregate info about results of survey */
export type SurveyResultsInfo = {
  __typename?: 'SurveyResultsInfo';
  /** Number of anonymous channels */
  anonymous: Scalars['Int']['output'];
  /** Number of channels with answer from user */
  answered: Scalars['Int']['output'];
  /**
   * Average time it takes respondent to finish this survey.
   * TODO: interval scalar
   */
  avgFinishTime?: Maybe<Scalars['Interval']['output']>;
  /** Number of finished channels */
  finished: Scalars['Int']['output'];
  /** Total number of channels */
  total: Scalars['Int']['output'];
  /** Number of channels with problems */
  withProblems: Scalars['Int']['output'];
};

/** Survey status */
export enum SurveyStatus {
  /** Survey is being activated and email are being sent */
  Activating = 'ACTIVATING',
  /** Survey was automatically anonymized after 25 months */
  Anonymized = 'ANONYMIZED',
  /** Survey is not active, ends_at date is in past and archived column is set to true.It does not mean that survey is archived in report_data_storage! */
  Archived = 'ARCHIVED',
  /** Survey is not active, ends_at date is in past */
  Completed = 'COMPLETED',
  /** Survey not started */
  Notstarted = 'NOTSTARTED',
  /** Survey is active, send_at date is in past and ends_at date is in future */
  Ongoing = 'ONGOING',
  /** Survey is not active, send_at date is in future */
  Prepared = 'PREPARED'
}

/**
 * Team groups respondents.
 * Surveys can be send to specific teams in organization
 */
export type Team = {
  __typename?: 'Team';
  /** ID of team */
  id: Scalars['ID']['output'];
  /** Team Leader */
  leader?: Maybe<Respondent>;
  /** Respondents that belong to this team */
  members: Array<Respondent>;
  /** Name of team */
  name?: Maybe<Scalars['String']['output']>;
  /** Parent organization */
  organization: Organization;
  /** Is it rootTeam in tree structure?(leader is CEO) */
  rootTeam: Scalars['Boolean']['output'];
  /** Team unique identificator */
  structureId?: Maybe<Scalars['String']['output']>;
  /** supervisor team in org structure */
  supervisorTeam?: Maybe<Team>;
  teamLeaderId?: Maybe<Scalars['ID']['output']>;
};

export type TeamInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  supervisorTeam?: InputMaybe<Scalars['String']['input']>;
};

/** survey results info for team */
export type TeamsSurveyResultsInfo = {
  __typename?: 'TeamsSurveyResultsInfo';
  resultInfo: SurveyResultsInfo;
  team: Team;
  /** team member ids from channels - is basically the team structure from the moment of survey creation */
  teamMemberIdsFromChannels: Array<Scalars['ID']['output']>;
};

/** Text file to be downloaded */
export type TextFile = {
  __typename?: 'TextFile';
  /** UTF-8 encoded file contents */
  contents: Scalars['String']['output'];
  /** Mimetype of file, like Content-Type header */
  mimetype: Scalars['String']['output'];
  /** Name of file, like filename in Content-Disposition header */
  name: Scalars['String']['output'];
};

/** Rule that can match regular expression. */
export type TextRule = Rule & {
  __typename?: 'TextRule';
  /** anonymity */
  anonymity?: Maybe<AnonymityLevel>;
  /** Alert level of question */
  answersToHighlight?: Maybe<Array<Scalars['ID']['output']>>;
  /** id of rule */
  id: Scalars['ID']['output'];
  /** Is from default - rule is created from question default rule */
  isFromDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Next state that FSM will transition to if this rule matches */
  nextQuestion: QuestionDefinition;
  /** Rule Operator */
  operator?: Maybe<RuleOperator>;
  /** Order of rule */
  order: Scalars['Int']['output'];
  /** Original rule value */
  origValue: Scalars['String']['output'];
  /** expression for this rule */
  value?: Maybe<Scalars['RegExp']['output']>;
};

export enum TimePeriod {
  Month = 'MONTH'
}

/**
 * Topic is conversation template, it contains question tree with rules that determine
 * whats next question based on answer.
 */
export type Topic = {
  __typename?: 'Topic';
  /** Flattened question definitions that can be answered */
  allAnswerables: Array<Answerable>;
  /** Flattened questions */
  allQuestions: Array<QuestionDefinition>;
  /** default allowed anonymities for topic */
  allowedAnonymities?: Maybe<Array<Maybe<AnonymityLevel>>>;
  commentGroups?: Maybe<Array<CommentGroup>>;
  /** When topic was created */
  createdAt: Scalars['Date']['output'];
  /** default anonymity for topic */
  defaultAnonymity?: Maybe<AnonymityLevel>;
  /** Description of topic */
  description?: Maybe<Scalars['String']['output']>;
  /** ID of topic */
  id: Scalars['ID']['output'];
  /** Indicate if topic is ready for new surveys */
  isApproved?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic can be edited - planned and ongoing topics are not editable */
  isEditable?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic is used only for testing purposes */
  isTesting?: Maybe<Scalars['Boolean']['output']>;
  /** Indicate if topic is valid */
  isValid?: Maybe<Scalars['Boolean']['output']>;
  /** Language IDs of translations that are on the starting question */
  languageIdsOnStartingQuestion: Array<Scalars['ID']['output']>;
  /** All topic languages. */
  languages: Array<TopicLanguage>;
  /** Newest report definition specified for this topic */
  lastValidReportDefinition?: Maybe<ReportList>;
  /** Short identification for humans */
  name: Scalars['String']['output'];
  numberOfComments?: Maybe<Scalars['Int']['output']>;
  /** specified message template uid for reminder message */
  reminderTemplate?: Maybe<Scalars['String']['output']>;
  /** First question in topic, bot initiates conversation with this */
  startingQuestion: QuestionDefinition;
  /** Topic group to which topic belongs */
  topicGroup: TopicGroup;
  /** When topic was updated */
  updatedAt: Scalars['Date']['output'];
  updatedBy?: Maybe<User>;
  /** specified message template uid for welcome message */
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

export type TopicDetail = {
  __typename?: 'TopicDetail';
  approved: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
  topic?: Maybe<Topic>;
  topicGroup?: Maybe<TopicGroup>;
};

export type TopicGroup = {
  __typename?: 'TopicGroup';
  accessKeys?: Maybe<Array<TopicGroupAccess>>;
  allowedAnonymities: Array<AnonymityLevel>;
  categoryCode?: Maybe<Scalars['String']['output']>;
  categoryName?: Maybe<Scalars['String']['output']>;
  chatSatisfactionScale?: Maybe<Scalars['Int']['output']>;
  containsSteps: Scalars['Boolean']['output'];
  defaultAnonymity: AnonymityLevel;
  deleteRespondents?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hideOnboardingParts?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  languages?: Maybe<Array<Language>>;
  lastSurvey?: Maybe<Survey>;
  lastSurveyGroup?: Maybe<SurveyGroup>;
  lastValidTopic?: Maybe<Topic>;
  limitedMode?: Maybe<Scalars['String']['output']>;
  /** Minimum time in seconds a respondent must take to fill the survey; responses below this threshold are auto-deactivated */
  minimumFillingTimeSecs?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  /** Organization owning this topic group */
  organization?: Maybe<Organization>;
  parentTopicGroup?: Maybe<TopicGroup>;
  /** Products / business units in which this public topic group is available (SysAdmin only) */
  productTopicGroups: Array<ProductTopicGroup>;
  questionOrderManuallyModified?: Maybe<Scalars['Boolean']['output']>;
  questionOrderModified?: Maybe<Scalars['Boolean']['output']>;
  reminder1Template?: Maybe<Scalars['String']['output']>;
  reminder2Template?: Maybe<Scalars['String']['output']>;
  reminder3Template?: Maybe<Scalars['String']['output']>;
  reports: Array<ReportList>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval: Scalars['Boolean']['output'];
  steps?: Maybe<Array<ProcessStep>>;
  topics?: Maybe<Array<Topic>>;
  translations?: Maybe<Array<TopicGroupTranslation>>;
  typeCode?: Maybe<TopicGroupTypeCode>;
  welcomeTemplate?: Maybe<Scalars['String']['output']>;
};

export type TopicGroupAccess = {
  __typename?: 'TopicGroupAccess';
  accessKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  level: Scalars['String']['output'];
  topicGroupId: Scalars['ID']['output'];
};

export type TopicGroupFilterInput = {
  /** Only topic groups not owned by any organization */
  onlyPublic?: InputMaybe<Scalars['Boolean']['input']>;
  organization?: InputMaybe<Scalars['String']['input']>;
  topic?: InputMaybe<Scalars['String']['input']>;
  topicGroup?: InputMaybe<Scalars['String']['input']>;
};

export type TopicGroupTranslation = {
  __typename?: 'TopicGroupTranslation';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  language: Language;
  topicGroup?: Maybe<TopicGroup>;
  topicGroupId?: Maybe<Scalars['ID']['output']>;
  value: Scalars['String']['output'];
};

/** type of topic group mainly useto distinguish process topic groups */
export enum TopicGroupTypeCode {
  Exit = 'EXIT',
  Hiring = 'HIRING',
  HiringFms = 'HIRING_FMS',
  Onboarding = 'ONBOARDING',
  Pulse = 'PULSE',
  Pulser = 'PULSER'
}

export type TopicGroupsData = {
  __typename?: 'TopicGroupsData';
  data: Array<TopicGroup>;
  totalCount: Scalars['Int']['output'];
};

export type TopicInput = {
  /** Topic group description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** if topic is approved */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** if topic is used only for testing purposes */
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  /** if topic is valid */
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language - iso of new topic */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Language id of new topic */
  languageId?: InputMaybe<Scalars['ID']['input']>;
  previousTopicId?: InputMaybe<Scalars['ID']['input']>;
  /** Id of topic group */
  topicGroupId: Scalars['ID']['input'];
  /** Id of new topic */
  topicId?: InputMaybe<Scalars['ID']['input']>;
  /** Team Notes */
  topicName: Scalars['String']['input'];
};

export type TopicLanguage = {
  __typename?: 'TopicLanguage';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
};

export type TopicMessageTemplate = {
  __typename?: 'TopicMessageTemplate';
  messageTemplateId: Scalars['ID']['output'];
  messageType: MessageTemplateUid;
  topicId: Scalars['ID']['output'];
};

export enum TranslationStatus {
  SameAsSource = 'same_as_source',
  SourceChanged = 'source_changed'
}

export type TwilioLookUpResponse = {
  __typename?: 'TwilioLookUpResponse';
  countryCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  specifiedPhoneNumber: Scalars['String']['output'];
  twilioError?: Maybe<TwilioLookUpResponseErr>;
};

export type TwilioLookUpResponseErr = {
  __typename?: 'TwilioLookUpResponseErr';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

/** Enum to determine if typing started or ended */
export enum TypingEventType {
  /** Typing ended */
  End = 'END',
  /** Typing started */
  Start = 'START'
}

export type UndeliveredInvitation = {
  __typename?: 'UndeliveredInvitation';
  contact: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  surveyId: Scalars['ID']['output'];
};

export type UndeliveredInvitations = {
  __typename?: 'UndeliveredInvitations';
  respondentId: Scalars['ID']['output'];
  undeliveredSurveyInvitations?: Maybe<Array<UndeliveredInvitation>>;
};

export type UnreadMessages = {
  __typename?: 'UnreadMessages';
  count?: Maybe<Scalars['Int']['output']>;
  from?: Maybe<Scalars['Date']['output']>;
};

export type UpdateCommentInput = {
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
};

/** Organization configuration */
export type UpdateOrganizationConfigInput = {
  /** Default country calling code */
  countryCallingCode?: InputMaybe<Scalars['String']['input']>;
  /** send team reports to teamleaders */
  countryCode?: InputMaybe<Scalars['String']['input']>;
  /** Organization id */
  organizationId: Scalars['ID']['input'];
  /** Language code of organization. Code is ISO 639-1 */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  /** Timezone */
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  /** Allowed survey languages for organization. Code is ISO 639-1 */
  allowedLanguages?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Change organization status to ARCHIVED. To archive organization pass true, to unarchive organization pass false */
  archiveOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Business unit of the organization */
  businessUnit?: InputMaybe<BusinessUnit>;
  /** Source channel */
  channel?: InputMaybe<Scalars['String']['input']>;
  /** CIN (IČO) for integration with other systems */
  companyId?: InputMaybe<Scalars['String']['input']>;
  /** Allowed topics or topic groups for organization */
  conversationSubjects?: InputMaybe<Array<ConversationSubjectInput>>;
  country?: InputMaybe<Scalars['String']['input']>;
  /** Custom organization name */
  customName?: InputMaybe<Scalars['String']['input']>;
  /** ID of the default onboarding SG */
  defaultOnboardingId?: InputMaybe<Scalars['ID']['input']>;
  /** External ID for integration with other systems (Teamio etc.) */
  externalUid?: InputMaybe<Scalars['String']['input']>;
  garantEmail?: InputMaybe<Scalars['String']['input']>;
  /** ID of organizations group */
  groupOrganizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization id */
  id: Scalars['ID']['input'];
  industry?: InputMaybe<Scalars['String']['input']>;
  /** Organization language code */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Licence count */
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  /** custom attribute do DB */
  microlearningAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimal team size to generate report */
  minimalTeamSizeToGenerateReport?: InputMaybe<Scalars['Int']['input']>;
  /** Minimal team size to keep anonymity */
  minimalTeamSizeToKeepAnonymity?: InputMaybe<Scalars['Int']['input']>;
  numberOfEmployees?: InputMaybe<Scalars['Int']['input']>;
  /** ID of originator */
  originatorId?: InputMaybe<Scalars['ID']['input']>;
  processNotificationsDefault?: InputMaybe<NotificationLevel>;
  processNotificationsLocked?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of organization purchased product name */
  product?: InputMaybe<Scalars['String']['input']>;
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** Organiation name */
  systemName?: InputMaybe<Scalars['String']['input']>;
  testOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization valid period */
  validPeriod?: InputMaybe<Scalars['Int']['input']>;
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProcessStepInput = {
  candidateLanguageCode?: InputMaybe<Scalars['String']['input']>;
  copyTg?: InputMaybe<Scalars['Boolean']['input']>;
  customFieldsCheck?: InputMaybe<Array<CustomFieldsCheckInput>>;
  endOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  eventDateField?: InputMaybe<Scalars['String']['input']>;
  payloadCheck?: InputMaybe<Array<PayloadCheckInput>>;
  previousEventsCheck?: InputMaybe<Array<PreviousEventsCheckInput>>;
  remindersOffsetMins?: InputMaybe<Array<Scalars['Int']['input']>>;
  startOffsetMins?: InputMaybe<Scalars['Int']['input']>;
  triggeredOn?: InputMaybe<Scalars['String']['input']>;
  useEmailFromNote?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateProductVersionInput = {
  boughtCredits?: InputMaybe<Scalars['Float']['input']>;
  licenceCount?: InputMaybe<Scalars['Int']['input']>;
  product?: InputMaybe<Scalars['String']['input']>;
  productHistorySurveyTypes?: InputMaybe<Array<InputMaybe<ProductHistorySurveyTypeInput>>>;
  rescheduleOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  transferredCredits?: InputMaybe<Scalars['Float']['input']>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  validFrom?: InputMaybe<Scalars['Date']['input']>;
  validTo?: InputMaybe<Scalars['Date']['input']>;
};

export type UpdateRespondentFromReportInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
};

export type UpdateRespondentInput = {
  /** All respondent contacts */
  contacts?: InputMaybe<Array<ContactInput>>;
  /** is Respondent disabled - all channels will be disabled */
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** First name of user */
  firstname?: InputMaybe<Scalars['String']['input']>;
  /** Preferred respondent language. Code is ISO 639-1 */
  language?: InputMaybe<Scalars['String']['input']>;
  notificationTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** organization for respondent */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Organization role of respondent */
  organizationRole?: InputMaybe<UserOrgRole>;
  /** Preferred type of contact */
  preferredContactType?: InputMaybe<ContactType>;
  /** Teams for which respondent will receive reports */
  reportTeamIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  /** Last name of user */
  surname?: InputMaybe<Scalars['String']['input']>;
  /** Team to which respondent belong */
  teamId?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters for updateSurvey mutation */
export type UpdateSurveyInput = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** Descriptor for anonymity related behaviour */
  anonymity?: InputMaybe<SurveyAnonymityInput>;
  /** Conversation subject to start */
  conversationSubjectId?: InputMaybe<Scalars['ID']['input']>;
  /** Conversation subject type */
  conversationSubjectType?: InputMaybe<ConversationSubjectType>;
  /** When survey ends. Must be later than sendAt */
  endsAt?: InputMaybe<Scalars['Date']['input']>;
  forceActivation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language of survey. Topic must have translation for this language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Only allowed channels for these recipients */
  recipientIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Reminders to be sent at specified time. */
  reminders?: InputMaybe<Array<SurveyReminderInput>>;
  /** ID of report definition */
  reportDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  reportNote?: InputMaybe<Scalars['String']['input']>;
  reportParams?: InputMaybe<Scalars['String']['input']>;
  /** Free-text grouping key for metric calculation */
  reportSeries?: InputMaybe<Scalars['String']['input']>;
  respondentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** When survey sends out invitation emails and becomes ONGOING */
  sendAt?: InputMaybe<Scalars['Date']['input']>;
  /** Survey invitation and reminders will be send to both contacts - email and sms */
  sendEmailSms?: InputMaybe<Scalars['Boolean']['input']>;
  /** Reference date for the survey group respondents */
  seqDate?: InputMaybe<Scalars['Date']['input']>;
  /** Id of survey group for the survey */
  surveyGroupId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates wheter survey runs in test mode or not */
  testing?: InputMaybe<Scalars['Boolean']['input']>;
  welcomeTemplateUid?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  supervisorTeamId?: InputMaybe<Scalars['ID']['input']>;
  teamLeaderId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  systemRole?: InputMaybe<UserSysRole>;
};

export type User = {
  __typename?: 'User';
  /** list of allowed organizations for user - based on user role */
  allowedMoreOrganizations: Scalars['Boolean']['output'];
  /** list of allowed organizations for user - based on user role */
  allowedOrganizations: Array<Organization>;
  /** flag if user changed password */
  changedPassword: Scalars['Boolean']['output'];
  consent: Scalars['Boolean']['output'];
  createdAt?: Maybe<Scalars['Date']['output']>;
  /** users first name */
  firstname?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  intercomHash?: Maybe<Scalars['String']['output']>;
  marketingConsent: Scalars['Boolean']['output'];
  optValidTo?: Maybe<Scalars['Date']['output']>;
  /** if user is ORG admin */
  organization?: Maybe<Organization>;
  otp?: Maybe<Scalars['String']['output']>;
  /** list of all users respondents */
  respondents?: Maybe<Array<Respondent>>;
  summaryNotifications: Scalars['Boolean']['output'];
  /** users last name */
  surname?: Maybe<Scalars['String']['output']>;
  /** user role org/sys admin */
  systemRole: UserSysRole;
  username: Scalars['String']['output'];
};

export type UserInput = {
  /** user calling code */
  callingCode?: InputMaybe<Scalars['String']['input']>;
  /** users email and login */
  email: Scalars['String']['input'];
  /** First name of user */
  firstname?: InputMaybe<Scalars['String']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  /** Organization role of user */
  orgRole?: InputMaybe<UserOrgRole>;
  /** organization for users of type ORG_ADMIN and REPORT */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** user phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** UID of message template for registration message */
  registrationTemplateUid?: InputMaybe<Scalars['String']['input']>;
  /** Last name of user */
  surname?: InputMaybe<Scalars['String']['input']>;
  /** System role of user */
  sysRole?: InputMaybe<UserSysRole>;
  /** username  */
  username?: InputMaybe<Scalars['String']['input']>;
};

export enum UserOrgRole {
  /** organization admin */
  OrgAdmin = 'ORG_ADMIN',
  /** respondent in organization - default */
  OrgRespondent = 'ORG_RESPONDENT'
}

export enum UserSysRole {
  /** system admin */
  SysAdmin = 'SYS_ADMIN',
  /** role is dependent on organization - default */
  SysUser = 'SYS_USER'
}

export type Widget = {
  __typename?: 'Widget';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
};

export type CreateTopicGroupInput = {
  /** Topic group allowed Anonymities. Default value is [ORGANIZATION,NONE] */
  allowedAnonymities?: InputMaybe<Array<AnonymityLevel>>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** True if topic group contains a sequence of topic groups */
  containsSteps?: InputMaybe<Scalars['Boolean']['input']>;
  /** Topic group default anonymity. Default value is NONE */
  defaultAnonymity?: InputMaybe<AnonymityLevel>;
  deleteRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Hide onboarding parts in reports */
  hideOnboardingParts?: InputMaybe<Scalars['Boolean']['input']>;
  language: Scalars['String']['input'];
  /** Minimum filling time in seconds; must be a positive integer or null to clear */
  minimumFillingTimeSecs?: InputMaybe<Scalars['Int']['input']>;
  /** Topic group name */
  name: Scalars['String']['input'];
  /** Owner of this topic group */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Topic group default reminder template uid */
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval?: InputMaybe<Scalars['Boolean']['input']>;
  typeCode?: InputMaybe<TopicGroupTypeCode>;
  /** Topic group default welcome template uid */
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type GetProcessKeywordsData = {
  __typename?: 'getProcessKeywordsData';
  done: Scalars['Boolean']['output'];
  keywords?: Maybe<Array<QuestionLabelComments>>;
};

export type SetTopicGroupDefaultsInput = {
  /** Topic group allowed Anonymities */
  allowedAnonymities?: InputMaybe<Array<AnonymityLevel>>;
  categoryCode?: InputMaybe<Scalars['String']['input']>;
  /** Topic group default anonymity. */
  defaultAnonymity?: InputMaybe<AnonymityLevel>;
  deleteRespondents?: InputMaybe<Scalars['Boolean']['input']>;
  /** Hide onboarding parts in reports */
  hideOnboardingParts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Id of topicGroup */
  id: Scalars['ID']['input'];
  /** Minimum filling time in seconds; must be a positive integer or null to clear */
  minimumFillingTimeSecs?: InputMaybe<Scalars['Int']['input']>;
  /** Organization ID */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  /** Topic group default reminder template uid */
  reminder1Template?: InputMaybe<Scalars['String']['input']>;
  reminder2Template?: InputMaybe<Scalars['String']['input']>;
  reminder3Template?: InputMaybe<Scalars['String']['input']>;
  /** When true, client reports stay hidden and unsent until Internal approves the survey report */
  requiresReportApproval?: InputMaybe<Scalars['Boolean']['input']>;
  typeCode?: InputMaybe<TopicGroupTypeCode>;
  /** Topic group default welcome template uid */
  welcomeTemplate?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTopicInput = {
  /** Topic id */
  id: Scalars['ID']['input'];
  /** Topic is approved. If false topic will not be used for survey */
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  /** Topic name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Topic group id to which topic belongs */
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpsertTopicGroupTranslationInput = {
  /** Description translation */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Language code of translation. Code is ISO 639-1 */
  language: Scalars['String']['input'];
  /** Topic group */
  topicGroupId: Scalars['ID']['input'];
  /** Name translations */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordMutationVariables = Exact<{
  username: Scalars['String']['input'];
  origin: Origin;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: boolean };

export type SendMagicLinkMutationVariables = Exact<{
  username: Scalars['String']['input'];
  redirect?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendMagicLinkMutation = { __typename?: 'Mutation', sendMagicLink: boolean };

export type SetConsentMutationVariables = Exact<{
  consent: Scalars['Boolean']['input'];
}>;


export type SetConsentMutation = { __typename?: 'Mutation', setConsent: boolean };

export type CreateRespondentMutationVariables = Exact<{
  input: RespondentInput;
}>;


export type CreateRespondentMutation = { __typename?: 'Mutation', createRespondent: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null } };

export type UpsertTopicGroupTranslationMutationVariables = Exact<{
  language: Scalars['String']['input'];
  value: Scalars['String']['input'];
  description: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
}>;


export type UpsertTopicGroupTranslationMutation = { __typename?: 'Mutation', upsertTopicGroupTranslation: { __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null } };

export type UpdateRespondentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateRespondentInput;
}>;


export type UpdateRespondentMutation = { __typename?: 'Mutation', updateRespondent: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, originator?: RespondentOriginator | null, createdAt: any, preferredContactType: ContactType, disabled: boolean, notificationTeamIds: Array<string>, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null, team?: { __typename?: 'Team', id: string, teamLeaderId?: string | null } | null, language?: { __typename?: 'Language', id: string, code: string } | null } };

export type ChangePasswordMutationVariables = Exact<{
  newPassword: Scalars['String']['input'];
  consent?: InputMaybe<Scalars['Boolean']['input']>;
  marketingConsent?: InputMaybe<Scalars['Boolean']['input']>;
  deviceToken: Scalars['String']['input'];
}>;


export type ChangePasswordMutation = { __typename?: 'Mutation', changePassword: { __typename?: 'BaseUser', username: string } };

export type CreateSurveyGroupMutationVariables = Exact<{
  input: CreateSurveyGroupInput;
}>;


export type CreateSurveyGroupMutation = { __typename?: 'Mutation', createSurveyGroup: { __typename?: 'SurveyGroup', id: string } };

export type ImportTopicMutationVariables = Exact<{
  topic: TopicInput;
  questions: Array<QuestionDefinitionInput> | QuestionDefinitionInput;
  isTesting?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderManuallyModified?: InputMaybe<Scalars['Boolean']['input']>;
  questionOrderModified?: InputMaybe<Scalars['Boolean']['input']>;
  translateViaAi?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ImportTopicMutation = { __typename?: 'Mutation', importTopic: { __typename?: 'Topic', id: string } };

export type CloneTopicWithTopicGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloneTopicWithTopicGroupMutation = { __typename?: 'Mutation', cloneTopicWithTopicGroup?: { __typename?: 'Topic', topicGroup: { __typename?: 'TopicGroup', id: string } } | null };

export type CloneProcessTopicGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CloneProcessTopicGroupMutation = { __typename?: 'Mutation', cloneProcessTopicGroup?: { __typename?: 'TopicGroup', id: string } | null };

export type AddRespondentsToSurveyGroupMutationVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
  respondents: Array<SurveyGroupRespondentImportInput> | SurveyGroupRespondentImportInput;
  addedOn: Scalars['Date']['input'];
  runOngoingSteps?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type AddRespondentsToSurveyGroupMutation = { __typename?: 'Mutation', addRespondentsToSurveyGroup: boolean };

export type CreateTopicGroupFromDefaultMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  typeCode?: InputMaybe<TopicGroupTypeCode>;
}>;


export type CreateTopicGroupFromDefaultMutation = { __typename?: 'Mutation', createTopicGroupFromDefault?: { __typename?: 'TopicGroup', id: string, topics?: Array<{ __typename?: 'Topic', id: string }> | null } | null };

export type CreateTopicGroupMutationVariables = Exact<{
  input: CreateTopicGroupInput;
}>;


export type CreateTopicGroupMutation = { __typename?: 'Mutation', createTopicGroup: { __typename?: 'TopicGroup', id: string } };

export type RemoveRespondentFromSurveyGroupMutationVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
  respondentId: Scalars['ID']['input'];
  addedOn: Scalars['Date']['input'];
}>;


export type RemoveRespondentFromSurveyGroupMutation = { __typename?: 'Mutation', removeRespondentFromSurveyGroup: boolean };

export type DeleteOrganizationSurveyMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type DeleteOrganizationSurveyMutation = { __typename?: 'Mutation', deleteOrganizationSurvey: number };

export type SetTimezoneAndCountryMutationVariables = Exact<{
  input: UpdateOrganizationConfigInput;
}>;


export type SetTimezoneAndCountryMutation = { __typename?: 'Mutation', updateOrganizationConfig: { __typename?: 'OrganizationConfig', timezone: string, countryCode?: string | null } };

export type UpdateSurveyMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  input: UpdateSurveyInput;
}>;


export type UpdateSurveyMutation = { __typename?: 'Mutation', updateSurvey: { __typename?: 'Survey', id: string, topic?: { __typename?: 'Topic', id: string } | null, topicGroup?: { __typename?: 'TopicGroup', id: string } | null } };

export type ReopenSurveyMutationVariables = Exact<{
  input: ReopenSurveyInput;
}>;


export type ReopenSurveyMutation = { __typename?: 'Mutation', reopenSurvey: { __typename?: 'Survey', id: string } };

export type SendInvitationAgainMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  respondentId: Scalars['ID']['input'];
  templateUid?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendInvitationAgainMutation = { __typename?: 'Mutation', sendInvitationAgain: boolean };

export type CreateSurveyMutationVariables = Exact<{
  input: CreateSurveyInput;
}>;


export type CreateSurveyMutation = { __typename?: 'Mutation', createSurvey: { __typename?: 'Survey', id: string, sendAt: any, topic?: { __typename?: 'Topic', id: string } | null, topicGroup?: { __typename?: 'TopicGroup', id: string } | null } };

export type CreateTestSurveyMutationVariables = Exact<{
  input: ICreateTestSurveyInput;
}>;


export type CreateTestSurveyMutation = { __typename?: 'Mutation', createTestSurvey: string };

export type CreateTeamMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  respondentId?: InputMaybe<Scalars['ID']['input']>;
  teamName?: InputMaybe<Scalars['String']['input']>;
  supervisorTeamId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name?: string | null } };

export type UpdateOrganizationConfigMutationVariables = Exact<{
  input: UpdateOrganizationConfigInput;
}>;


export type UpdateOrganizationConfigMutation = { __typename?: 'Mutation', updateOrganizationConfig: { __typename?: 'OrganizationConfig', timezone: string, countryCode?: string | null, countryCallingCode: string, organization: { __typename?: 'Organization', primaryLanguageCode: string, primaryLanguageId: number } } };

export type VerifyPhoneNumbersMutationVariables = Exact<{
  phoneNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type VerifyPhoneNumbersMutation = { __typename?: 'Mutation', verifyPhoneNumbers: Array<{ __typename?: 'TwilioLookUpResponse', specifiedPhoneNumber: string, phoneNumber?: string | null }> };

export type DeleteRespondentMutationVariables = Exact<{
  respondentId: Scalars['ID']['input'];
}>;


export type DeleteRespondentMutation = { __typename?: 'Mutation', deleteRespondent: boolean };

export type AssignOrganizationMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type AssignOrganizationMutation = { __typename?: 'Mutation', assignOrganization: boolean };

export type AcceptReportsMutationVariables = Exact<{
  reportAccepts: Array<ReportAccept> | ReportAccept;
}>;


export type AcceptReportsMutation = { __typename?: 'Mutation', acceptReports: boolean };

export type UpdateProcessStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateProcessStepInput;
}>;


export type UpdateProcessStepMutation = { __typename?: 'Mutation', updateProcessStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }> } };

export type CreateProcessStepMutationVariables = Exact<{
  input: CreateProcessStepInput;
}>;


export type CreateProcessStepMutation = { __typename?: 'Mutation', createProcessStep: { __typename?: 'ProcessStep', id: string, stepTopicGroup: { __typename?: 'TopicGroup', id: string, lastValidTopic?: { __typename?: 'Topic', id: string } | null } } };

export type CloneProcessStepMutationVariables = Exact<{
  processStepId: Scalars['ID']['input'];
}>;


export type CloneProcessStepMutation = { __typename?: 'Mutation', cloneProcessStep: { __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, stepTopicGroup: { __typename?: 'TopicGroup', id: string, lastValidTopic?: { __typename?: 'Topic', id: string } | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, language: { __typename?: 'Language', id: string, code: string } }> | null }, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }> } };

export type DeleteProcessStepMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProcessStepMutation = { __typename?: 'Mutation', deleteProcessStep: boolean };

export type RegistrationMutationVariables = Exact<{
  userInput: UserInput;
  organizationInput: RegistrationOrganizationInput;
  password: Scalars['String']['input'];
}>;


export type RegistrationMutation = { __typename?: 'Mutation', registration?: { __typename?: 'User', id: string } | null };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: string, name: string } };

export type UploadOrganizationLogoMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadOrganizationLogoMutation = { __typename?: 'Mutation', uploadOrganizationLogo: { __typename?: 'OrganizationLogo', id: string, url: string, originalName: string, createdAt: any } };

export type DeleteOrganizationLogoMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DeleteOrganizationLogoMutation = { __typename?: 'Mutation', deleteOrganizationLogo: boolean };

export type UploadSurveyAttachmentMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type UploadSurveyAttachmentMutation = { __typename?: 'Mutation', uploadSurveyAttachment: { __typename?: 'SurveyAttachment', id: string, originalName: string, mimeType: string, sizeBytes: number, createdAt: any } };

export type DeleteSurveyAttachmentMutationVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type DeleteSurveyAttachmentMutation = { __typename?: 'Mutation', deleteSurveyAttachment: boolean };

export type SetSurveyArchivedMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetSurveyArchivedMutation = { __typename?: 'Mutation', setSurveyArchived: boolean };

export type SetSurveyGroupArchivedMutationVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
  reverse?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetSurveyGroupArchivedMutation = { __typename?: 'Mutation', setSurveyGroupArchived: boolean };

export type GenerateOtpMutationVariables = Exact<{
  username: Scalars['String']['input'];
}>;


export type GenerateOtpMutation = { __typename?: 'Mutation', generateOtp: boolean };

export type SendEmailConfirmationMutationVariables = Exact<{
  email: Scalars['String']['input'];
  language: Scalars['String']['input'];
}>;


export type SendEmailConfirmationMutation = { __typename?: 'Mutation', sendEmailConfirmation: boolean };

export type ConfirmEmailMutationVariables = Exact<{
  deviceToken: Scalars['String']['input'];
}>;


export type ConfirmEmailMutation = { __typename?: 'Mutation', confirmEmail: string };

export type CreateSalesOrganizationMutationVariables = Exact<{
  input: CreateSalesOrganizationInput;
}>;


export type CreateSalesOrganizationMutation = { __typename?: 'Mutation', createSalesOrganization: { __typename?: 'Organization', id: string } };

export type ImportOrganizationMutationVariables = Exact<{
  orgId: Scalars['ID']['input'];
  respondents: Array<ImportRespondentInput> | ImportRespondentInput;
  teams: Array<TeamInput> | TeamInput;
}>;


export type ImportOrganizationMutation = { __typename?: 'Mutation', importOrganization: boolean };

export type EnableFeatureMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  feature: Features;
}>;


export type EnableFeatureMutation = { __typename?: 'Mutation', enableFeature: boolean };

export type DisableFeatureMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  feature: Features;
}>;


export type DisableFeatureMutation = { __typename?: 'Mutation', disableFeature: boolean };

export type LogFeEventMutationVariables = Exact<{
  eventType: FeEventType;
  payload: FeEventPayload;
}>;


export type LogFeEventMutation = { __typename?: 'Mutation', logFEEvent: boolean };

export type LogErrorReportMutationVariables = Exact<{
  errorReport: ErrorReportInput;
}>;


export type LogErrorReportMutation = { __typename?: 'Mutation', logErrorReport: boolean };

export type RenameSurveyGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  surveyGroupId: Scalars['ID']['input'];
}>;


export type RenameSurveyGroupMutation = { __typename?: 'Mutation', renameSurveyGroup: { __typename?: 'SurveyGroup', name?: string | null, id: string } };

export type CreateNewRespondentChannelsMutationVariables = Exact<{
  surveyId: Scalars['ID']['input'];
  respondentIds?: InputMaybe<Array<Scalars['Int']['input']> | Scalars['Int']['input']>;
}>;


export type CreateNewRespondentChannelsMutation = { __typename?: 'Mutation', createNewRespondentChannels?: Array<{ __typename?: 'Channel', id: string } | null> | null };

export type DeleteTopicGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteTopicGroupMutation = { __typename?: 'Mutation', deleteTopicGroup: boolean };

export type SendPreviewConversationMutationVariables = Exact<{
  organizationName: Scalars['String']['input'];
  topicGroupId: Scalars['ID']['input'];
  languageCode: Scalars['String']['input'];
  contactType: ContactType;
  contactValue: Scalars['String']['input'];
}>;


export type SendPreviewConversationMutation = { __typename?: 'Mutation', sendPreviewConversation: boolean };

export type SendPreviewReportMutationVariables = Exact<{
  topicGroupId: Scalars['ID']['input'];
  languageCode: Scalars['String']['input'];
  email: Scalars['String']['input'];
}>;


export type SendPreviewReportMutation = { __typename?: 'Mutation', sendPreviewReport: boolean };

export type CreatePublicSurveyMutationVariables = Exact<{
  input: CreatePublicSurveyInput;
}>;


export type CreatePublicSurveyMutation = { __typename?: 'Mutation', createPublicSurvey: { __typename?: 'Survey', id: string, accessKey?: string | null, topic?: { __typename?: 'Topic', name: string } | null } };

export type CreateCommentMutationVariables = Exact<{
  input: CreateCommentInput;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', createComment: { __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null } };

export type CreateCommentGroupMutationVariables = Exact<{
  input: CreateCommentGroupInput;
}>;


export type CreateCommentGroupMutation = { __typename?: 'Mutation', createCommentGroup: { __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null } };

export type DeleteCommentGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCommentGroupMutation = { __typename?: 'Mutation', deleteCommentGroup: boolean };

export type UpdateCommentGroupPositionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
}>;


export type UpdateCommentGroupPositionMutation = { __typename?: 'Mutation', updateCommentGroupPosition: { __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null } };

export type UpdateCommentMutationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateCommentMutationMutation = { __typename?: 'Mutation', updateComment: { __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null } };

export type DeleteSurveyGroupMutationVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type DeleteSurveyGroupMutation = { __typename?: 'Mutation', deleteSurveyGroup: boolean };

export type UpdateTeamMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  input: UpdateTeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name?: string | null } };

export type DeleteTeamMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
}>;


export type DeleteTeamMutation = { __typename?: 'Mutation', deleteTeam: boolean };

export type SetManualDeductionMutationVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  creditsUsed: Scalars['Float']['input'];
}>;


export type SetManualDeductionMutation = { __typename?: 'Mutation', setManualDeduction: boolean };

export type SendNewReportsMutationVariables = Exact<{
  respondentId: Scalars['ID']['input'];
  surveyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendNewReportsMutation = { __typename?: 'Mutation', sendNewReports: boolean };

export type CreateQuestionMetricMutationVariables = Exact<{
  identifier: Metrics;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
}>;


export type CreateQuestionMetricMutation = { __typename?: 'Mutation', createQuestionMetric: boolean };

export type DeleteQuestionMetricMutationVariables = Exact<{
  identifier?: InputMaybe<Metrics>;
  index: Scalars['Int']['input'];
  topicGroupId: Scalars['Int']['input'];
}>;


export type DeleteQuestionMetricMutation = { __typename?: 'Mutation', deleteQuestionMetric: boolean };

export type AiTranslateTopicNodesMutationVariables = Exact<{
  nodes: Array<AiTranslateNodeInput> | AiTranslateNodeInput;
  sourceLang: Scalars['String']['input'];
  targetLang: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AiTranslateTopicNodesMutation = { __typename?: 'Mutation', aiTranslateTopicNodes: { __typename?: 'AiTranslateTopicNodesResult', title?: string | null, description?: string | null, limitReached: boolean, nodes: Array<{ __typename?: 'AiTranslatedNode', questionIndex: number, questionText: string, choices: Array<string>, statements: Array<string>, translated: boolean }> } };

export type MarkTranslationAsReviewedMutationVariables = Exact<{
  questionDefinitionId: Scalars['ID']['input'];
  languageCode: Scalars['String']['input'];
}>;


export type MarkTranslationAsReviewedMutation = { __typename?: 'Mutation', markTranslationAsReviewed: boolean };

export type GetBaseUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBaseUserQuery = { __typename?: 'Query', isAccessTokenValid: { __typename?: 'AccessToken', status?: AccessTokenStatus | null, consent?: boolean | null, baseUser?: { __typename?: 'BaseUser', firstname?: string | null, surname?: string | null, username: string, organization?: { __typename?: 'Organization', name: string } | null } | null } };

export type CheckSsoQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckSsoQuery = { __typename?: 'Query', checkSso: SsoLoginMode };

export type IsAccessTokenValidQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAccessTokenValidQuery = { __typename?: 'Query', isAccessTokenValid: { __typename?: 'AccessToken', status?: AccessTokenStatus | null, consent?: boolean | null, user?: { __typename?: 'User', id: string, username: string, firstname?: string | null, surname?: string | null, createdAt?: any | null, systemRole: UserSysRole, consent: boolean, marketingConsent: boolean, allowedMoreOrganizations: boolean, organization?: { __typename?: 'Organization', id: string } | null } | null } };

export type DashboardQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type DashboardQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, currentSurveys: Array<{ __typename?: 'Survey', id: string, accessKey?: string | null, status: SurveyStatus, whitelistedRespondentsLength?: number | null, public?: boolean | null, isReportPendingApproval: boolean, notstartedReason?: NotstartedSurveyReason | null, sendAt: any, endsAt?: any | null, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null, topLevelReport?: { __typename?: 'ReportAccess', accessKey: string } | null, user: { __typename?: 'User', id: string }, topic?: { __typename?: 'Topic', id: string, name: string } | null, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, categoryCode?: string | null, typeCode?: TopicGroupTypeCode | null } | null, reminders: Array<{ __typename?: 'Reminder', reminderAt: any }> }>, activeProcessSurveys: Array<{ __typename?: 'SurveyGroup', from?: any | null, id: string, status: ProcessStatus, name?: string | null, hasOutOfLicenceInterval?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, topicGroup: { __typename?: 'TopicGroup', id: string, name: string, categoryCode?: string | null, typeCode?: TopicGroupTypeCode | null }, topLevelReport?: { __typename?: 'ReportAccess', accessKey: string } | null }>, activeOnboadings: Array<{ __typename?: 'SurveyGroup', id: string, name?: string | null, topicGroup: { __typename?: 'TopicGroup', id: string, name: string }, topLevelReport?: { __typename?: 'ReportAccess', accessKey: string } | null, steps: Array<{ __typename?: 'SurveyGroupStep', avgMetric?: number | null, processStep: { __typename?: 'ProcessStep', stepTopicGroup: { __typename?: 'TopicGroup', id: string, chatSatisfactionScale?: number | null, name: string } } }> }> } | null } };

export type GetRespondentsQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRespondentsQuery = { __typename?: 'Query', user: { __typename?: 'User', respondents?: Array<{ __typename?: 'Respondent', id: string, organizationRole: UserOrgRole, organization: { __typename?: 'Organization', id: string }, contacts?: Array<{ __typename?: 'Contact', source?: ContactSource | null, type: ContactType, value: string }> | null }> | null } };

export type UserQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, username: string, systemRole: UserSysRole, organization?: { __typename?: 'Organization', id: string, name: string, systemName: string, status: OrganizationStatus, primaryLanguageId: number, primaryLanguageCode: string, respondentsCount: number, enabledRespondentsCount: number, activeRespondentsInCurrentPeriodCount?: number | null, beforeFirstSurvey: boolean, featureNames?: Array<string | null> | null, languages: Array<{ __typename?: 'Language', id: string, code: string }>, productVersion?: { __typename?: 'ProductVersion', product: string, licenceCount?: number | null, validFrom: any, validTo: any } | null, productVersionHistory?: Array<{ __typename?: 'ProductVersion', product: string, licenceCount?: number | null, validFrom: any, validTo: any }> | null, config?: { __typename?: 'OrganizationConfig', timezone: string, testSurveys: number } | null, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, public?: boolean | null, archivedAt?: any | null, isReportPendingApproval: boolean, notstartedReason?: NotstartedSurveyReason | null, sendAt: any, updatedAt: any, endsAt?: any | null, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null, topLevelReport?: { __typename?: 'ReportAccess', id: string, accessKey: string } | null, topic?: { __typename?: 'Topic', id: string, name: string, description?: string | null, topicGroup: { __typename?: 'TopicGroup', id: string } } | null, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, description?: string | null, categoryCode?: string | null } | null, reminders: Array<{ __typename?: 'Reminder', reminderAt: any }>, availableInLanguages: Array<{ __typename?: 'Language', id: string, code: string }> }>, surveyGroups: Array<{ __typename?: 'SurveyGroup', from?: any | null, to?: any | null, id: string, status: ProcessStatus, name?: string | null, topicGroup: { __typename?: 'TopicGroup', id: string, name: string, typeCode?: TopicGroupTypeCode | null, categoryCode?: string | null, description?: string | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null, parentTopicGroup?: { __typename?: 'TopicGroup', id: string } | null }, reports: Array<{ __typename?: 'ReportAccess', id: string, accessKey: string, respondent?: { __typename?: 'Respondent', id: string } | null }>, statistics?: { __typename?: 'ReportBasicStatistics', total: number, answered: number } | null, steps: Array<{ __typename?: 'SurveyGroupStep', hasOutOfLicenceInterval?: boolean | null, hasNotStarted?: boolean | null, status: ProcessStatus, notstartedReason?: Array<NotstartedSurveyReason> | null, avgMetric?: number | null, processStep: { __typename?: 'ProcessStep', stepTopicGroup: { __typename?: 'TopicGroup', id: string, name: string, description?: string | null, categoryCode?: string | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null } }, surveys: Array<{ __typename?: 'BasicSurveyInfo', sendAt: any, id: string, archivedAt?: any | null }> }> }> } | null } };

export type OrganizationSurveysQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrganizationSurveysQuery = { __typename?: 'Query', organizationSurveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, public?: boolean | null, archivedAt?: any | null, isReportPendingApproval: boolean, notstartedReason?: NotstartedSurveyReason | null, sendAt: any, updatedAt: any, endsAt?: any | null, whitelistedRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null }>, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null, topLevelReport?: { __typename?: 'ReportAccess', id: string, accessKey: string } | null, user: { __typename?: 'User', id: string }, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, description?: string | null, categoryCode?: string | null, typeCode?: TopicGroupTypeCode | null } | null, reminders: Array<{ __typename?: 'Reminder', reminderAt: any }>, availableInLanguages: Array<{ __typename?: 'Language', id: string, code: string }> }> };

export type AllowedTopicGroupsQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type AllowedTopicGroupsQuery = { __typename?: 'Query', allowedTopicGroups?: Array<{ __typename?: 'TopicGroup', id: string, name: string, description?: string | null, containsSteps: boolean, typeCode?: TopicGroupTypeCode | null, categoryCode?: string | null, categoryName?: string | null, lastSurvey?: { __typename?: 'Survey', id: string, sendAt: any, endsAt?: any | null, status: SurveyStatus } | null, steps?: Array<{ __typename?: 'ProcessStep', startOffsetMins?: number | null, endOffsetMins?: number | null, triggeredOn?: string | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, language: { __typename?: 'Language', id: string, code: string } }> | null } }> | null, lastSurveyGroup?: { __typename?: 'SurveyGroup', id: string, from?: any | null, status: ProcessStatus } | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null, organization?: { __typename?: 'Organization', id: string } | null, lastValidTopic?: { __typename?: 'Topic', id: string, numberOfComments?: number | null, name: string, isValid?: boolean | null, languageIdsOnStartingQuestion: Array<string>, updatedAt: any, createdAt: any, updatedBy?: { __typename?: 'User', firstname?: string | null, surname?: string | null } | null, topicGroup: { __typename?: 'TopicGroup', id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, language: { __typename?: 'Language', id: string, code: string } }> | null }, languages: Array<{ __typename?: 'TopicLanguage', id: string, code: string }> } | null, parentTopicGroup?: { __typename?: 'TopicGroup', id: string } | null }> | null };

export type ActiveRespondentsQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ActiveRespondentsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, organization?: { __typename?: 'Organization', id: string, enabledRespondentsCount: number, name: string, activeRespondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, language?: { __typename?: 'Language', id: string, code: string } | null, team?: { __typename?: 'Team', id: string, name?: string | null } | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }>, teams: Array<{ __typename?: 'Team', id: string, name?: string | null, rootTeam: boolean, structureId?: string | null, leader?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null } | null, supervisorTeam?: { __typename?: 'Team', id: string } | null, members: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, preferredContactType: ContactType, disabled: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null, language?: { __typename?: 'Language', id: string, code: string } | null }> }> } | null } };

export type TopicGroupDetailQueryVariables = Exact<{
  topicGroupId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type TopicGroupDetailQuery = { __typename?: 'Query', topicGroup: { __typename?: 'TopicGroup', id: string, name: string, containsSteps: boolean, description?: string | null, questionOrderManuallyModified?: boolean | null, questionOrderModified?: boolean | null, accessKeys?: Array<{ __typename?: 'TopicGroupAccess', id: string, level: string, accessKey: string }> | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, id: string, description?: string | null, language: { __typename?: 'Language', id: string, code: string } }> | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null, lastValidTopic?: { __typename?: 'Topic', id: string, name: string, description?: string | null, isApproved?: boolean | null, isEditable?: boolean | null, updatedAt: any, updatedBy?: { __typename?: 'User', firstname?: string | null, surname?: string | null } | null, languages: Array<{ __typename?: 'TopicLanguage', id: string, code: string }>, startingQuestion: { __typename?: 'CommentQuestionDefinition', id: string } | { __typename?: 'EmailContactQuestionDefinition', id: string } | { __typename?: 'EndingQuestionDefinition', id: string } | { __typename?: 'FreeTextQuestionDefinition', id: string } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string } | { __typename?: 'ScaleQuestionDefinition', id: string } | { __typename?: 'SelectQuestionDefinition', id: string } | { __typename?: 'SmsContactQuestionDefinition', id: string }, allQuestions: Array<{ __typename?: 'CommentQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'EmailContactQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'EndingQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'FreeTextQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, text: string, selectedRange: any, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'ScaleQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'ArrayRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'SelectQuestionDefinition', id: string, text: string, selectedRange: any, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'ArrayRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'SmsContactQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> }>, commentGroups?: Array<{ __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null }> | null } | null } };

export type TopicDetailQueryVariables = Exact<{
  topicId?: InputMaybe<Scalars['ID']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TopicDetailQuery = { __typename?: 'Query', topicDetail: { __typename?: 'Topic', id: string, name: string, description?: string | null, isApproved?: boolean | null, isValid?: boolean | null, isEditable?: boolean | null, updatedAt: any, updatedBy?: { __typename?: 'User', firstname?: string | null, surname?: string | null } | null, languages: Array<{ __typename?: 'TopicLanguage', id: string, code: string }>, startingQuestion: { __typename?: 'CommentQuestionDefinition', id: string } | { __typename?: 'EmailContactQuestionDefinition', id: string } | { __typename?: 'EndingQuestionDefinition', id: string } | { __typename?: 'FreeTextQuestionDefinition', id: string } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string } | { __typename?: 'ScaleQuestionDefinition', id: string } | { __typename?: 'SelectQuestionDefinition', id: string } | { __typename?: 'SmsContactQuestionDefinition', id: string }, allQuestions: Array<{ __typename?: 'CommentQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'EmailContactQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'EndingQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'FreeTextQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, text: string, selectedRange: any, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'ScaleQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption: boolean, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'ArrayRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'SelectQuestionDefinition', id: string, text: string, selectedRange: any, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'AlwaysMatchingRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'ArrayRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } } | { __typename?: 'TextRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> } | { __typename?: 'SmsContactQuestionDefinition', id: string, text: string, selectedRange?: any | null, index?: number | null, reportIndex?: number | null, reportOrder?: number | null, optional?: boolean | null, randomizeOrder: boolean, isRankingScale: boolean, showEscapeOption?: boolean | null, answersToHighlight?: Array<string> | null, isFirstInSectionWithNumber?: number | null, positionX?: number | null, positionY?: number | null, metrics?: Array<Metrics> | null, isQuestionTrigger: boolean, translations: Array<{ __typename?: 'QuestionDefinitionTranslation', choices?: Array<string | null> | null, statements?: Array<string> | null, isDefault: boolean, text: string, translationStatus?: TranslationStatus | null, language: { __typename?: 'Language', id: string, code: string } }>, rules: Array<{ __typename?: 'RangeRule', id: string, origValue: string, operator?: RuleOperator | null, order: number, isFromDefault?: boolean | null, nextQuestion: { __typename?: 'CommentQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EmailContactQuestionDefinition', id: string, index?: number | null } | { __typename?: 'EndingQuestionDefinition', id: string, index?: number | null } | { __typename?: 'FreeTextQuestionDefinition', id: string, index?: number | null } | { __typename?: 'PersonMultiselectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'ScaleQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SelectQuestionDefinition', id: string, index?: number | null } | { __typename?: 'SmsContactQuestionDefinition', id: string, index?: number | null } }> }>, commentGroups?: Array<{ __typename?: 'CommentGroup', id: string, positionX: number, positionY: number, topicId: string, comments?: Array<{ __typename?: 'Comment', id: string, text: string, createdAt: any, updatedAt: any, originator?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> | null }> | null, topicGroup: { __typename?: 'TopicGroup', id: string, name: string, containsSteps: boolean, description?: string | null, questionOrderManuallyModified?: boolean | null, questionOrderModified?: boolean | null, organization?: { __typename?: 'Organization', id: string } | null, accessKeys?: Array<{ __typename?: 'TopicGroupAccess', id: string, level: string, accessKey: string }> | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, id: string, description?: string | null, language: { __typename?: 'Language', id: string, code: string } }> | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null } } };

export type SurveyQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type SurveyQuery = { __typename?: 'Query', survey?: { __typename?: 'Survey', id: string, status: SurveyStatus, public?: boolean | null, accessKey?: string | null, isReportPendingApproval: boolean, sendAt: any, endsAt?: any | null, sendEmailSms?: boolean | null, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, description?: string | null, lastValidTopic?: { __typename?: 'Topic', id: string } | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null } | null, topic?: { __typename?: 'Topic', id: string } | null, channels?: Array<{ __typename?: 'Channel', lastRemindedAt?: any | null, isFinished: boolean, answered: boolean, alert: boolean, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null } | null }> | null, whitelistedRespondents: Array<{ __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, team?: { __typename?: 'Team', id: string, name?: string | null } | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null, language?: { __typename?: 'Language', id: string, code: string } | null }>, resultsInfo?: { __typename?: 'SurveyResultsInfo', total: number, answered: number, finished: number } | null, reports?: Array<{ __typename?: 'ReportAccess', accessKey: string, respondent?: { __typename?: 'Respondent', id: string } | null }> | null, teamsResultInfo?: Array<{ __typename?: 'TeamsSurveyResultsInfo', teamMemberIdsFromChannels: Array<string>, team: { __typename?: 'Team', id: string, name?: string | null, leader?: { __typename?: 'Respondent', firstname?: string | null, surname?: string | null } | null }, resultInfo: { __typename?: 'SurveyResultsInfo', total: number, answered: number, anonymous: number } } | null> | null, reminders: Array<{ __typename?: 'Reminder', reminderAt: any }>, anonymitySettings: { __typename?: 'AnonymitySettings', default?: AnonymityLevel | null, allowedLevels?: Array<AnonymityLevel> | null } } | null };

export type SurveyAttachmentsQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type SurveyAttachmentsQuery = { __typename?: 'Query', survey?: { __typename?: 'Survey', id: string, attachments: Array<{ __typename?: 'SurveyAttachment', id: string, originalName: string, mimeType: string, sizeBytes: number, createdAt: any }> } | null };

export type SurveyAttachmentDownloadUrlQueryVariables = Exact<{
  attachmentId: Scalars['ID']['input'];
}>;


export type SurveyAttachmentDownloadUrlQuery = { __typename?: 'Query', surveyAttachmentDownloadUrl: string };

export type SurveyGroupWithRespondentsQueryVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type SurveyGroupWithRespondentsQuery = { __typename?: 'Query', surveyGroup?: { __typename?: 'SurveyGroup', id: string, surveyGroupRespondents?: Array<{ __typename?: 'SurveyGroupRespondent', respondentId: string, addedOn?: any | null, deleted: boolean, isCompleted?: boolean | null, numberOfSurveys?: number | null }> | null } | null };

export type SurveyGroupWithoutRespondentsQueryVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type SurveyGroupWithoutRespondentsQuery = { __typename?: 'Query', surveyGroup?: { __typename?: 'SurveyGroup', id: string, name?: string | null, status: ProcessStatus, topicGroup: { __typename?: 'TopicGroup', id: string, name: string, categoryCode?: string | null, typeCode?: TopicGroupTypeCode | null, description?: string | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null, languages?: Array<{ __typename?: 'Language', id: string, code: string }> | null, steps?: Array<{ __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, triggeredOn?: string | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', hasMetricQuestion: boolean, processStep: { __typename?: 'ProcessStep', startOffsetMins?: number | null, endOffsetMins?: number | null, triggeredOn?: string | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, name: string, allowedAnonymities: Array<AnonymityLevel>, defaultAnonymity: AnonymityLevel, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null, lastValidTopic?: { __typename?: 'Topic', id: string } | null } }, surveys: Array<{ __typename?: 'BasicSurveyInfo', id: string, status: SurveyStatus }> }>, topLevelReport?: { __typename?: 'ReportAccess', id: string, accessKey: string } | null } | null };

export type SurveyGroupStepStatisticsQueryVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type SurveyGroupStepStatisticsQuery = { __typename?: 'Query', surveyGroup?: { __typename?: 'SurveyGroup', id: string, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, avgMetric?: number | null, processStep: { __typename?: 'ProcessStep', startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null, lastValidTopic?: { __typename?: 'Topic', id: string } | null } }, statistics?: { __typename?: 'ReportBasicStatistics', answered: number, total: number, withProblems: number } | null }> } | null };

export type SurveyGroupRespondentsQueryVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
  pagination?: InputMaybe<Pagination>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  withoutDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SurveyGroupRespondentsQuery = { __typename?: 'Query', surveyGroupRespondents: { __typename?: 'SurveyGroupRespondents', totalCount: number, data: Array<{ __typename?: 'SurveyGroupRespondentWithDetails', addedOn: any, isLastRun: boolean, isCreatingSurveys: boolean, recruiterName: string, recruitmentId?: string | null, creditsToReturn?: number | null, deleted: boolean, deletedAt?: any | null, respondent: { __typename?: 'Respondent', id: string, preferredContactType: ContactType, firstname?: string | null, surname?: string | null, deleted: boolean, team?: { __typename?: 'Team', id: string, name?: string | null } | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null }, surveys: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, notstartedReason?: NotstartedSurveyReason | null, sendAt: any, endsAt?: any | null, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null } | null }>, channels?: Array<{ __typename?: 'Channel', finishedAt?: any | null, lastRemindedAt?: any | null, isFinishedByRespondent: boolean, allowedAnonymities: Array<AnonymityLevel>, answered: boolean, slug?: string | null, survey: { __typename?: 'Survey', id: string }, respondent?: { __typename?: 'Respondent', id: string } | null }> | null, hiringSurveys?: Array<{ __typename?: 'Survey', id: string, status: SurveyStatus, notstartedReason?: NotstartedSurveyReason | null, sendAt: any, endsAt?: any | null, topicGroup?: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null } | null, whitelistedRespondents: Array<{ __typename?: 'Respondent', id: string }> }> | null, undeliveredInvitations?: Array<{ __typename?: 'UndeliveredInvitations', respondentId: string, undeliveredSurveyInvitations?: Array<{ __typename?: 'UndeliveredInvitation', surveyId: string, contact: string, status?: string | null }> | null } | null> | null, answers: Array<{ __typename?: 'MetricAnswer', topicGroupId: string, value?: number | null }> }> } };

export type DatesForNewSurveyQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type DatesForNewSurveyQuery = { __typename?: 'Query', datesForNewSurvey: { __typename?: 'DatesForNewSurvey', sendAt: any, endsAt?: any | null, reminderAt?: any | null, secondReminderAt?: any | null } };

export type OrganizationQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, systemName: string, companyId?: string | null, primaryLanguageId: number, primaryLanguageCode: string, enabledRespondentsCount: number, respondentsCount: number, activeRespondentsInCurrentPeriodCount?: number | null, featureNames?: Array<string | null> | null, hasProcessSurveys: boolean, lastSuccessfulApiUpdate?: any | null, lastFailedApiUpdate?: any | null, languages: Array<{ __typename?: 'Language', id: string, code: string }>, productVersion?: { __typename?: 'ProductVersion', id: string, product: string, validTo: any, licenceCount?: number | null, validFrom: any, activePeriodEnd?: any | null, usedCredits?: number | null, boughtCredits?: number | null, transferredCredits?: number | null } | null, config?: { __typename?: 'OrganizationConfig', countryCode?: string | null } | null, productVersionHistory?: Array<{ __typename?: 'ProductVersion', id: string, product: string, licenceCount?: number | null, validFrom: any, validTo: any, boughtCredits?: number | null, transferredCredits?: number | null, activePeriodEnd?: any | null }> | null } | null };

export type SurveyGroupsQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SurveyGroupsQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', surveyGroups: Array<{ __typename?: 'SurveyGroup', id: string, name?: string | null, status: ProcessStatus, from?: any | null, topicGroup: { __typename?: 'TopicGroup', typeCode?: TopicGroupTypeCode | null, name: string, organization?: { __typename?: 'Organization', id: string } | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, language: { __typename?: 'Language', code: string } }> | null, steps?: Array<{ __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, triggeredOn?: string | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, language: { __typename?: 'Language', code: string } }> | null } }> | null }, statistics?: { __typename?: 'ReportBasicStatistics', total: number, answered: number } | null }> } | null };

export type OrganizationTeamsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationTeamsQuery = { __typename?: 'Query', organizationTeams: Array<{ __typename?: 'Team', id: string, name?: string | null, rootTeam: boolean, structureId?: string | null, supervisorTeam?: { __typename?: 'Team', id: string } | null, leader?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, originator?: RespondentOriginator | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string }> | null } | null, members: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, preferredContactType: ContactType, originator?: RespondentOriginator | null, createdAt: any, notificationTeamIds: Array<string>, disabled: boolean, contacts?: Array<{ __typename?: 'Contact', type: ContactType, source?: ContactSource | null, value: string, phoneNumber?: { __typename?: 'PhoneNumber', countryCallingCode: string, nationalNumber: string } | null }> | null, language?: { __typename?: 'Language', id: string, code: string } | null }> }> };

export type OrganizationAdminsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationAdminsQuery = { __typename?: 'Query', organizationAdmins?: Array<{ __typename?: 'Respondent', id: string, user?: { __typename?: 'User', id: string } | null, contacts?: Array<{ __typename?: 'Contact', source?: ContactSource | null, type: ContactType, value: string }> | null } | null> | null };

export type OrganizationSettingQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSettingQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, systemName: string, primaryLanguageCode: string, processNotificationsDefault: NotificationLevel, processNotificationsLocked: boolean, activeRespondentsInCurrentPeriodCount?: number | null, featureNames?: Array<string | null> | null, productVersion?: { __typename?: 'ProductVersion', product: string, id: string } | null, productVersionHistory?: Array<{ __typename?: 'ProductVersion', id: string, product: string, licenceCount?: number | null, transferredCredits?: number | null, boughtCredits?: number | null, activePeriodEnd?: any | null, validFrom: any, validTo: any, usedCredits?: number | null }> | null, organizationAdmins: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, user?: { __typename?: 'User', id: string, username: string } | null }>, languages: Array<{ __typename?: 'Language', id: string, code: string }>, allRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string, source?: ContactSource | null }> | null }>, config?: { __typename?: 'OrganizationConfig', timezone: string, countryCode?: string | null, countryCallingCode: string } | null, logo?: { __typename?: 'OrganizationLogo', id: string, url: string, originalName: string, createdAt: any } | null } | null };

export type OrganizationSettingReportQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type OrganizationSettingReportQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', id: string, name: string, primaryLanguageId: number, primaryLanguageCode: string, teams: Array<{ __typename?: 'Team', id: string, name?: string | null, members: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string }> | null }> }>, languages: Array<{ __typename?: 'Language', id: string, code: string }>, allRespondents: Array<{ __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, organizationRole: UserOrgRole, disabled: boolean, team?: { __typename?: 'Team', id: string } | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string }> | null }> } | null };

export type LanguagesQueryVariables = Exact<{
  filter?: InputMaybe<LanguageFilterInput>;
}>;


export type LanguagesQuery = { __typename?: 'Query', languages: Array<{ __typename?: 'Language', id: string, code: string }> };

export type ReportRecipientsQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type ReportRecipientsQuery = { __typename?: 'Query', reportRecipients: Array<{ __typename?: 'ReportRecipient', id: string, respondentDeleted: boolean, teamDeleted: boolean, type: ReportType, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string }> | null } | null, team?: { __typename?: 'Team', id: string, name?: string | null } | null, language: { __typename?: 'Language', id: string, code: string } }> };

export type GetOrganizationRespondentsCountQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetOrganizationRespondentsCountQuery = { __typename?: 'Query', organization?: { __typename?: 'Organization', respondentsCount: number } | null };

export type GetOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrganizationsQuery = { __typename?: 'Query', user: { __typename?: 'User', id: string, allowedOrganizations: Array<{ __typename?: 'Organization', id: string, name: string, systemName: string }>, organization?: { __typename?: 'Organization', id: string, name: string, systemName: string } | null } };

export type ReportAccessQueryVariables = Exact<{
  surveyId: Scalars['ID']['input'];
}>;


export type ReportAccessQuery = { __typename?: 'Query', survey?: { __typename?: 'Survey', sendAt: any, endsAt?: any | null, isReportPendingApproval: boolean, status: SurveyStatus, topic?: { __typename?: 'Topic', name: string, topicGroup: { __typename?: 'TopicGroup', name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null } } | null, reports?: Array<{ __typename?: 'ReportAccess', id: string, accessKey: string, accepted?: boolean | null, sent: boolean, readAt?: any | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string }> | null } | null, teams?: Array<{ __typename?: 'Team', id: string, name?: string | null, leader?: { __typename?: 'Respondent', id: string } | null }> | null, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null }> | null, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null, reportRecipients?: Array<{ __typename?: 'ReportRecipient', validFrom?: any | null, validTo?: any | null, team?: { __typename?: 'Team', id: string } | null, respondent?: { __typename?: 'Respondent', id: string } | null } | null> | null } | null };

export type SequenceReportAccessesQueryVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type SequenceReportAccessesQuery = { __typename?: 'Query', surveyGroup?: { __typename?: 'SurveyGroup', from?: any | null, status: ProcessStatus, isAnySurveyComplete: boolean, topicGroup: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null }, steps: Array<{ __typename?: 'SurveyGroupStep', daysFromStart: number, status: ProcessStatus, hasNotStarted?: boolean | null, notstartedReason?: Array<NotstartedSurveyReason> | null, processStep: { __typename?: 'ProcessStep', startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, name: string, translations?: Array<{ __typename?: 'TopicGroupTranslation', id: string, value: string, language: { __typename?: 'Language', code: string } }> | null } }, statistics?: { __typename?: 'ReportBasicStatistics', answered: number, total: number } | null }>, reports: Array<{ __typename?: 'ReportAccess', id: string, accessKey: string, accepted?: boolean | null, sent: boolean, readAt?: any | null, visitsInLastYear?: number | null, totalCount?: number | null, unreadCount?: number | null, respondent?: { __typename?: 'Respondent', id: string, firstname?: string | null, surname?: string | null, contacts?: Array<{ __typename?: 'Contact', type: ContactType, value: string }> | null } | null, teams?: Array<{ __typename?: 'Team', id: string, name?: string | null, leader?: { __typename?: 'Respondent', id: string } | null }> | null }>, reportRecipients?: Array<{ __typename?: 'ReportRecipient', validFrom?: any | null, validTo?: any | null, team?: { __typename?: 'Team', id: string } | null, respondent?: { __typename?: 'Respondent', id: string } | null } | null> | null } | null };

export type TopicGroupQueryVariables = Exact<{
  topicGroupId: Scalars['ID']['input'];
  language?: InputMaybe<Scalars['ID']['input']>;
}>;


export type TopicGroupQuery = { __typename?: 'Query', topicGroup: { __typename?: 'TopicGroup', id: string, name: string, description?: string | null, typeCode?: TopicGroupTypeCode | null, organization?: { __typename?: 'Organization', id: string } | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, id: string, language: { __typename?: 'Language', id: string, code: string } }> | null, steps?: Array<{ __typename?: 'ProcessStep', id: string, startOffsetMins?: number | null, endOffsetMins?: number | null, reminders: Array<{ __typename?: 'ProcessStepReminder', reminderOffsetMins: number }>, stepTopicGroup: { __typename?: 'TopicGroup', id: string, organization?: { __typename?: 'Organization', id: string } | null, lastValidTopic?: { __typename?: 'Topic', id: string, name: string } | null, translations?: Array<{ __typename?: 'TopicGroupTranslation', value: string, description?: string | null, language: { __typename?: 'Language', id: string, code: string } }> | null } }> | null } };

export type ExportTranslationsQueryVariables = Exact<{
  topicId: Scalars['ID']['input'];
  languageCode?: InputMaybe<Scalars['String']['input']>;
  topicGroupId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExportTranslationsQuery = { __typename?: 'Query', exportTranslations?: { __typename?: 'TextFile', mimetype: string, name: string, contents: string } | null };

export type SurveysQueryVariables = Exact<{
  languageCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type SurveysQuery = { __typename?: 'Query', user: { __typename?: 'User', organization?: { __typename?: 'Organization', surveys: Array<{ __typename?: 'Survey', id: string, public?: boolean | null, status: SurveyStatus, sendAt: any, whitelistedRespondents: Array<{ __typename?: 'Respondent', id: string }>, resultsInfo?: { __typename?: 'SurveyResultsInfo', answered: number, total: number } | null, topic?: { __typename?: 'Topic', name: string } | null, topicGroup?: { __typename?: 'TopicGroup', name: string, typeCode?: TopicGroupTypeCode | null } | null }> } | null } };

export type PublicTopicGroupsQueryVariables = Exact<{
  language: Scalars['String']['input'];
  product?: InputMaybe<Scalars['String']['input']>;
}>;


export type PublicTopicGroupsQuery = { __typename?: 'Query', publicTopicGroups: Array<{ __typename?: 'PublicTopicGroup', id: string, name: string } | null> };

export type LastMessagesForRespondentQueryVariables = Exact<{
  surveyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  respondentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type LastMessagesForRespondentQuery = { __typename?: 'Query', lastMessagesForRespondent: Array<{ __typename?: 'MessageStatus', id: string, messageStatus?: string | null, processed: boolean, createdAt: any, error?: string | null, surveyId: string }> };

export type GetCreditHistoryQueryVariables = Exact<{
  productId: Scalars['ID']['input'];
}>;


export type GetCreditHistoryQuery = { __typename?: 'Query', getCreditHistory: Array<{ __typename?: 'CreditHistory', id: string, type: string, creditsUsed: number, createdAt: any, organization: { __typename?: 'Organization', id: string, name: string }, user?: { __typename?: 'User', id: string, firstname?: string | null, surname?: string | null } | null }> };

export type GetCompletedSurveysQueryVariables = Exact<{
  organizationId: Scalars['ID']['input'];
}>;


export type GetCompletedSurveysQuery = { __typename?: 'Query', getCompletedSurveys: Array<{ __typename?: 'Survey', id: string, sendAt: any, endsAt?: any | null, teamIds: Array<string | null>, topic?: { __typename?: 'Topic', name: string } | null, topicGroup?: { __typename?: 'TopicGroup', name: string } | null, reports?: Array<{ __typename?: 'ReportAccess', id: string, accessKey: string, respondent?: { __typename?: 'Respondent', id: string } | null, teams?: Array<{ __typename?: 'Team', id: string }> | null }> | null }> };

export type WatchSurveyGroupChangesSubscriptionVariables = Exact<{
  surveyGroupId: Scalars['ID']['input'];
}>;


export type WatchSurveyGroupChangesSubscription = { __typename?: 'Subscription', watchSurveyGroupChanges?: { __typename?: 'SurveyGroupChange', surveyGroupId: string } | null };

export type ArielAiChatSubscriptionVariables = Exact<{
  topicId: Scalars['ID']['input'];
  languageCode: Scalars['String']['input'];
  messages: Array<ArielAiChatMessageInput> | ArielAiChatMessageInput;
  graph: Array<ArielAiNodeDataInput> | ArielAiNodeDataInput;
}>;


export type ArielAiChatSubscription = { __typename?: 'Subscription', arielAiChat: { __typename?: 'ArielAiChatData', text: string, done: boolean, patch?: Array<{ __typename?: 'ArielAiNodeData', questionIndex: number, questionText: string, isRequired: boolean, metrics: Array<Metrics>, isQuestionTrigger: boolean, statements?: Array<string | null> | null, statementIds?: Array<string | null> | null, randomizeOrder?: boolean | null, isRankingScale?: boolean | null, showEscapeOption?: boolean | null, type: string, input: boolean, position?: Array<number | null> | null, reportOrder?: number | null, commentGroupId?: string | null, choices: Array<{ __typename?: 'ArielAiNodeChoice', key: string, value: string }>, range?: { __typename?: 'ArielAiSelectedRange', min: number, max: number } | null, answersToHighlight?: Array<{ __typename?: 'ArielAiNodeChoice', key: string, value: string }> | null, outputs: Array<{ __typename?: 'ArielAiNodeOutput', key: string, targetQuestionIndex?: number | null }>, comments?: Array<{ __typename?: 'ArielAiComment', id?: string | null, text?: string | null, originator?: string | null }> | null }> | null, error?: { __typename?: 'ArielAiChatError', code: ArielAiChatErrorCode, message: string, validationErrors?: Array<string> | null } | null } };


export const ResetPasswordDocument = gql`
    mutation resetPassword($username: String!, $origin: Origin!) {
  resetPassword(username: $username, origin: $origin)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      username: // value for 'username'
 *      origin: // value for 'origin'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const SendMagicLinkDocument = gql`
    mutation sendMagicLink($username: String!, $redirect: String) {
  sendMagicLink(username: $username, redirect: $redirect)
}
    `;
export type SendMagicLinkMutationFn = Apollo.MutationFunction<SendMagicLinkMutation, SendMagicLinkMutationVariables>;

/**
 * __useSendMagicLinkMutation__
 *
 * To run a mutation, you first call `useSendMagicLinkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMagicLinkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMagicLinkMutation, { data, loading, error }] = useSendMagicLinkMutation({
 *   variables: {
 *      username: // value for 'username'
 *      redirect: // value for 'redirect'
 *   },
 * });
 */
export function useSendMagicLinkMutation(baseOptions?: Apollo.MutationHookOptions<SendMagicLinkMutation, SendMagicLinkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendMagicLinkMutation, SendMagicLinkMutationVariables>(SendMagicLinkDocument, options);
      }
export type SendMagicLinkMutationHookResult = ReturnType<typeof useSendMagicLinkMutation>;
export type SendMagicLinkMutationResult = Apollo.MutationResult<SendMagicLinkMutation>;
export type SendMagicLinkMutationOptions = Apollo.BaseMutationOptions<SendMagicLinkMutation, SendMagicLinkMutationVariables>;
export const SetConsentDocument = gql`
    mutation setConsent($consent: Boolean!) {
  setConsent(consent: $consent)
}
    `;
export type SetConsentMutationFn = Apollo.MutationFunction<SetConsentMutation, SetConsentMutationVariables>;

/**
 * __useSetConsentMutation__
 *
 * To run a mutation, you first call `useSetConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setConsentMutation, { data, loading, error }] = useSetConsentMutation({
 *   variables: {
 *      consent: // value for 'consent'
 *   },
 * });
 */
export function useSetConsentMutation(baseOptions?: Apollo.MutationHookOptions<SetConsentMutation, SetConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetConsentMutation, SetConsentMutationVariables>(SetConsentDocument, options);
      }
export type SetConsentMutationHookResult = ReturnType<typeof useSetConsentMutation>;
export type SetConsentMutationResult = Apollo.MutationResult<SetConsentMutation>;
export type SetConsentMutationOptions = Apollo.BaseMutationOptions<SetConsentMutation, SetConsentMutationVariables>;
export const CreateRespondentDocument = gql`
    mutation CreateRespondent($input: RespondentInput!) {
  createRespondent(input: $input) {
    id
    firstname
    surname
  }
}
    `;
export type CreateRespondentMutationFn = Apollo.MutationFunction<CreateRespondentMutation, CreateRespondentMutationVariables>;

/**
 * __useCreateRespondentMutation__
 *
 * To run a mutation, you first call `useCreateRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRespondentMutation, { data, loading, error }] = useCreateRespondentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateRespondentMutation(baseOptions?: Apollo.MutationHookOptions<CreateRespondentMutation, CreateRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRespondentMutation, CreateRespondentMutationVariables>(CreateRespondentDocument, options);
      }
export type CreateRespondentMutationHookResult = ReturnType<typeof useCreateRespondentMutation>;
export type CreateRespondentMutationResult = Apollo.MutationResult<CreateRespondentMutation>;
export type CreateRespondentMutationOptions = Apollo.BaseMutationOptions<CreateRespondentMutation, CreateRespondentMutationVariables>;
export const UpsertTopicGroupTranslationDocument = gql`
    mutation upsertTopicGroupTranslation($language: String!, $value: String!, $description: String!, $topicGroupId: ID!) {
  upsertTopicGroupTranslation(
    input: {topicGroupId: $topicGroupId, language: $language, value: $value, description: $description}
  ) {
    id
    value
    description
  }
}
    `;
export type UpsertTopicGroupTranslationMutationFn = Apollo.MutationFunction<UpsertTopicGroupTranslationMutation, UpsertTopicGroupTranslationMutationVariables>;

/**
 * __useUpsertTopicGroupTranslationMutation__
 *
 * To run a mutation, you first call `useUpsertTopicGroupTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertTopicGroupTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertTopicGroupTranslationMutation, { data, loading, error }] = useUpsertTopicGroupTranslationMutation({
 *   variables: {
 *      language: // value for 'language'
 *      value: // value for 'value'
 *      description: // value for 'description'
 *      topicGroupId: // value for 'topicGroupId'
 *   },
 * });
 */
export function useUpsertTopicGroupTranslationMutation(baseOptions?: Apollo.MutationHookOptions<UpsertTopicGroupTranslationMutation, UpsertTopicGroupTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertTopicGroupTranslationMutation, UpsertTopicGroupTranslationMutationVariables>(UpsertTopicGroupTranslationDocument, options);
      }
export type UpsertTopicGroupTranslationMutationHookResult = ReturnType<typeof useUpsertTopicGroupTranslationMutation>;
export type UpsertTopicGroupTranslationMutationResult = Apollo.MutationResult<UpsertTopicGroupTranslationMutation>;
export type UpsertTopicGroupTranslationMutationOptions = Apollo.BaseMutationOptions<UpsertTopicGroupTranslationMutation, UpsertTopicGroupTranslationMutationVariables>;
export const UpdateRespondentDocument = gql`
    mutation UpdateRespondent($id: ID!, $input: UpdateRespondentInput!) {
  updateRespondent(respondentId: $id, input: $input) {
    id
    firstname
    surname
    originator
    createdAt
    contacts {
      type
      source
      value
      phoneNumber {
        countryCallingCode
        nationalNumber
      }
    }
    preferredContactType
    team {
      id
      teamLeaderId
    }
    language {
      id
      code
    }
    disabled
    notificationTeamIds
  }
}
    `;
export type UpdateRespondentMutationFn = Apollo.MutationFunction<UpdateRespondentMutation, UpdateRespondentMutationVariables>;

/**
 * __useUpdateRespondentMutation__
 *
 * To run a mutation, you first call `useUpdateRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRespondentMutation, { data, loading, error }] = useUpdateRespondentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateRespondentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRespondentMutation, UpdateRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRespondentMutation, UpdateRespondentMutationVariables>(UpdateRespondentDocument, options);
      }
export type UpdateRespondentMutationHookResult = ReturnType<typeof useUpdateRespondentMutation>;
export type UpdateRespondentMutationResult = Apollo.MutationResult<UpdateRespondentMutation>;
export type UpdateRespondentMutationOptions = Apollo.BaseMutationOptions<UpdateRespondentMutation, UpdateRespondentMutationVariables>;
export const ChangePasswordDocument = gql`
    mutation changePassword($newPassword: String!, $consent: Boolean, $marketingConsent: Boolean, $deviceToken: String!) {
  changePassword(
    newPassword: $newPassword
    consent: $consent
    marketingConsent: $marketingConsent
    deviceToken: $deviceToken
  ) {
    username
  }
}
    `;
export type ChangePasswordMutationFn = Apollo.MutationFunction<ChangePasswordMutation, ChangePasswordMutationVariables>;

/**
 * __useChangePasswordMutation__
 *
 * To run a mutation, you first call `useChangePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changePasswordMutation, { data, loading, error }] = useChangePasswordMutation({
 *   variables: {
 *      newPassword: // value for 'newPassword'
 *      consent: // value for 'consent'
 *      marketingConsent: // value for 'marketingConsent'
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */
export function useChangePasswordMutation(baseOptions?: Apollo.MutationHookOptions<ChangePasswordMutation, ChangePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangePasswordMutation, ChangePasswordMutationVariables>(ChangePasswordDocument, options);
      }
export type ChangePasswordMutationHookResult = ReturnType<typeof useChangePasswordMutation>;
export type ChangePasswordMutationResult = Apollo.MutationResult<ChangePasswordMutation>;
export type ChangePasswordMutationOptions = Apollo.BaseMutationOptions<ChangePasswordMutation, ChangePasswordMutationVariables>;
export const CreateSurveyGroupDocument = gql`
    mutation createSurveyGroup($input: CreateSurveyGroupInput!) {
  createSurveyGroup(input: $input) {
    id
  }
}
    `;
export type CreateSurveyGroupMutationFn = Apollo.MutationFunction<CreateSurveyGroupMutation, CreateSurveyGroupMutationVariables>;

/**
 * __useCreateSurveyGroupMutation__
 *
 * To run a mutation, you first call `useCreateSurveyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyGroupMutation, { data, loading, error }] = useCreateSurveyGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyGroupMutation, CreateSurveyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyGroupMutation, CreateSurveyGroupMutationVariables>(CreateSurveyGroupDocument, options);
      }
export type CreateSurveyGroupMutationHookResult = ReturnType<typeof useCreateSurveyGroupMutation>;
export type CreateSurveyGroupMutationResult = Apollo.MutationResult<CreateSurveyGroupMutation>;
export type CreateSurveyGroupMutationOptions = Apollo.BaseMutationOptions<CreateSurveyGroupMutation, CreateSurveyGroupMutationVariables>;
export const ImportTopicDocument = gql`
    mutation importTopic($topic: TopicInput!, $questions: [QuestionDefinitionInput!]!, $isTesting: Boolean, $questionOrderManuallyModified: Boolean, $questionOrderModified: Boolean, $translateViaAi: Boolean) {
  importTopic(
    topic: $topic
    questions: $questions
    isTesting: $isTesting
    questionOrderManuallyModified: $questionOrderManuallyModified
    questionOrderModified: $questionOrderModified
    translateViaAi: $translateViaAi
  ) {
    id
  }
}
    `;
export type ImportTopicMutationFn = Apollo.MutationFunction<ImportTopicMutation, ImportTopicMutationVariables>;

/**
 * __useImportTopicMutation__
 *
 * To run a mutation, you first call `useImportTopicMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportTopicMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importTopicMutation, { data, loading, error }] = useImportTopicMutation({
 *   variables: {
 *      topic: // value for 'topic'
 *      questions: // value for 'questions'
 *      isTesting: // value for 'isTesting'
 *      questionOrderManuallyModified: // value for 'questionOrderManuallyModified'
 *      questionOrderModified: // value for 'questionOrderModified'
 *      translateViaAi: // value for 'translateViaAi'
 *   },
 * });
 */
export function useImportTopicMutation(baseOptions?: Apollo.MutationHookOptions<ImportTopicMutation, ImportTopicMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportTopicMutation, ImportTopicMutationVariables>(ImportTopicDocument, options);
      }
export type ImportTopicMutationHookResult = ReturnType<typeof useImportTopicMutation>;
export type ImportTopicMutationResult = Apollo.MutationResult<ImportTopicMutation>;
export type ImportTopicMutationOptions = Apollo.BaseMutationOptions<ImportTopicMutation, ImportTopicMutationVariables>;
export const CloneTopicWithTopicGroupDocument = gql`
    mutation cloneTopicWithTopicGroup($id: ID!) {
  cloneTopicWithTopicGroup(topicId: $id) {
    topicGroup {
      id
    }
  }
}
    `;
export type CloneTopicWithTopicGroupMutationFn = Apollo.MutationFunction<CloneTopicWithTopicGroupMutation, CloneTopicWithTopicGroupMutationVariables>;

/**
 * __useCloneTopicWithTopicGroupMutation__
 *
 * To run a mutation, you first call `useCloneTopicWithTopicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneTopicWithTopicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneTopicWithTopicGroupMutation, { data, loading, error }] = useCloneTopicWithTopicGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneTopicWithTopicGroupMutation(baseOptions?: Apollo.MutationHookOptions<CloneTopicWithTopicGroupMutation, CloneTopicWithTopicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneTopicWithTopicGroupMutation, CloneTopicWithTopicGroupMutationVariables>(CloneTopicWithTopicGroupDocument, options);
      }
export type CloneTopicWithTopicGroupMutationHookResult = ReturnType<typeof useCloneTopicWithTopicGroupMutation>;
export type CloneTopicWithTopicGroupMutationResult = Apollo.MutationResult<CloneTopicWithTopicGroupMutation>;
export type CloneTopicWithTopicGroupMutationOptions = Apollo.BaseMutationOptions<CloneTopicWithTopicGroupMutation, CloneTopicWithTopicGroupMutationVariables>;
export const CloneProcessTopicGroupDocument = gql`
    mutation cloneProcessTopicGroup($id: ID!) {
  cloneProcessTopicGroup(topicGroupId: $id) {
    id
  }
}
    `;
export type CloneProcessTopicGroupMutationFn = Apollo.MutationFunction<CloneProcessTopicGroupMutation, CloneProcessTopicGroupMutationVariables>;

/**
 * __useCloneProcessTopicGroupMutation__
 *
 * To run a mutation, you first call `useCloneProcessTopicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProcessTopicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProcessTopicGroupMutation, { data, loading, error }] = useCloneProcessTopicGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCloneProcessTopicGroupMutation(baseOptions?: Apollo.MutationHookOptions<CloneProcessTopicGroupMutation, CloneProcessTopicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProcessTopicGroupMutation, CloneProcessTopicGroupMutationVariables>(CloneProcessTopicGroupDocument, options);
      }
export type CloneProcessTopicGroupMutationHookResult = ReturnType<typeof useCloneProcessTopicGroupMutation>;
export type CloneProcessTopicGroupMutationResult = Apollo.MutationResult<CloneProcessTopicGroupMutation>;
export type CloneProcessTopicGroupMutationOptions = Apollo.BaseMutationOptions<CloneProcessTopicGroupMutation, CloneProcessTopicGroupMutationVariables>;
export const AddRespondentsToSurveyGroupDocument = gql`
    mutation addRespondentsToSurveyGroup($surveyGroupId: ID!, $respondents: [SurveyGroupRespondentImportInput!]!, $addedOn: Date!, $runOngoingSteps: [ID!]) {
  addRespondentsToSurveyGroup(
    respondents: $respondents
    surveyGroupId: $surveyGroupId
    addedOn: $addedOn
    runOngoingSteps: $runOngoingSteps
  )
}
    `;
export type AddRespondentsToSurveyGroupMutationFn = Apollo.MutationFunction<AddRespondentsToSurveyGroupMutation, AddRespondentsToSurveyGroupMutationVariables>;

/**
 * __useAddRespondentsToSurveyGroupMutation__
 *
 * To run a mutation, you first call `useAddRespondentsToSurveyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddRespondentsToSurveyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addRespondentsToSurveyGroupMutation, { data, loading, error }] = useAddRespondentsToSurveyGroupMutation({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *      respondents: // value for 'respondents'
 *      addedOn: // value for 'addedOn'
 *      runOngoingSteps: // value for 'runOngoingSteps'
 *   },
 * });
 */
export function useAddRespondentsToSurveyGroupMutation(baseOptions?: Apollo.MutationHookOptions<AddRespondentsToSurveyGroupMutation, AddRespondentsToSurveyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddRespondentsToSurveyGroupMutation, AddRespondentsToSurveyGroupMutationVariables>(AddRespondentsToSurveyGroupDocument, options);
      }
export type AddRespondentsToSurveyGroupMutationHookResult = ReturnType<typeof useAddRespondentsToSurveyGroupMutation>;
export type AddRespondentsToSurveyGroupMutationResult = Apollo.MutationResult<AddRespondentsToSurveyGroupMutation>;
export type AddRespondentsToSurveyGroupMutationOptions = Apollo.BaseMutationOptions<AddRespondentsToSurveyGroupMutation, AddRespondentsToSurveyGroupMutationVariables>;
export const CreateTopicGroupFromDefaultDocument = gql`
    mutation createTopicGroupFromDefault($organizationId: ID!, $name: String!, $description: String!, $typeCode: TopicGroupTypeCode) {
  createTopicGroupFromDefault(
    organizationId: $organizationId
    name: $name
    description: $description
    typeCode: $typeCode
  ) {
    id
    topics {
      id
    }
  }
}
    `;
export type CreateTopicGroupFromDefaultMutationFn = Apollo.MutationFunction<CreateTopicGroupFromDefaultMutation, CreateTopicGroupFromDefaultMutationVariables>;

/**
 * __useCreateTopicGroupFromDefaultMutation__
 *
 * To run a mutation, you first call `useCreateTopicGroupFromDefaultMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicGroupFromDefaultMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicGroupFromDefaultMutation, { data, loading, error }] = useCreateTopicGroupFromDefaultMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      typeCode: // value for 'typeCode'
 *   },
 * });
 */
export function useCreateTopicGroupFromDefaultMutation(baseOptions?: Apollo.MutationHookOptions<CreateTopicGroupFromDefaultMutation, CreateTopicGroupFromDefaultMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTopicGroupFromDefaultMutation, CreateTopicGroupFromDefaultMutationVariables>(CreateTopicGroupFromDefaultDocument, options);
      }
export type CreateTopicGroupFromDefaultMutationHookResult = ReturnType<typeof useCreateTopicGroupFromDefaultMutation>;
export type CreateTopicGroupFromDefaultMutationResult = Apollo.MutationResult<CreateTopicGroupFromDefaultMutation>;
export type CreateTopicGroupFromDefaultMutationOptions = Apollo.BaseMutationOptions<CreateTopicGroupFromDefaultMutation, CreateTopicGroupFromDefaultMutationVariables>;
export const CreateTopicGroupDocument = gql`
    mutation createTopicGroup($input: createTopicGroupInput!) {
  createTopicGroup(input: $input) {
    id
  }
}
    `;
export type CreateTopicGroupMutationFn = Apollo.MutationFunction<CreateTopicGroupMutation, CreateTopicGroupMutationVariables>;

/**
 * __useCreateTopicGroupMutation__
 *
 * To run a mutation, you first call `useCreateTopicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTopicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTopicGroupMutation, { data, loading, error }] = useCreateTopicGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTopicGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTopicGroupMutation, CreateTopicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTopicGroupMutation, CreateTopicGroupMutationVariables>(CreateTopicGroupDocument, options);
      }
export type CreateTopicGroupMutationHookResult = ReturnType<typeof useCreateTopicGroupMutation>;
export type CreateTopicGroupMutationResult = Apollo.MutationResult<CreateTopicGroupMutation>;
export type CreateTopicGroupMutationOptions = Apollo.BaseMutationOptions<CreateTopicGroupMutation, CreateTopicGroupMutationVariables>;
export const RemoveRespondentFromSurveyGroupDocument = gql`
    mutation removeRespondentFromSurveyGroup($surveyGroupId: ID!, $respondentId: ID!, $addedOn: Date!) {
  removeRespondentFromSurveyGroup(
    surveyGroupId: $surveyGroupId
    respondentId: $respondentId
    addedOn: $addedOn
  )
}
    `;
export type RemoveRespondentFromSurveyGroupMutationFn = Apollo.MutationFunction<RemoveRespondentFromSurveyGroupMutation, RemoveRespondentFromSurveyGroupMutationVariables>;

/**
 * __useRemoveRespondentFromSurveyGroupMutation__
 *
 * To run a mutation, you first call `useRemoveRespondentFromSurveyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveRespondentFromSurveyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeRespondentFromSurveyGroupMutation, { data, loading, error }] = useRemoveRespondentFromSurveyGroupMutation({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *      respondentId: // value for 'respondentId'
 *      addedOn: // value for 'addedOn'
 *   },
 * });
 */
export function useRemoveRespondentFromSurveyGroupMutation(baseOptions?: Apollo.MutationHookOptions<RemoveRespondentFromSurveyGroupMutation, RemoveRespondentFromSurveyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveRespondentFromSurveyGroupMutation, RemoveRespondentFromSurveyGroupMutationVariables>(RemoveRespondentFromSurveyGroupDocument, options);
      }
export type RemoveRespondentFromSurveyGroupMutationHookResult = ReturnType<typeof useRemoveRespondentFromSurveyGroupMutation>;
export type RemoveRespondentFromSurveyGroupMutationResult = Apollo.MutationResult<RemoveRespondentFromSurveyGroupMutation>;
export type RemoveRespondentFromSurveyGroupMutationOptions = Apollo.BaseMutationOptions<RemoveRespondentFromSurveyGroupMutation, RemoveRespondentFromSurveyGroupMutationVariables>;
export const DeleteOrganizationSurveyDocument = gql`
    mutation deleteOrganizationSurvey($surveyId: ID!) {
  deleteOrganizationSurvey(surveyId: $surveyId)
}
    `;
export type DeleteOrganizationSurveyMutationFn = Apollo.MutationFunction<DeleteOrganizationSurveyMutation, DeleteOrganizationSurveyMutationVariables>;

/**
 * __useDeleteOrganizationSurveyMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationSurveyMutation, { data, loading, error }] = useDeleteOrganizationSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useDeleteOrganizationSurveyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationSurveyMutation, DeleteOrganizationSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationSurveyMutation, DeleteOrganizationSurveyMutationVariables>(DeleteOrganizationSurveyDocument, options);
      }
export type DeleteOrganizationSurveyMutationHookResult = ReturnType<typeof useDeleteOrganizationSurveyMutation>;
export type DeleteOrganizationSurveyMutationResult = Apollo.MutationResult<DeleteOrganizationSurveyMutation>;
export type DeleteOrganizationSurveyMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationSurveyMutation, DeleteOrganizationSurveyMutationVariables>;
export const SetTimezoneAndCountryDocument = gql`
    mutation setTimezoneAndCountry($input: UpdateOrganizationConfigInput!) {
  updateOrganizationConfig(input: $input) {
    timezone
    countryCode
  }
}
    `;
export type SetTimezoneAndCountryMutationFn = Apollo.MutationFunction<SetTimezoneAndCountryMutation, SetTimezoneAndCountryMutationVariables>;

/**
 * __useSetTimezoneAndCountryMutation__
 *
 * To run a mutation, you first call `useSetTimezoneAndCountryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetTimezoneAndCountryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setTimezoneAndCountryMutation, { data, loading, error }] = useSetTimezoneAndCountryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetTimezoneAndCountryMutation(baseOptions?: Apollo.MutationHookOptions<SetTimezoneAndCountryMutation, SetTimezoneAndCountryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetTimezoneAndCountryMutation, SetTimezoneAndCountryMutationVariables>(SetTimezoneAndCountryDocument, options);
      }
export type SetTimezoneAndCountryMutationHookResult = ReturnType<typeof useSetTimezoneAndCountryMutation>;
export type SetTimezoneAndCountryMutationResult = Apollo.MutationResult<SetTimezoneAndCountryMutation>;
export type SetTimezoneAndCountryMutationOptions = Apollo.BaseMutationOptions<SetTimezoneAndCountryMutation, SetTimezoneAndCountryMutationVariables>;
export const UpdateSurveyDocument = gql`
    mutation UpdateSurvey($surveyId: ID!, $input: UpdateSurveyInput!) {
  updateSurvey(surveyId: $surveyId, input: $input) {
    id
    topic {
      id
    }
    topicGroup {
      id
    }
  }
}
    `;
export type UpdateSurveyMutationFn = Apollo.MutationFunction<UpdateSurveyMutation, UpdateSurveyMutationVariables>;

/**
 * __useUpdateSurveyMutation__
 *
 * To run a mutation, you first call `useUpdateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSurveyMutation, { data, loading, error }] = useUpdateSurveyMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSurveyMutation, UpdateSurveyMutationVariables>(UpdateSurveyDocument, options);
      }
export type UpdateSurveyMutationHookResult = ReturnType<typeof useUpdateSurveyMutation>;
export type UpdateSurveyMutationResult = Apollo.MutationResult<UpdateSurveyMutation>;
export type UpdateSurveyMutationOptions = Apollo.BaseMutationOptions<UpdateSurveyMutation, UpdateSurveyMutationVariables>;
export const ReopenSurveyDocument = gql`
    mutation ReopenSurvey($input: ReopenSurveyInput!) {
  reopenSurvey(input: $input) {
    id
  }
}
    `;
export type ReopenSurveyMutationFn = Apollo.MutationFunction<ReopenSurveyMutation, ReopenSurveyMutationVariables>;

/**
 * __useReopenSurveyMutation__
 *
 * To run a mutation, you first call `useReopenSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReopenSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reopenSurveyMutation, { data, loading, error }] = useReopenSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReopenSurveyMutation(baseOptions?: Apollo.MutationHookOptions<ReopenSurveyMutation, ReopenSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReopenSurveyMutation, ReopenSurveyMutationVariables>(ReopenSurveyDocument, options);
      }
export type ReopenSurveyMutationHookResult = ReturnType<typeof useReopenSurveyMutation>;
export type ReopenSurveyMutationResult = Apollo.MutationResult<ReopenSurveyMutation>;
export type ReopenSurveyMutationOptions = Apollo.BaseMutationOptions<ReopenSurveyMutation, ReopenSurveyMutationVariables>;
export const SendInvitationAgainDocument = gql`
    mutation SendInvitationAgain($surveyId: ID!, $respondentId: ID!, $templateUid: String) {
  sendInvitationAgain(
    surveyId: $surveyId
    respondentId: $respondentId
    templateUid: $templateUid
  )
}
    `;
export type SendInvitationAgainMutationFn = Apollo.MutationFunction<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>;

/**
 * __useSendInvitationAgainMutation__
 *
 * To run a mutation, you first call `useSendInvitationAgainMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInvitationAgainMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInvitationAgainMutation, { data, loading, error }] = useSendInvitationAgainMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      respondentId: // value for 'respondentId'
 *      templateUid: // value for 'templateUid'
 *   },
 * });
 */
export function useSendInvitationAgainMutation(baseOptions?: Apollo.MutationHookOptions<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>(SendInvitationAgainDocument, options);
      }
export type SendInvitationAgainMutationHookResult = ReturnType<typeof useSendInvitationAgainMutation>;
export type SendInvitationAgainMutationResult = Apollo.MutationResult<SendInvitationAgainMutation>;
export type SendInvitationAgainMutationOptions = Apollo.BaseMutationOptions<SendInvitationAgainMutation, SendInvitationAgainMutationVariables>;
export const CreateSurveyDocument = gql`
    mutation CreateSurvey($input: CreateSurveyInput!) {
  createSurvey(input: $input) {
    id
    sendAt
    topic {
      id
    }
    topicGroup {
      id
    }
  }
}
    `;
export type CreateSurveyMutationFn = Apollo.MutationFunction<CreateSurveyMutation, CreateSurveyMutationVariables>;

/**
 * __useCreateSurveyMutation__
 *
 * To run a mutation, you first call `useCreateSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSurveyMutation, { data, loading, error }] = useCreateSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateSurveyMutation, CreateSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSurveyMutation, CreateSurveyMutationVariables>(CreateSurveyDocument, options);
      }
export type CreateSurveyMutationHookResult = ReturnType<typeof useCreateSurveyMutation>;
export type CreateSurveyMutationResult = Apollo.MutationResult<CreateSurveyMutation>;
export type CreateSurveyMutationOptions = Apollo.BaseMutationOptions<CreateSurveyMutation, CreateSurveyMutationVariables>;
export const CreateTestSurveyDocument = gql`
    mutation CreateTestSurvey($input: ICreateTestSurveyInput!) {
  createTestSurvey(input: $input)
}
    `;
export type CreateTestSurveyMutationFn = Apollo.MutationFunction<CreateTestSurveyMutation, CreateTestSurveyMutationVariables>;

/**
 * __useCreateTestSurveyMutation__
 *
 * To run a mutation, you first call `useCreateTestSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTestSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTestSurveyMutation, { data, loading, error }] = useCreateTestSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTestSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreateTestSurveyMutation, CreateTestSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTestSurveyMutation, CreateTestSurveyMutationVariables>(CreateTestSurveyDocument, options);
      }
export type CreateTestSurveyMutationHookResult = ReturnType<typeof useCreateTestSurveyMutation>;
export type CreateTestSurveyMutationResult = Apollo.MutationResult<CreateTestSurveyMutation>;
export type CreateTestSurveyMutationOptions = Apollo.BaseMutationOptions<CreateTestSurveyMutation, CreateTestSurveyMutationVariables>;
export const CreateTeamDocument = gql`
    mutation createTeam($organizationId: ID!, $respondentId: ID, $teamName: String, $supervisorTeamId: ID) {
  createTeam(
    organizationId: $organizationId
    respondentId: $respondentId
    teamName: $teamName
    supervisorTeamId: $supervisorTeamId
  ) {
    id
    name
  }
}
    `;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      respondentId: // value for 'respondentId'
 *      teamName: // value for 'teamName'
 *      supervisorTeamId: // value for 'supervisorTeamId'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateOrganizationConfigDocument = gql`
    mutation UpdateOrganizationConfig($input: UpdateOrganizationConfigInput!) {
  updateOrganizationConfig(input: $input) {
    timezone
    countryCode
    countryCallingCode
    organization {
      primaryLanguageCode
      primaryLanguageId
    }
  }
}
    `;
export type UpdateOrganizationConfigMutationFn = Apollo.MutationFunction<UpdateOrganizationConfigMutation, UpdateOrganizationConfigMutationVariables>;

/**
 * __useUpdateOrganizationConfigMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationConfigMutation, { data, loading, error }] = useUpdateOrganizationConfigMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationConfigMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationConfigMutation, UpdateOrganizationConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationConfigMutation, UpdateOrganizationConfigMutationVariables>(UpdateOrganizationConfigDocument, options);
      }
export type UpdateOrganizationConfigMutationHookResult = ReturnType<typeof useUpdateOrganizationConfigMutation>;
export type UpdateOrganizationConfigMutationResult = Apollo.MutationResult<UpdateOrganizationConfigMutation>;
export type UpdateOrganizationConfigMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationConfigMutation, UpdateOrganizationConfigMutationVariables>;
export const VerifyPhoneNumbersDocument = gql`
    mutation verifyPhoneNumbers($phoneNumbers: [String!]!) {
  verifyPhoneNumbers(phoneNumbers: $phoneNumbers) {
    specifiedPhoneNumber
    phoneNumber
  }
}
    `;
export type VerifyPhoneNumbersMutationFn = Apollo.MutationFunction<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>;

/**
 * __useVerifyPhoneNumbersMutation__
 *
 * To run a mutation, you first call `useVerifyPhoneNumbersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyPhoneNumbersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyPhoneNumbersMutation, { data, loading, error }] = useVerifyPhoneNumbersMutation({
 *   variables: {
 *      phoneNumbers: // value for 'phoneNumbers'
 *   },
 * });
 */
export function useVerifyPhoneNumbersMutation(baseOptions?: Apollo.MutationHookOptions<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>(VerifyPhoneNumbersDocument, options);
      }
export type VerifyPhoneNumbersMutationHookResult = ReturnType<typeof useVerifyPhoneNumbersMutation>;
export type VerifyPhoneNumbersMutationResult = Apollo.MutationResult<VerifyPhoneNumbersMutation>;
export type VerifyPhoneNumbersMutationOptions = Apollo.BaseMutationOptions<VerifyPhoneNumbersMutation, VerifyPhoneNumbersMutationVariables>;
export const DeleteRespondentDocument = gql`
    mutation DeleteRespondent($respondentId: ID!) {
  deleteRespondent(respondentId: $respondentId)
}
    `;
export type DeleteRespondentMutationFn = Apollo.MutationFunction<DeleteRespondentMutation, DeleteRespondentMutationVariables>;

/**
 * __useDeleteRespondentMutation__
 *
 * To run a mutation, you first call `useDeleteRespondentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRespondentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRespondentMutation, { data, loading, error }] = useDeleteRespondentMutation({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *   },
 * });
 */
export function useDeleteRespondentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteRespondentMutation, DeleteRespondentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteRespondentMutation, DeleteRespondentMutationVariables>(DeleteRespondentDocument, options);
      }
export type DeleteRespondentMutationHookResult = ReturnType<typeof useDeleteRespondentMutation>;
export type DeleteRespondentMutationResult = Apollo.MutationResult<DeleteRespondentMutation>;
export type DeleteRespondentMutationOptions = Apollo.BaseMutationOptions<DeleteRespondentMutation, DeleteRespondentMutationVariables>;
export const AssignOrganizationDocument = gql`
    mutation assignOrganization($organizationId: ID!) {
  assignOrganization(organizationId: $organizationId)
}
    `;
export type AssignOrganizationMutationFn = Apollo.MutationFunction<AssignOrganizationMutation, AssignOrganizationMutationVariables>;

/**
 * __useAssignOrganizationMutation__
 *
 * To run a mutation, you first call `useAssignOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignOrganizationMutation, { data, loading, error }] = useAssignOrganizationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useAssignOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<AssignOrganizationMutation, AssignOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignOrganizationMutation, AssignOrganizationMutationVariables>(AssignOrganizationDocument, options);
      }
export type AssignOrganizationMutationHookResult = ReturnType<typeof useAssignOrganizationMutation>;
export type AssignOrganizationMutationResult = Apollo.MutationResult<AssignOrganizationMutation>;
export type AssignOrganizationMutationOptions = Apollo.BaseMutationOptions<AssignOrganizationMutation, AssignOrganizationMutationVariables>;
export const AcceptReportsDocument = gql`
    mutation AcceptReports($reportAccepts: [ReportAccept!]!) {
  acceptReports(reportAccepts: $reportAccepts)
}
    `;
export type AcceptReportsMutationFn = Apollo.MutationFunction<AcceptReportsMutation, AcceptReportsMutationVariables>;

/**
 * __useAcceptReportsMutation__
 *
 * To run a mutation, you first call `useAcceptReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptReportsMutation, { data, loading, error }] = useAcceptReportsMutation({
 *   variables: {
 *      reportAccepts: // value for 'reportAccepts'
 *   },
 * });
 */
export function useAcceptReportsMutation(baseOptions?: Apollo.MutationHookOptions<AcceptReportsMutation, AcceptReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptReportsMutation, AcceptReportsMutationVariables>(AcceptReportsDocument, options);
      }
export type AcceptReportsMutationHookResult = ReturnType<typeof useAcceptReportsMutation>;
export type AcceptReportsMutationResult = Apollo.MutationResult<AcceptReportsMutation>;
export type AcceptReportsMutationOptions = Apollo.BaseMutationOptions<AcceptReportsMutation, AcceptReportsMutationVariables>;
export const UpdateProcessStepDocument = gql`
    mutation updateProcessStep($id: ID!, $input: UpdateProcessStepInput!) {
  updateProcessStep(id: $id, input: $input) {
    id
    startOffsetMins
    reminders {
      reminderOffsetMins
    }
    endOffsetMins
  }
}
    `;
export type UpdateProcessStepMutationFn = Apollo.MutationFunction<UpdateProcessStepMutation, UpdateProcessStepMutationVariables>;

/**
 * __useUpdateProcessStepMutation__
 *
 * To run a mutation, you first call `useUpdateProcessStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProcessStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProcessStepMutation, { data, loading, error }] = useUpdateProcessStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProcessStepMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProcessStepMutation, UpdateProcessStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProcessStepMutation, UpdateProcessStepMutationVariables>(UpdateProcessStepDocument, options);
      }
export type UpdateProcessStepMutationHookResult = ReturnType<typeof useUpdateProcessStepMutation>;
export type UpdateProcessStepMutationResult = Apollo.MutationResult<UpdateProcessStepMutation>;
export type UpdateProcessStepMutationOptions = Apollo.BaseMutationOptions<UpdateProcessStepMutation, UpdateProcessStepMutationVariables>;
export const CreateProcessStepDocument = gql`
    mutation createProcessStep($input: CreateProcessStepInput!) {
  createProcessStep(input: $input) {
    id
    stepTopicGroup {
      id
      lastValidTopic {
        id
      }
    }
  }
}
    `;
export type CreateProcessStepMutationFn = Apollo.MutationFunction<CreateProcessStepMutation, CreateProcessStepMutationVariables>;

/**
 * __useCreateProcessStepMutation__
 *
 * To run a mutation, you first call `useCreateProcessStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProcessStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProcessStepMutation, { data, loading, error }] = useCreateProcessStepMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProcessStepMutation(baseOptions?: Apollo.MutationHookOptions<CreateProcessStepMutation, CreateProcessStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProcessStepMutation, CreateProcessStepMutationVariables>(CreateProcessStepDocument, options);
      }
export type CreateProcessStepMutationHookResult = ReturnType<typeof useCreateProcessStepMutation>;
export type CreateProcessStepMutationResult = Apollo.MutationResult<CreateProcessStepMutation>;
export type CreateProcessStepMutationOptions = Apollo.BaseMutationOptions<CreateProcessStepMutation, CreateProcessStepMutationVariables>;
export const CloneProcessStepDocument = gql`
    mutation cloneProcessStep($processStepId: ID!) {
  cloneProcessStep(processStepId: $processStepId) {
    id
    startOffsetMins
    endOffsetMins
    stepTopicGroup {
      id
      lastValidTopic {
        id
      }
      translations {
        value
        description
        language {
          id
          code
        }
      }
    }
    reminders {
      reminderOffsetMins
    }
  }
}
    `;
export type CloneProcessStepMutationFn = Apollo.MutationFunction<CloneProcessStepMutation, CloneProcessStepMutationVariables>;

/**
 * __useCloneProcessStepMutation__
 *
 * To run a mutation, you first call `useCloneProcessStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCloneProcessStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cloneProcessStepMutation, { data, loading, error }] = useCloneProcessStepMutation({
 *   variables: {
 *      processStepId: // value for 'processStepId'
 *   },
 * });
 */
export function useCloneProcessStepMutation(baseOptions?: Apollo.MutationHookOptions<CloneProcessStepMutation, CloneProcessStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CloneProcessStepMutation, CloneProcessStepMutationVariables>(CloneProcessStepDocument, options);
      }
export type CloneProcessStepMutationHookResult = ReturnType<typeof useCloneProcessStepMutation>;
export type CloneProcessStepMutationResult = Apollo.MutationResult<CloneProcessStepMutation>;
export type CloneProcessStepMutationOptions = Apollo.BaseMutationOptions<CloneProcessStepMutation, CloneProcessStepMutationVariables>;
export const DeleteProcessStepDocument = gql`
    mutation deleteProcessStep($id: ID!) {
  deleteProcessStep(id: $id)
}
    `;
export type DeleteProcessStepMutationFn = Apollo.MutationFunction<DeleteProcessStepMutation, DeleteProcessStepMutationVariables>;

/**
 * __useDeleteProcessStepMutation__
 *
 * To run a mutation, you first call `useDeleteProcessStepMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProcessStepMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProcessStepMutation, { data, loading, error }] = useDeleteProcessStepMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProcessStepMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProcessStepMutation, DeleteProcessStepMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProcessStepMutation, DeleteProcessStepMutationVariables>(DeleteProcessStepDocument, options);
      }
export type DeleteProcessStepMutationHookResult = ReturnType<typeof useDeleteProcessStepMutation>;
export type DeleteProcessStepMutationResult = Apollo.MutationResult<DeleteProcessStepMutation>;
export type DeleteProcessStepMutationOptions = Apollo.BaseMutationOptions<DeleteProcessStepMutation, DeleteProcessStepMutationVariables>;
export const RegistrationDocument = gql`
    mutation registration($userInput: UserInput!, $organizationInput: RegistrationOrganizationInput!, $password: String!) {
  registration(
    userInput: $userInput
    organizationInput: $organizationInput
    password: $password
  ) {
    id
  }
}
    `;
export type RegistrationMutationFn = Apollo.MutationFunction<RegistrationMutation, RegistrationMutationVariables>;

/**
 * __useRegistrationMutation__
 *
 * To run a mutation, you first call `useRegistrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegistrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registrationMutation, { data, loading, error }] = useRegistrationMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      organizationInput: // value for 'organizationInput'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useRegistrationMutation(baseOptions?: Apollo.MutationHookOptions<RegistrationMutation, RegistrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegistrationMutation, RegistrationMutationVariables>(RegistrationDocument, options);
      }
export type RegistrationMutationHookResult = ReturnType<typeof useRegistrationMutation>;
export type RegistrationMutationResult = Apollo.MutationResult<RegistrationMutation>;
export type RegistrationMutationOptions = Apollo.BaseMutationOptions<RegistrationMutation, RegistrationMutationVariables>;
export const UpdateOrganizationDocument = gql`
    mutation updateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    id
    name
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const UploadOrganizationLogoDocument = gql`
    mutation uploadOrganizationLogo($organizationId: ID!, $file: Upload!) {
  uploadOrganizationLogo(organizationId: $organizationId, file: $file) {
    id
    url
    originalName
    createdAt
  }
}
    `;
export type UploadOrganizationLogoMutationFn = Apollo.MutationFunction<UploadOrganizationLogoMutation, UploadOrganizationLogoMutationVariables>;

/**
 * __useUploadOrganizationLogoMutation__
 *
 * To run a mutation, you first call `useUploadOrganizationLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadOrganizationLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadOrganizationLogoMutation, { data, loading, error }] = useUploadOrganizationLogoMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadOrganizationLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadOrganizationLogoMutation, UploadOrganizationLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadOrganizationLogoMutation, UploadOrganizationLogoMutationVariables>(UploadOrganizationLogoDocument, options);
      }
export type UploadOrganizationLogoMutationHookResult = ReturnType<typeof useUploadOrganizationLogoMutation>;
export type UploadOrganizationLogoMutationResult = Apollo.MutationResult<UploadOrganizationLogoMutation>;
export type UploadOrganizationLogoMutationOptions = Apollo.BaseMutationOptions<UploadOrganizationLogoMutation, UploadOrganizationLogoMutationVariables>;
export const DeleteOrganizationLogoDocument = gql`
    mutation deleteOrganizationLogo($organizationId: ID!) {
  deleteOrganizationLogo(organizationId: $organizationId)
}
    `;
export type DeleteOrganizationLogoMutationFn = Apollo.MutationFunction<DeleteOrganizationLogoMutation, DeleteOrganizationLogoMutationVariables>;

/**
 * __useDeleteOrganizationLogoMutation__
 *
 * To run a mutation, you first call `useDeleteOrganizationLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrganizationLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrganizationLogoMutation, { data, loading, error }] = useDeleteOrganizationLogoMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDeleteOrganizationLogoMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrganizationLogoMutation, DeleteOrganizationLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrganizationLogoMutation, DeleteOrganizationLogoMutationVariables>(DeleteOrganizationLogoDocument, options);
      }
export type DeleteOrganizationLogoMutationHookResult = ReturnType<typeof useDeleteOrganizationLogoMutation>;
export type DeleteOrganizationLogoMutationResult = Apollo.MutationResult<DeleteOrganizationLogoMutation>;
export type DeleteOrganizationLogoMutationOptions = Apollo.BaseMutationOptions<DeleteOrganizationLogoMutation, DeleteOrganizationLogoMutationVariables>;
export const UploadSurveyAttachmentDocument = gql`
    mutation uploadSurveyAttachment($surveyId: ID!, $file: Upload!) {
  uploadSurveyAttachment(surveyId: $surveyId, file: $file) {
    id
    originalName
    mimeType
    sizeBytes
    createdAt
  }
}
    `;
export type UploadSurveyAttachmentMutationFn = Apollo.MutationFunction<UploadSurveyAttachmentMutation, UploadSurveyAttachmentMutationVariables>;

/**
 * __useUploadSurveyAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadSurveyAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadSurveyAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadSurveyAttachmentMutation, { data, loading, error }] = useUploadSurveyAttachmentMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadSurveyAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadSurveyAttachmentMutation, UploadSurveyAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadSurveyAttachmentMutation, UploadSurveyAttachmentMutationVariables>(UploadSurveyAttachmentDocument, options);
      }
export type UploadSurveyAttachmentMutationHookResult = ReturnType<typeof useUploadSurveyAttachmentMutation>;
export type UploadSurveyAttachmentMutationResult = Apollo.MutationResult<UploadSurveyAttachmentMutation>;
export type UploadSurveyAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadSurveyAttachmentMutation, UploadSurveyAttachmentMutationVariables>;
export const DeleteSurveyAttachmentDocument = gql`
    mutation deleteSurveyAttachment($attachmentId: ID!) {
  deleteSurveyAttachment(attachmentId: $attachmentId)
}
    `;
export type DeleteSurveyAttachmentMutationFn = Apollo.MutationFunction<DeleteSurveyAttachmentMutation, DeleteSurveyAttachmentMutationVariables>;

/**
 * __useDeleteSurveyAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyAttachmentMutation, { data, loading, error }] = useDeleteSurveyAttachmentMutation({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useDeleteSurveyAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyAttachmentMutation, DeleteSurveyAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyAttachmentMutation, DeleteSurveyAttachmentMutationVariables>(DeleteSurveyAttachmentDocument, options);
      }
export type DeleteSurveyAttachmentMutationHookResult = ReturnType<typeof useDeleteSurveyAttachmentMutation>;
export type DeleteSurveyAttachmentMutationResult = Apollo.MutationResult<DeleteSurveyAttachmentMutation>;
export type DeleteSurveyAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyAttachmentMutation, DeleteSurveyAttachmentMutationVariables>;
export const SetSurveyArchivedDocument = gql`
    mutation setSurveyArchived($surveyId: ID!, $reverse: Boolean) {
  setSurveyArchived(surveyId: $surveyId, reverse: $reverse)
}
    `;
export type SetSurveyArchivedMutationFn = Apollo.MutationFunction<SetSurveyArchivedMutation, SetSurveyArchivedMutationVariables>;

/**
 * __useSetSurveyArchivedMutation__
 *
 * To run a mutation, you first call `useSetSurveyArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSurveyArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSurveyArchivedMutation, { data, loading, error }] = useSetSurveyArchivedMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      reverse: // value for 'reverse'
 *   },
 * });
 */
export function useSetSurveyArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetSurveyArchivedMutation, SetSurveyArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSurveyArchivedMutation, SetSurveyArchivedMutationVariables>(SetSurveyArchivedDocument, options);
      }
export type SetSurveyArchivedMutationHookResult = ReturnType<typeof useSetSurveyArchivedMutation>;
export type SetSurveyArchivedMutationResult = Apollo.MutationResult<SetSurveyArchivedMutation>;
export type SetSurveyArchivedMutationOptions = Apollo.BaseMutationOptions<SetSurveyArchivedMutation, SetSurveyArchivedMutationVariables>;
export const SetSurveyGroupArchivedDocument = gql`
    mutation setSurveyGroupArchived($surveyGroupId: ID!, $reverse: Boolean) {
  setSurveyGroupArchived(surveyGroupId: $surveyGroupId, reverse: $reverse)
}
    `;
export type SetSurveyGroupArchivedMutationFn = Apollo.MutationFunction<SetSurveyGroupArchivedMutation, SetSurveyGroupArchivedMutationVariables>;

/**
 * __useSetSurveyGroupArchivedMutation__
 *
 * To run a mutation, you first call `useSetSurveyGroupArchivedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetSurveyGroupArchivedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setSurveyGroupArchivedMutation, { data, loading, error }] = useSetSurveyGroupArchivedMutation({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *      reverse: // value for 'reverse'
 *   },
 * });
 */
export function useSetSurveyGroupArchivedMutation(baseOptions?: Apollo.MutationHookOptions<SetSurveyGroupArchivedMutation, SetSurveyGroupArchivedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetSurveyGroupArchivedMutation, SetSurveyGroupArchivedMutationVariables>(SetSurveyGroupArchivedDocument, options);
      }
export type SetSurveyGroupArchivedMutationHookResult = ReturnType<typeof useSetSurveyGroupArchivedMutation>;
export type SetSurveyGroupArchivedMutationResult = Apollo.MutationResult<SetSurveyGroupArchivedMutation>;
export type SetSurveyGroupArchivedMutationOptions = Apollo.BaseMutationOptions<SetSurveyGroupArchivedMutation, SetSurveyGroupArchivedMutationVariables>;
export const GenerateOtpDocument = gql`
    mutation generateOtp($username: String!) {
  generateOtp(username: $username)
}
    `;
export type GenerateOtpMutationFn = Apollo.MutationFunction<GenerateOtpMutation, GenerateOtpMutationVariables>;

/**
 * __useGenerateOtpMutation__
 *
 * To run a mutation, you first call `useGenerateOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateOtpMutation, { data, loading, error }] = useGenerateOtpMutation({
 *   variables: {
 *      username: // value for 'username'
 *   },
 * });
 */
export function useGenerateOtpMutation(baseOptions?: Apollo.MutationHookOptions<GenerateOtpMutation, GenerateOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateOtpMutation, GenerateOtpMutationVariables>(GenerateOtpDocument, options);
      }
export type GenerateOtpMutationHookResult = ReturnType<typeof useGenerateOtpMutation>;
export type GenerateOtpMutationResult = Apollo.MutationResult<GenerateOtpMutation>;
export type GenerateOtpMutationOptions = Apollo.BaseMutationOptions<GenerateOtpMutation, GenerateOtpMutationVariables>;
export const SendEmailConfirmationDocument = gql`
    mutation sendEmailConfirmation($email: String!, $language: String!) {
  sendEmailConfirmation(email: $email, language: $language)
}
    `;
export type SendEmailConfirmationMutationFn = Apollo.MutationFunction<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>;

/**
 * __useSendEmailConfirmationMutation__
 *
 * To run a mutation, you first call `useSendEmailConfirmationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailConfirmationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailConfirmationMutation, { data, loading, error }] = useSendEmailConfirmationMutation({
 *   variables: {
 *      email: // value for 'email'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useSendEmailConfirmationMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>(SendEmailConfirmationDocument, options);
      }
export type SendEmailConfirmationMutationHookResult = ReturnType<typeof useSendEmailConfirmationMutation>;
export type SendEmailConfirmationMutationResult = Apollo.MutationResult<SendEmailConfirmationMutation>;
export type SendEmailConfirmationMutationOptions = Apollo.BaseMutationOptions<SendEmailConfirmationMutation, SendEmailConfirmationMutationVariables>;
export const ConfirmEmailDocument = gql`
    mutation confirmEmail($deviceToken: String!) {
  confirmEmail(deviceToken: $deviceToken)
}
    `;
export type ConfirmEmailMutationFn = Apollo.MutationFunction<ConfirmEmailMutation, ConfirmEmailMutationVariables>;

/**
 * __useConfirmEmailMutation__
 *
 * To run a mutation, you first call `useConfirmEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmEmailMutation, { data, loading, error }] = useConfirmEmailMutation({
 *   variables: {
 *      deviceToken: // value for 'deviceToken'
 *   },
 * });
 */
export function useConfirmEmailMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmEmailMutation, ConfirmEmailMutationVariables>(ConfirmEmailDocument, options);
      }
export type ConfirmEmailMutationHookResult = ReturnType<typeof useConfirmEmailMutation>;
export type ConfirmEmailMutationResult = Apollo.MutationResult<ConfirmEmailMutation>;
export type ConfirmEmailMutationOptions = Apollo.BaseMutationOptions<ConfirmEmailMutation, ConfirmEmailMutationVariables>;
export const CreateSalesOrganizationDocument = gql`
    mutation createSalesOrganization($input: CreateSalesOrganizationInput!) {
  createSalesOrganization(input: $input) {
    id
  }
}
    `;
export type CreateSalesOrganizationMutationFn = Apollo.MutationFunction<CreateSalesOrganizationMutation, CreateSalesOrganizationMutationVariables>;

/**
 * __useCreateSalesOrganizationMutation__
 *
 * To run a mutation, you first call `useCreateSalesOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSalesOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSalesOrganizationMutation, { data, loading, error }] = useCreateSalesOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateSalesOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<CreateSalesOrganizationMutation, CreateSalesOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSalesOrganizationMutation, CreateSalesOrganizationMutationVariables>(CreateSalesOrganizationDocument, options);
      }
export type CreateSalesOrganizationMutationHookResult = ReturnType<typeof useCreateSalesOrganizationMutation>;
export type CreateSalesOrganizationMutationResult = Apollo.MutationResult<CreateSalesOrganizationMutation>;
export type CreateSalesOrganizationMutationOptions = Apollo.BaseMutationOptions<CreateSalesOrganizationMutation, CreateSalesOrganizationMutationVariables>;
export const ImportOrganizationDocument = gql`
    mutation importOrganization($orgId: ID!, $respondents: [ImportRespondentInput!]!, $teams: [TeamInput!]!) {
  importOrganization(orgId: $orgId, respondents: $respondents, teams: $teams)
}
    `;
export type ImportOrganizationMutationFn = Apollo.MutationFunction<ImportOrganizationMutation, ImportOrganizationMutationVariables>;

/**
 * __useImportOrganizationMutation__
 *
 * To run a mutation, you first call `useImportOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importOrganizationMutation, { data, loading, error }] = useImportOrganizationMutation({
 *   variables: {
 *      orgId: // value for 'orgId'
 *      respondents: // value for 'respondents'
 *      teams: // value for 'teams'
 *   },
 * });
 */
export function useImportOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<ImportOrganizationMutation, ImportOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportOrganizationMutation, ImportOrganizationMutationVariables>(ImportOrganizationDocument, options);
      }
export type ImportOrganizationMutationHookResult = ReturnType<typeof useImportOrganizationMutation>;
export type ImportOrganizationMutationResult = Apollo.MutationResult<ImportOrganizationMutation>;
export type ImportOrganizationMutationOptions = Apollo.BaseMutationOptions<ImportOrganizationMutation, ImportOrganizationMutationVariables>;
export const EnableFeatureDocument = gql`
    mutation enableFeature($organizationId: ID!, $feature: Features!) {
  enableFeature(organizationId: $organizationId, feature: $feature)
}
    `;
export type EnableFeatureMutationFn = Apollo.MutationFunction<EnableFeatureMutation, EnableFeatureMutationVariables>;

/**
 * __useEnableFeatureMutation__
 *
 * To run a mutation, you first call `useEnableFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableFeatureMutation, { data, loading, error }] = useEnableFeatureMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useEnableFeatureMutation(baseOptions?: Apollo.MutationHookOptions<EnableFeatureMutation, EnableFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableFeatureMutation, EnableFeatureMutationVariables>(EnableFeatureDocument, options);
      }
export type EnableFeatureMutationHookResult = ReturnType<typeof useEnableFeatureMutation>;
export type EnableFeatureMutationResult = Apollo.MutationResult<EnableFeatureMutation>;
export type EnableFeatureMutationOptions = Apollo.BaseMutationOptions<EnableFeatureMutation, EnableFeatureMutationVariables>;
export const DisableFeatureDocument = gql`
    mutation disableFeature($organizationId: ID!, $feature: Features!) {
  disableFeature(organizationId: $organizationId, feature: $feature)
}
    `;
export type DisableFeatureMutationFn = Apollo.MutationFunction<DisableFeatureMutation, DisableFeatureMutationVariables>;

/**
 * __useDisableFeatureMutation__
 *
 * To run a mutation, you first call `useDisableFeatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableFeatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableFeatureMutation, { data, loading, error }] = useDisableFeatureMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      feature: // value for 'feature'
 *   },
 * });
 */
export function useDisableFeatureMutation(baseOptions?: Apollo.MutationHookOptions<DisableFeatureMutation, DisableFeatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableFeatureMutation, DisableFeatureMutationVariables>(DisableFeatureDocument, options);
      }
export type DisableFeatureMutationHookResult = ReturnType<typeof useDisableFeatureMutation>;
export type DisableFeatureMutationResult = Apollo.MutationResult<DisableFeatureMutation>;
export type DisableFeatureMutationOptions = Apollo.BaseMutationOptions<DisableFeatureMutation, DisableFeatureMutationVariables>;
export const LogFeEventDocument = gql`
    mutation logFEEvent($eventType: FEEventType!, $payload: FEEventPayload!) {
  logFEEvent(eventType: $eventType, payload: $payload)
}
    `;
export type LogFeEventMutationFn = Apollo.MutationFunction<LogFeEventMutation, LogFeEventMutationVariables>;

/**
 * __useLogFeEventMutation__
 *
 * To run a mutation, you first call `useLogFeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogFeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logFeEventMutation, { data, loading, error }] = useLogFeEventMutation({
 *   variables: {
 *      eventType: // value for 'eventType'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useLogFeEventMutation(baseOptions?: Apollo.MutationHookOptions<LogFeEventMutation, LogFeEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogFeEventMutation, LogFeEventMutationVariables>(LogFeEventDocument, options);
      }
export type LogFeEventMutationHookResult = ReturnType<typeof useLogFeEventMutation>;
export type LogFeEventMutationResult = Apollo.MutationResult<LogFeEventMutation>;
export type LogFeEventMutationOptions = Apollo.BaseMutationOptions<LogFeEventMutation, LogFeEventMutationVariables>;
export const LogErrorReportDocument = gql`
    mutation logErrorReport($errorReport: ErrorReportInput!) {
  logErrorReport(errorReport: $errorReport)
}
    `;
export type LogErrorReportMutationFn = Apollo.MutationFunction<LogErrorReportMutation, LogErrorReportMutationVariables>;

/**
 * __useLogErrorReportMutation__
 *
 * To run a mutation, you first call `useLogErrorReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogErrorReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logErrorReportMutation, { data, loading, error }] = useLogErrorReportMutation({
 *   variables: {
 *      errorReport: // value for 'errorReport'
 *   },
 * });
 */
export function useLogErrorReportMutation(baseOptions?: Apollo.MutationHookOptions<LogErrorReportMutation, LogErrorReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogErrorReportMutation, LogErrorReportMutationVariables>(LogErrorReportDocument, options);
      }
export type LogErrorReportMutationHookResult = ReturnType<typeof useLogErrorReportMutation>;
export type LogErrorReportMutationResult = Apollo.MutationResult<LogErrorReportMutation>;
export type LogErrorReportMutationOptions = Apollo.BaseMutationOptions<LogErrorReportMutation, LogErrorReportMutationVariables>;
export const RenameSurveyGroupDocument = gql`
    mutation renameSurveyGroup($name: String!, $surveyGroupId: ID!) {
  renameSurveyGroup(name: $name, surveyGroupId: $surveyGroupId) {
    name
    id
  }
}
    `;
export type RenameSurveyGroupMutationFn = Apollo.MutationFunction<RenameSurveyGroupMutation, RenameSurveyGroupMutationVariables>;

/**
 * __useRenameSurveyGroupMutation__
 *
 * To run a mutation, you first call `useRenameSurveyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameSurveyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameSurveyGroupMutation, { data, loading, error }] = useRenameSurveyGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useRenameSurveyGroupMutation(baseOptions?: Apollo.MutationHookOptions<RenameSurveyGroupMutation, RenameSurveyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameSurveyGroupMutation, RenameSurveyGroupMutationVariables>(RenameSurveyGroupDocument, options);
      }
export type RenameSurveyGroupMutationHookResult = ReturnType<typeof useRenameSurveyGroupMutation>;
export type RenameSurveyGroupMutationResult = Apollo.MutationResult<RenameSurveyGroupMutation>;
export type RenameSurveyGroupMutationOptions = Apollo.BaseMutationOptions<RenameSurveyGroupMutation, RenameSurveyGroupMutationVariables>;
export const CreateNewRespondentChannelsDocument = gql`
    mutation createNewRespondentChannels($surveyId: ID!, $respondentIds: [Int!]) {
  createNewRespondentChannels(surveyId: $surveyId, respondentIds: $respondentIds) {
    id
  }
}
    `;
export type CreateNewRespondentChannelsMutationFn = Apollo.MutationFunction<CreateNewRespondentChannelsMutation, CreateNewRespondentChannelsMutationVariables>;

/**
 * __useCreateNewRespondentChannelsMutation__
 *
 * To run a mutation, you first call `useCreateNewRespondentChannelsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateNewRespondentChannelsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createNewRespondentChannelsMutation, { data, loading, error }] = useCreateNewRespondentChannelsMutation({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *      respondentIds: // value for 'respondentIds'
 *   },
 * });
 */
export function useCreateNewRespondentChannelsMutation(baseOptions?: Apollo.MutationHookOptions<CreateNewRespondentChannelsMutation, CreateNewRespondentChannelsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateNewRespondentChannelsMutation, CreateNewRespondentChannelsMutationVariables>(CreateNewRespondentChannelsDocument, options);
      }
export type CreateNewRespondentChannelsMutationHookResult = ReturnType<typeof useCreateNewRespondentChannelsMutation>;
export type CreateNewRespondentChannelsMutationResult = Apollo.MutationResult<CreateNewRespondentChannelsMutation>;
export type CreateNewRespondentChannelsMutationOptions = Apollo.BaseMutationOptions<CreateNewRespondentChannelsMutation, CreateNewRespondentChannelsMutationVariables>;
export const DeleteTopicGroupDocument = gql`
    mutation deleteTopicGroup($id: ID!) {
  deleteTopicGroup(id: $id)
}
    `;
export type DeleteTopicGroupMutationFn = Apollo.MutationFunction<DeleteTopicGroupMutation, DeleteTopicGroupMutationVariables>;

/**
 * __useDeleteTopicGroupMutation__
 *
 * To run a mutation, you first call `useDeleteTopicGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTopicGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTopicGroupMutation, { data, loading, error }] = useDeleteTopicGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteTopicGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTopicGroupMutation, DeleteTopicGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTopicGroupMutation, DeleteTopicGroupMutationVariables>(DeleteTopicGroupDocument, options);
      }
export type DeleteTopicGroupMutationHookResult = ReturnType<typeof useDeleteTopicGroupMutation>;
export type DeleteTopicGroupMutationResult = Apollo.MutationResult<DeleteTopicGroupMutation>;
export type DeleteTopicGroupMutationOptions = Apollo.BaseMutationOptions<DeleteTopicGroupMutation, DeleteTopicGroupMutationVariables>;
export const SendPreviewConversationDocument = gql`
    mutation sendPreviewConversation($organizationName: String!, $topicGroupId: ID!, $languageCode: String!, $contactType: ContactType!, $contactValue: String!) {
  sendPreviewConversation(
    organizationName: $organizationName
    topicGroupId: $topicGroupId
    languageCode: $languageCode
    contactType: $contactType
    contactValue: $contactValue
  )
}
    `;
export type SendPreviewConversationMutationFn = Apollo.MutationFunction<SendPreviewConversationMutation, SendPreviewConversationMutationVariables>;

/**
 * __useSendPreviewConversationMutation__
 *
 * To run a mutation, you first call `useSendPreviewConversationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPreviewConversationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPreviewConversationMutation, { data, loading, error }] = useSendPreviewConversationMutation({
 *   variables: {
 *      organizationName: // value for 'organizationName'
 *      topicGroupId: // value for 'topicGroupId'
 *      languageCode: // value for 'languageCode'
 *      contactType: // value for 'contactType'
 *      contactValue: // value for 'contactValue'
 *   },
 * });
 */
export function useSendPreviewConversationMutation(baseOptions?: Apollo.MutationHookOptions<SendPreviewConversationMutation, SendPreviewConversationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPreviewConversationMutation, SendPreviewConversationMutationVariables>(SendPreviewConversationDocument, options);
      }
export type SendPreviewConversationMutationHookResult = ReturnType<typeof useSendPreviewConversationMutation>;
export type SendPreviewConversationMutationResult = Apollo.MutationResult<SendPreviewConversationMutation>;
export type SendPreviewConversationMutationOptions = Apollo.BaseMutationOptions<SendPreviewConversationMutation, SendPreviewConversationMutationVariables>;
export const SendPreviewReportDocument = gql`
    mutation sendPreviewReport($topicGroupId: ID!, $languageCode: String!, $email: String!) {
  sendPreviewReport(
    topicGroupId: $topicGroupId
    languageCode: $languageCode
    email: $email
  )
}
    `;
export type SendPreviewReportMutationFn = Apollo.MutationFunction<SendPreviewReportMutation, SendPreviewReportMutationVariables>;

/**
 * __useSendPreviewReportMutation__
 *
 * To run a mutation, you first call `useSendPreviewReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPreviewReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPreviewReportMutation, { data, loading, error }] = useSendPreviewReportMutation({
 *   variables: {
 *      topicGroupId: // value for 'topicGroupId'
 *      languageCode: // value for 'languageCode'
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSendPreviewReportMutation(baseOptions?: Apollo.MutationHookOptions<SendPreviewReportMutation, SendPreviewReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPreviewReportMutation, SendPreviewReportMutationVariables>(SendPreviewReportDocument, options);
      }
export type SendPreviewReportMutationHookResult = ReturnType<typeof useSendPreviewReportMutation>;
export type SendPreviewReportMutationResult = Apollo.MutationResult<SendPreviewReportMutation>;
export type SendPreviewReportMutationOptions = Apollo.BaseMutationOptions<SendPreviewReportMutation, SendPreviewReportMutationVariables>;
export const CreatePublicSurveyDocument = gql`
    mutation createPublicSurvey($input: CreatePublicSurveyInput!) {
  createPublicSurvey(input: $input) {
    id
    accessKey
    topic {
      name
    }
  }
}
    `;
export type CreatePublicSurveyMutationFn = Apollo.MutationFunction<CreatePublicSurveyMutation, CreatePublicSurveyMutationVariables>;

/**
 * __useCreatePublicSurveyMutation__
 *
 * To run a mutation, you first call `useCreatePublicSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePublicSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPublicSurveyMutation, { data, loading, error }] = useCreatePublicSurveyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePublicSurveyMutation(baseOptions?: Apollo.MutationHookOptions<CreatePublicSurveyMutation, CreatePublicSurveyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePublicSurveyMutation, CreatePublicSurveyMutationVariables>(CreatePublicSurveyDocument, options);
      }
export type CreatePublicSurveyMutationHookResult = ReturnType<typeof useCreatePublicSurveyMutation>;
export type CreatePublicSurveyMutationResult = Apollo.MutationResult<CreatePublicSurveyMutation>;
export type CreatePublicSurveyMutationOptions = Apollo.BaseMutationOptions<CreatePublicSurveyMutation, CreatePublicSurveyMutationVariables>;
export const CreateCommentDocument = gql`
    mutation createComment($input: CreateCommentInput!) {
  createComment(input: $input) {
    id
    positionX
    positionY
    topicId
    comments {
      id
      text
      originator {
        id
        firstname
        surname
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateCommentMutationFn = Apollo.MutationFunction<CreateCommentMutation, CreateCommentMutationVariables>;

/**
 * __useCreateCommentMutation__
 *
 * To run a mutation, you first call `useCreateCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentMutation, { data, loading, error }] = useCreateCommentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentMutation, CreateCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentMutation, CreateCommentMutationVariables>(CreateCommentDocument, options);
      }
export type CreateCommentMutationHookResult = ReturnType<typeof useCreateCommentMutation>;
export type CreateCommentMutationResult = Apollo.MutationResult<CreateCommentMutation>;
export type CreateCommentMutationOptions = Apollo.BaseMutationOptions<CreateCommentMutation, CreateCommentMutationVariables>;
export const CreateCommentGroupDocument = gql`
    mutation createCommentGroup($input: CreateCommentGroupInput!) {
  createCommentGroup(input: $input) {
    id
    positionX
    positionY
    topicId
    comments {
      id
      text
      originator {
        id
        firstname
        surname
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type CreateCommentGroupMutationFn = Apollo.MutationFunction<CreateCommentGroupMutation, CreateCommentGroupMutationVariables>;

/**
 * __useCreateCommentGroupMutation__
 *
 * To run a mutation, you first call `useCreateCommentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCommentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCommentGroupMutation, { data, loading, error }] = useCreateCommentGroupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCommentGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateCommentGroupMutation, CreateCommentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCommentGroupMutation, CreateCommentGroupMutationVariables>(CreateCommentGroupDocument, options);
      }
export type CreateCommentGroupMutationHookResult = ReturnType<typeof useCreateCommentGroupMutation>;
export type CreateCommentGroupMutationResult = Apollo.MutationResult<CreateCommentGroupMutation>;
export type CreateCommentGroupMutationOptions = Apollo.BaseMutationOptions<CreateCommentGroupMutation, CreateCommentGroupMutationVariables>;
export const DeleteCommentGroupDocument = gql`
    mutation deleteCommentGroup($id: ID!) {
  deleteCommentGroup(id: $id)
}
    `;
export type DeleteCommentGroupMutationFn = Apollo.MutationFunction<DeleteCommentGroupMutation, DeleteCommentGroupMutationVariables>;

/**
 * __useDeleteCommentGroupMutation__
 *
 * To run a mutation, you first call `useDeleteCommentGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCommentGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCommentGroupMutation, { data, loading, error }] = useDeleteCommentGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteCommentGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCommentGroupMutation, DeleteCommentGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCommentGroupMutation, DeleteCommentGroupMutationVariables>(DeleteCommentGroupDocument, options);
      }
export type DeleteCommentGroupMutationHookResult = ReturnType<typeof useDeleteCommentGroupMutation>;
export type DeleteCommentGroupMutationResult = Apollo.MutationResult<DeleteCommentGroupMutation>;
export type DeleteCommentGroupMutationOptions = Apollo.BaseMutationOptions<DeleteCommentGroupMutation, DeleteCommentGroupMutationVariables>;
export const UpdateCommentGroupPositionDocument = gql`
    mutation updateCommentGroupPosition($id: ID!, $positionX: Int!, $positionY: Int!) {
  updateCommentGroupPosition(
    id: $id
    positionX: $positionX
    positionY: $positionY
  ) {
    id
    positionX
    positionY
    topicId
    comments {
      id
      text
      originator {
        id
        firstname
        surname
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateCommentGroupPositionMutationFn = Apollo.MutationFunction<UpdateCommentGroupPositionMutation, UpdateCommentGroupPositionMutationVariables>;

/**
 * __useUpdateCommentGroupPositionMutation__
 *
 * To run a mutation, you first call `useUpdateCommentGroupPositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentGroupPositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentGroupPositionMutation, { data, loading, error }] = useUpdateCommentGroupPositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      positionX: // value for 'positionX'
 *      positionY: // value for 'positionY'
 *   },
 * });
 */
export function useUpdateCommentGroupPositionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentGroupPositionMutation, UpdateCommentGroupPositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentGroupPositionMutation, UpdateCommentGroupPositionMutationVariables>(UpdateCommentGroupPositionDocument, options);
      }
export type UpdateCommentGroupPositionMutationHookResult = ReturnType<typeof useUpdateCommentGroupPositionMutation>;
export type UpdateCommentGroupPositionMutationResult = Apollo.MutationResult<UpdateCommentGroupPositionMutation>;
export type UpdateCommentGroupPositionMutationOptions = Apollo.BaseMutationOptions<UpdateCommentGroupPositionMutation, UpdateCommentGroupPositionMutationVariables>;
export const UpdateCommentMutationDocument = gql`
    mutation updateCommentMutation($id: ID!, $text: String!) {
  updateComment(id: $id, text: $text) {
    id
    positionX
    positionY
    topicId
    comments {
      id
      text
      originator {
        id
        firstname
        surname
      }
      createdAt
      updatedAt
    }
  }
}
    `;
export type UpdateCommentMutationMutationFn = Apollo.MutationFunction<UpdateCommentMutationMutation, UpdateCommentMutationMutationVariables>;

/**
 * __useUpdateCommentMutationMutation__
 *
 * To run a mutation, you first call `useUpdateCommentMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCommentMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCommentMutationMutation, { data, loading, error }] = useUpdateCommentMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useUpdateCommentMutationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCommentMutationMutation, UpdateCommentMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCommentMutationMutation, UpdateCommentMutationMutationVariables>(UpdateCommentMutationDocument, options);
      }
export type UpdateCommentMutationMutationHookResult = ReturnType<typeof useUpdateCommentMutationMutation>;
export type UpdateCommentMutationMutationResult = Apollo.MutationResult<UpdateCommentMutationMutation>;
export type UpdateCommentMutationMutationOptions = Apollo.BaseMutationOptions<UpdateCommentMutationMutation, UpdateCommentMutationMutationVariables>;
export const DeleteSurveyGroupDocument = gql`
    mutation deleteSurveyGroup($surveyGroupId: ID!) {
  deleteSurveyGroup(surveyGroupId: $surveyGroupId)
}
    `;
export type DeleteSurveyGroupMutationFn = Apollo.MutationFunction<DeleteSurveyGroupMutation, DeleteSurveyGroupMutationVariables>;

/**
 * __useDeleteSurveyGroupMutation__
 *
 * To run a mutation, you first call `useDeleteSurveyGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSurveyGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSurveyGroupMutation, { data, loading, error }] = useDeleteSurveyGroupMutation({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useDeleteSurveyGroupMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSurveyGroupMutation, DeleteSurveyGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSurveyGroupMutation, DeleteSurveyGroupMutationVariables>(DeleteSurveyGroupDocument, options);
      }
export type DeleteSurveyGroupMutationHookResult = ReturnType<typeof useDeleteSurveyGroupMutation>;
export type DeleteSurveyGroupMutationResult = Apollo.MutationResult<DeleteSurveyGroupMutation>;
export type DeleteSurveyGroupMutationOptions = Apollo.BaseMutationOptions<DeleteSurveyGroupMutation, DeleteSurveyGroupMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation updateTeam($teamId: ID!, $input: UpdateTeamInput!) {
  updateTeam(teamId: $teamId, input: $input) {
    id
    name
  }
}
    `;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const DeleteTeamDocument = gql`
    mutation deleteTeam($teamId: ID!) {
  deleteTeam(teamId: $teamId)
}
    `;
export type DeleteTeamMutationFn = Apollo.MutationFunction<DeleteTeamMutation, DeleteTeamMutationVariables>;

/**
 * __useDeleteTeamMutation__
 *
 * To run a mutation, you first call `useDeleteTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTeamMutation, { data, loading, error }] = useDeleteTeamMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *   },
 * });
 */
export function useDeleteTeamMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTeamMutation, DeleteTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTeamMutation, DeleteTeamMutationVariables>(DeleteTeamDocument, options);
      }
export type DeleteTeamMutationHookResult = ReturnType<typeof useDeleteTeamMutation>;
export type DeleteTeamMutationResult = Apollo.MutationResult<DeleteTeamMutation>;
export type DeleteTeamMutationOptions = Apollo.BaseMutationOptions<DeleteTeamMutation, DeleteTeamMutationVariables>;
export const SetManualDeductionDocument = gql`
    mutation setManualDeduction($organizationId: ID!, $creditsUsed: Float!) {
  setManualDeduction(organizationId: $organizationId, creditsUsed: $creditsUsed)
}
    `;
export type SetManualDeductionMutationFn = Apollo.MutationFunction<SetManualDeductionMutation, SetManualDeductionMutationVariables>;

/**
 * __useSetManualDeductionMutation__
 *
 * To run a mutation, you first call `useSetManualDeductionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetManualDeductionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setManualDeductionMutation, { data, loading, error }] = useSetManualDeductionMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      creditsUsed: // value for 'creditsUsed'
 *   },
 * });
 */
export function useSetManualDeductionMutation(baseOptions?: Apollo.MutationHookOptions<SetManualDeductionMutation, SetManualDeductionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetManualDeductionMutation, SetManualDeductionMutationVariables>(SetManualDeductionDocument, options);
      }
export type SetManualDeductionMutationHookResult = ReturnType<typeof useSetManualDeductionMutation>;
export type SetManualDeductionMutationResult = Apollo.MutationResult<SetManualDeductionMutation>;
export type SetManualDeductionMutationOptions = Apollo.BaseMutationOptions<SetManualDeductionMutation, SetManualDeductionMutationVariables>;
export const SendNewReportsDocument = gql`
    mutation sendNewReports($respondentId: ID!, $surveyIds: [ID!]!) {
  sendNewReports(respondentId: $respondentId, surveyIds: $surveyIds)
}
    `;
export type SendNewReportsMutationFn = Apollo.MutationFunction<SendNewReportsMutation, SendNewReportsMutationVariables>;

/**
 * __useSendNewReportsMutation__
 *
 * To run a mutation, you first call `useSendNewReportsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendNewReportsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendNewReportsMutation, { data, loading, error }] = useSendNewReportsMutation({
 *   variables: {
 *      respondentId: // value for 'respondentId'
 *      surveyIds: // value for 'surveyIds'
 *   },
 * });
 */
export function useSendNewReportsMutation(baseOptions?: Apollo.MutationHookOptions<SendNewReportsMutation, SendNewReportsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendNewReportsMutation, SendNewReportsMutationVariables>(SendNewReportsDocument, options);
      }
export type SendNewReportsMutationHookResult = ReturnType<typeof useSendNewReportsMutation>;
export type SendNewReportsMutationResult = Apollo.MutationResult<SendNewReportsMutation>;
export type SendNewReportsMutationOptions = Apollo.BaseMutationOptions<SendNewReportsMutation, SendNewReportsMutationVariables>;
export const CreateQuestionMetricDocument = gql`
    mutation createQuestionMetric($identifier: Metrics!, $index: Int!, $topicGroupId: Int!) {
  createQuestionMetric(
    identifier: $identifier
    index: $index
    topicGroupId: $topicGroupId
  )
}
    `;
export type CreateQuestionMetricMutationFn = Apollo.MutationFunction<CreateQuestionMetricMutation, CreateQuestionMetricMutationVariables>;

/**
 * __useCreateQuestionMetricMutation__
 *
 * To run a mutation, you first call `useCreateQuestionMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateQuestionMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createQuestionMetricMutation, { data, loading, error }] = useCreateQuestionMetricMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      index: // value for 'index'
 *      topicGroupId: // value for 'topicGroupId'
 *   },
 * });
 */
export function useCreateQuestionMetricMutation(baseOptions?: Apollo.MutationHookOptions<CreateQuestionMetricMutation, CreateQuestionMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateQuestionMetricMutation, CreateQuestionMetricMutationVariables>(CreateQuestionMetricDocument, options);
      }
export type CreateQuestionMetricMutationHookResult = ReturnType<typeof useCreateQuestionMetricMutation>;
export type CreateQuestionMetricMutationResult = Apollo.MutationResult<CreateQuestionMetricMutation>;
export type CreateQuestionMetricMutationOptions = Apollo.BaseMutationOptions<CreateQuestionMetricMutation, CreateQuestionMetricMutationVariables>;
export const DeleteQuestionMetricDocument = gql`
    mutation deleteQuestionMetric($identifier: Metrics, $index: Int!, $topicGroupId: Int!) {
  deleteQuestionMetric(
    identifier: $identifier
    index: $index
    topicGroupId: $topicGroupId
  )
}
    `;
export type DeleteQuestionMetricMutationFn = Apollo.MutationFunction<DeleteQuestionMetricMutation, DeleteQuestionMetricMutationVariables>;

/**
 * __useDeleteQuestionMetricMutation__
 *
 * To run a mutation, you first call `useDeleteQuestionMetricMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteQuestionMetricMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteQuestionMetricMutation, { data, loading, error }] = useDeleteQuestionMetricMutation({
 *   variables: {
 *      identifier: // value for 'identifier'
 *      index: // value for 'index'
 *      topicGroupId: // value for 'topicGroupId'
 *   },
 * });
 */
export function useDeleteQuestionMetricMutation(baseOptions?: Apollo.MutationHookOptions<DeleteQuestionMetricMutation, DeleteQuestionMetricMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteQuestionMetricMutation, DeleteQuestionMetricMutationVariables>(DeleteQuestionMetricDocument, options);
      }
export type DeleteQuestionMetricMutationHookResult = ReturnType<typeof useDeleteQuestionMetricMutation>;
export type DeleteQuestionMetricMutationResult = Apollo.MutationResult<DeleteQuestionMetricMutation>;
export type DeleteQuestionMetricMutationOptions = Apollo.BaseMutationOptions<DeleteQuestionMetricMutation, DeleteQuestionMetricMutationVariables>;
export const AiTranslateTopicNodesDocument = gql`
    mutation AiTranslateTopicNodes($nodes: [AiTranslateNodeInput!]!, $sourceLang: String!, $targetLang: String!, $title: String, $description: String) {
  aiTranslateTopicNodes(
    nodes: $nodes
    sourceLang: $sourceLang
    targetLang: $targetLang
    title: $title
    description: $description
  ) {
    nodes {
      questionIndex
      questionText
      choices
      statements
      translated
    }
    title
    description
    limitReached
  }
}
    `;
export type AiTranslateTopicNodesMutationFn = Apollo.MutationFunction<AiTranslateTopicNodesMutation, AiTranslateTopicNodesMutationVariables>;

/**
 * __useAiTranslateTopicNodesMutation__
 *
 * To run a mutation, you first call `useAiTranslateTopicNodesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAiTranslateTopicNodesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [aiTranslateTopicNodesMutation, { data, loading, error }] = useAiTranslateTopicNodesMutation({
 *   variables: {
 *      nodes: // value for 'nodes'
 *      sourceLang: // value for 'sourceLang'
 *      targetLang: // value for 'targetLang'
 *      title: // value for 'title'
 *      description: // value for 'description'
 *   },
 * });
 */
export function useAiTranslateTopicNodesMutation(baseOptions?: Apollo.MutationHookOptions<AiTranslateTopicNodesMutation, AiTranslateTopicNodesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AiTranslateTopicNodesMutation, AiTranslateTopicNodesMutationVariables>(AiTranslateTopicNodesDocument, options);
      }
export type AiTranslateTopicNodesMutationHookResult = ReturnType<typeof useAiTranslateTopicNodesMutation>;
export type AiTranslateTopicNodesMutationResult = Apollo.MutationResult<AiTranslateTopicNodesMutation>;
export type AiTranslateTopicNodesMutationOptions = Apollo.BaseMutationOptions<AiTranslateTopicNodesMutation, AiTranslateTopicNodesMutationVariables>;
export const MarkTranslationAsReviewedDocument = gql`
    mutation MarkTranslationAsReviewed($questionDefinitionId: ID!, $languageCode: String!) {
  markTranslationAsReviewed(
    questionDefinitionId: $questionDefinitionId
    languageCode: $languageCode
  )
}
    `;
export type MarkTranslationAsReviewedMutationFn = Apollo.MutationFunction<MarkTranslationAsReviewedMutation, MarkTranslationAsReviewedMutationVariables>;

/**
 * __useMarkTranslationAsReviewedMutation__
 *
 * To run a mutation, you first call `useMarkTranslationAsReviewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkTranslationAsReviewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markTranslationAsReviewedMutation, { data, loading, error }] = useMarkTranslationAsReviewedMutation({
 *   variables: {
 *      questionDefinitionId: // value for 'questionDefinitionId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useMarkTranslationAsReviewedMutation(baseOptions?: Apollo.MutationHookOptions<MarkTranslationAsReviewedMutation, MarkTranslationAsReviewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkTranslationAsReviewedMutation, MarkTranslationAsReviewedMutationVariables>(MarkTranslationAsReviewedDocument, options);
      }
export type MarkTranslationAsReviewedMutationHookResult = ReturnType<typeof useMarkTranslationAsReviewedMutation>;
export type MarkTranslationAsReviewedMutationResult = Apollo.MutationResult<MarkTranslationAsReviewedMutation>;
export type MarkTranslationAsReviewedMutationOptions = Apollo.BaseMutationOptions<MarkTranslationAsReviewedMutation, MarkTranslationAsReviewedMutationVariables>;
export const GetBaseUserDocument = gql`
    query getBaseUser {
  isAccessTokenValid {
    status
    consent
    baseUser {
      firstname
      surname
      organization {
        name
      }
      username
    }
  }
}
    `;

/**
 * __useGetBaseUserQuery__
 *
 * To run a query within a React component, call `useGetBaseUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBaseUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBaseUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBaseUserQuery(baseOptions?: Apollo.QueryHookOptions<GetBaseUserQuery, GetBaseUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBaseUserQuery, GetBaseUserQueryVariables>(GetBaseUserDocument, options);
      }
export function useGetBaseUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBaseUserQuery, GetBaseUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBaseUserQuery, GetBaseUserQueryVariables>(GetBaseUserDocument, options);
        }
export function useGetBaseUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBaseUserQuery, GetBaseUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBaseUserQuery, GetBaseUserQueryVariables>(GetBaseUserDocument, options);
        }
export type GetBaseUserQueryHookResult = ReturnType<typeof useGetBaseUserQuery>;
export type GetBaseUserLazyQueryHookResult = ReturnType<typeof useGetBaseUserLazyQuery>;
export type GetBaseUserSuspenseQueryHookResult = ReturnType<typeof useGetBaseUserSuspenseQuery>;
export type GetBaseUserQueryResult = Apollo.QueryResult<GetBaseUserQuery, GetBaseUserQueryVariables>;
export const CheckSsoDocument = gql`
    query checkSso($email: String!) {
  checkSso(email: $email)
}
    `;

/**
 * __useCheckSsoQuery__
 *
 * To run a query within a React component, call `useCheckSsoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCheckSsoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCheckSsoQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useCheckSsoQuery(baseOptions: Apollo.QueryHookOptions<CheckSsoQuery, CheckSsoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CheckSsoQuery, CheckSsoQueryVariables>(CheckSsoDocument, options);
      }
export function useCheckSsoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CheckSsoQuery, CheckSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CheckSsoQuery, CheckSsoQueryVariables>(CheckSsoDocument, options);
        }
export function useCheckSsoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CheckSsoQuery, CheckSsoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CheckSsoQuery, CheckSsoQueryVariables>(CheckSsoDocument, options);
        }
export type CheckSsoQueryHookResult = ReturnType<typeof useCheckSsoQuery>;
export type CheckSsoLazyQueryHookResult = ReturnType<typeof useCheckSsoLazyQuery>;
export type CheckSsoSuspenseQueryHookResult = ReturnType<typeof useCheckSsoSuspenseQuery>;
export type CheckSsoQueryResult = Apollo.QueryResult<CheckSsoQuery, CheckSsoQueryVariables>;
export const IsAccessTokenValidDocument = gql`
    query isAccessTokenValid {
  isAccessTokenValid {
    status
    consent
    user {
      id
      username
      firstname
      surname
      createdAt
      systemRole
      consent
      marketingConsent
      allowedMoreOrganizations
      organization {
        id
      }
    }
  }
}
    `;

/**
 * __useIsAccessTokenValidQuery__
 *
 * To run a query within a React component, call `useIsAccessTokenValidQuery` and pass it any options that fit your needs.
 * When your component renders, `useIsAccessTokenValidQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIsAccessTokenValidQuery({
 *   variables: {
 *   },
 * });
 */
export function useIsAccessTokenValidQuery(baseOptions?: Apollo.QueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
      }
export function useIsAccessTokenValidLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
        }
export function useIsAccessTokenValidSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>(IsAccessTokenValidDocument, options);
        }
export type IsAccessTokenValidQueryHookResult = ReturnType<typeof useIsAccessTokenValidQuery>;
export type IsAccessTokenValidLazyQueryHookResult = ReturnType<typeof useIsAccessTokenValidLazyQuery>;
export type IsAccessTokenValidSuspenseQueryHookResult = ReturnType<typeof useIsAccessTokenValidSuspenseQuery>;
export type IsAccessTokenValidQueryResult = Apollo.QueryResult<IsAccessTokenValidQuery, IsAccessTokenValidQueryVariables>;
export const DashboardDocument = gql`
    query dashboard($languageCode: String) {
  user(languageCode: $languageCode) {
    id
    organization {
      id
      currentSurveys {
        id
        accessKey
        status
        whitelistedRespondentsLength
        public
        resultsInfo {
          answered
          total
        }
        topLevelReport {
          accessKey
        }
        isReportPendingApproval
        notstartedReason
        user {
          id
        }
        topic {
          id
          name
        }
        topicGroup {
          id
          name
          categoryCode
          typeCode
        }
        sendAt
        endsAt
        reminders {
          reminderAt
        }
      }
      activeProcessSurveys {
        from
        id
        status
        name
        topicGroup {
          id
          name
          categoryCode
          typeCode
        }
        topLevelReport {
          accessKey
        }
        hasOutOfLicenceInterval
        notstartedReason
      }
      activeOnboadings {
        id
        name
        topicGroup {
          id
          name
        }
        topLevelReport {
          accessKey
        }
        steps {
          processStep {
            stepTopicGroup {
              id
              chatSatisfactionScale
              name
            }
          }
          avgMetric
        }
      }
    }
  }
}
    `;

/**
 * __useDashboardQuery__
 *
 * To run a query within a React component, call `useDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useDashboardQuery(baseOptions?: Apollo.QueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
      }
export function useDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export function useDashboardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DashboardQuery, DashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DashboardQuery, DashboardQueryVariables>(DashboardDocument, options);
        }
export type DashboardQueryHookResult = ReturnType<typeof useDashboardQuery>;
export type DashboardLazyQueryHookResult = ReturnType<typeof useDashboardLazyQuery>;
export type DashboardSuspenseQueryHookResult = ReturnType<typeof useDashboardSuspenseQuery>;
export type DashboardQueryResult = Apollo.QueryResult<DashboardQuery, DashboardQueryVariables>;
export const GetRespondentsDocument = gql`
    query getRespondents($languageCode: String) {
  user(languageCode: $languageCode) {
    respondents {
      id
      organization {
        id
      }
      organizationRole
      contacts {
        source
        type
        value
      }
    }
  }
}
    `;

/**
 * __useGetRespondentsQuery__
 *
 * To run a query within a React component, call `useGetRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRespondentsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useGetRespondentsQuery(baseOptions?: Apollo.QueryHookOptions<GetRespondentsQuery, GetRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRespondentsQuery, GetRespondentsQueryVariables>(GetRespondentsDocument, options);
      }
export function useGetRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRespondentsQuery, GetRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRespondentsQuery, GetRespondentsQueryVariables>(GetRespondentsDocument, options);
        }
export function useGetRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetRespondentsQuery, GetRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRespondentsQuery, GetRespondentsQueryVariables>(GetRespondentsDocument, options);
        }
export type GetRespondentsQueryHookResult = ReturnType<typeof useGetRespondentsQuery>;
export type GetRespondentsLazyQueryHookResult = ReturnType<typeof useGetRespondentsLazyQuery>;
export type GetRespondentsSuspenseQueryHookResult = ReturnType<typeof useGetRespondentsSuspenseQuery>;
export type GetRespondentsQueryResult = Apollo.QueryResult<GetRespondentsQuery, GetRespondentsQueryVariables>;
export const UserDocument = gql`
    query user($languageCode: String) {
  user(languageCode: $languageCode) {
    id
    username
    systemRole
    organization {
      id
      name
      systemName
      status
      primaryLanguageId
      primaryLanguageCode
      languages {
        id
        code
      }
      respondentsCount
      enabledRespondentsCount
      activeRespondentsInCurrentPeriodCount
      productVersion {
        product
        licenceCount
        validFrom
        validTo
      }
      productVersionHistory {
        product
        licenceCount
        validFrom
        validTo
      }
      beforeFirstSurvey
      config {
        timezone
        testSurveys
      }
      surveys {
        id
        status
        public
        archivedAt
        resultsInfo {
          answered
          total
        }
        topLevelReport {
          id
          accessKey
        }
        isReportPendingApproval
        notstartedReason
        topic {
          id
          name
          description
          topicGroup {
            id
          }
        }
        topicGroup {
          id
          name
          description
          categoryCode
        }
        sendAt
        updatedAt
        endsAt
        reminders {
          reminderAt
        }
        availableInLanguages {
          id
          code
        }
      }
      surveyGroups {
        from
        to
        id
        status
        name
        topicGroup {
          id
          name
          typeCode
          categoryCode
          translations {
            id
            language {
              code
            }
            value
            description
          }
          languages {
            id
            code
          }
          description
          typeCode
          parentTopicGroup {
            id
          }
        }
        reports {
          id
          respondent {
            id
          }
          accessKey
        }
        statistics {
          total
          answered
        }
        steps {
          hasOutOfLicenceInterval
          hasNotStarted
          status
          notstartedReason
          processStep {
            stepTopicGroup {
              id
              name
              languages {
                id
                code
              }
              description
              categoryCode
            }
          }
          surveys {
            sendAt
            id
            archivedAt
          }
          avgMetric
        }
      }
      featureNames
    }
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const OrganizationSurveysDocument = gql`
    query organizationSurveys($organizationId: ID!, $languageCode: String) {
  organizationSurveys(
    organizationId: $organizationId
    languageCode: $languageCode
  ) {
    id
    status
    whitelistedRespondents {
      id
      firstname
      surname
    }
    public
    archivedAt
    resultsInfo {
      answered
      total
    }
    topLevelReport {
      id
      accessKey
    }
    isReportPendingApproval
    notstartedReason
    user {
      id
    }
    topicGroup {
      id
      name
      description
      categoryCode
      typeCode
    }
    sendAt
    updatedAt
    endsAt
    reminders {
      reminderAt
    }
    availableInLanguages {
      id
      code
    }
  }
}
    `;

/**
 * __useOrganizationSurveysQuery__
 *
 * To run a query within a React component, call `useOrganizationSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSurveysQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useOrganizationSurveysQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>(OrganizationSurveysDocument, options);
      }
export function useOrganizationSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>(OrganizationSurveysDocument, options);
        }
export function useOrganizationSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>(OrganizationSurveysDocument, options);
        }
export type OrganizationSurveysQueryHookResult = ReturnType<typeof useOrganizationSurveysQuery>;
export type OrganizationSurveysLazyQueryHookResult = ReturnType<typeof useOrganizationSurveysLazyQuery>;
export type OrganizationSurveysSuspenseQueryHookResult = ReturnType<typeof useOrganizationSurveysSuspenseQuery>;
export type OrganizationSurveysQueryResult = Apollo.QueryResult<OrganizationSurveysQuery, OrganizationSurveysQueryVariables>;
export const AllowedTopicGroupsDocument = gql`
    query allowedTopicGroups($languageCode: String) {
  allowedTopicGroups(languageCode: $languageCode) {
    id
    name
    description
    containsSteps
    typeCode
    lastSurvey {
      id
      sendAt
      endsAt
      status
    }
    steps {
      startOffsetMins
      reminders {
        reminderOffsetMins
      }
      endOffsetMins
      triggeredOn
      stepTopicGroup {
        id
        name
        translations {
          language {
            id
            code
          }
          value
        }
      }
    }
    lastSurveyGroup {
      id
      from
      status
    }
    languages {
      id
      code
    }
    organization {
      id
    }
    lastValidTopic {
      id
      numberOfComments
      name
      isValid
      languageIdsOnStartingQuestion
      updatedAt
      updatedBy {
        firstname
        surname
      }
      createdAt
      topicGroup {
        translations {
          language {
            id
            code
          }
          value
        }
        id
      }
      languages {
        id
        code
      }
    }
    categoryCode
    categoryName
    parentTopicGroup {
      id
    }
  }
}
    `;

/**
 * __useAllowedTopicGroupsQuery__
 *
 * To run a query within a React component, call `useAllowedTopicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllowedTopicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllowedTopicGroupsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useAllowedTopicGroupsQuery(baseOptions?: Apollo.QueryHookOptions<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>(AllowedTopicGroupsDocument, options);
      }
export function useAllowedTopicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>(AllowedTopicGroupsDocument, options);
        }
export function useAllowedTopicGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>(AllowedTopicGroupsDocument, options);
        }
export type AllowedTopicGroupsQueryHookResult = ReturnType<typeof useAllowedTopicGroupsQuery>;
export type AllowedTopicGroupsLazyQueryHookResult = ReturnType<typeof useAllowedTopicGroupsLazyQuery>;
export type AllowedTopicGroupsSuspenseQueryHookResult = ReturnType<typeof useAllowedTopicGroupsSuspenseQuery>;
export type AllowedTopicGroupsQueryResult = Apollo.QueryResult<AllowedTopicGroupsQuery, AllowedTopicGroupsQueryVariables>;
export const ActiveRespondentsDocument = gql`
    query activeRespondents($languageCode: String) {
  user(languageCode: $languageCode) {
    id
    organization {
      id
      enabledRespondentsCount
      name
      activeRespondents {
        id
        preferredContactType
        firstname
        surname
        language {
          id
          code
        }
        team {
          id
          name
        }
        contacts {
          type
          source
          value
          phoneNumber {
            countryCallingCode
            nationalNumber
          }
        }
      }
      teams {
        id
        name
        rootTeam
        structureId
        leader {
          id
          firstname
          surname
          contacts {
            type
            source
            value
          }
        }
        supervisorTeam {
          id
        }
        members {
          id
          firstname
          surname
          preferredContactType
          contacts {
            type
            source
            value
            phoneNumber {
              countryCallingCode
              nationalNumber
            }
          }
          language {
            id
            code
          }
          disabled
        }
      }
    }
  }
}
    `;

/**
 * __useActiveRespondentsQuery__
 *
 * To run a query within a React component, call `useActiveRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useActiveRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useActiveRespondentsQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useActiveRespondentsQuery(baseOptions?: Apollo.QueryHookOptions<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>(ActiveRespondentsDocument, options);
      }
export function useActiveRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>(ActiveRespondentsDocument, options);
        }
export function useActiveRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>(ActiveRespondentsDocument, options);
        }
export type ActiveRespondentsQueryHookResult = ReturnType<typeof useActiveRespondentsQuery>;
export type ActiveRespondentsLazyQueryHookResult = ReturnType<typeof useActiveRespondentsLazyQuery>;
export type ActiveRespondentsSuspenseQueryHookResult = ReturnType<typeof useActiveRespondentsSuspenseQuery>;
export type ActiveRespondentsQueryResult = Apollo.QueryResult<ActiveRespondentsQuery, ActiveRespondentsQueryVariables>;
export const TopicGroupDetailDocument = gql`
    query topicGroupDetail($topicGroupId: ID!, $languageCode: String) {
  topicGroup(topicGroupId: $topicGroupId, languageCode: $languageCode) {
    id
    name
    containsSteps
    accessKeys {
      id
      level
      accessKey
    }
    translations {
      language {
        id
        code
      }
      value
      id
      description
    }
    languages {
      id
      code
    }
    description
    questionOrderManuallyModified
    questionOrderModified
    lastValidTopic {
      id
      name
      description
      isApproved
      isEditable
      updatedAt
      updatedBy {
        firstname
        surname
      }
      languages {
        id
        code
      }
      startingQuestion {
        id
      }
      allQuestions {
        id
        text
        selectedRange
        index
        reportIndex
        reportOrder
        optional
        randomizeOrder
        isRankingScale
        showEscapeOption
        answersToHighlight
        isFirstInSectionWithNumber
        translations {
          choices
          statements
          isDefault
          text
          language {
            id
            code
          }
        }
        rules {
          id
          nextQuestion {
            id
            index
          }
          origValue
          operator
          order
          isFromDefault
        }
        positionX
        positionY
        metrics
        isQuestionTrigger
      }
      commentGroups {
        id
        positionX
        positionY
        topicId
        comments {
          id
          text
          originator {
            id
            firstname
            surname
          }
          createdAt
          updatedAt
        }
      }
    }
  }
}
    `;

/**
 * __useTopicGroupDetailQuery__
 *
 * To run a query within a React component, call `useTopicGroupDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicGroupDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicGroupDetailQuery({
 *   variables: {
 *      topicGroupId: // value for 'topicGroupId'
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useTopicGroupDetailQuery(baseOptions: Apollo.QueryHookOptions<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>(TopicGroupDetailDocument, options);
      }
export function useTopicGroupDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>(TopicGroupDetailDocument, options);
        }
export function useTopicGroupDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>(TopicGroupDetailDocument, options);
        }
export type TopicGroupDetailQueryHookResult = ReturnType<typeof useTopicGroupDetailQuery>;
export type TopicGroupDetailLazyQueryHookResult = ReturnType<typeof useTopicGroupDetailLazyQuery>;
export type TopicGroupDetailSuspenseQueryHookResult = ReturnType<typeof useTopicGroupDetailSuspenseQuery>;
export type TopicGroupDetailQueryResult = Apollo.QueryResult<TopicGroupDetailQuery, TopicGroupDetailQueryVariables>;
export const TopicDetailDocument = gql`
    query topicDetail($topicId: ID, $topicGroupId: ID) {
  topicDetail(topicId: $topicId, topicGroupId: $topicGroupId) {
    id
    name
    description
    isApproved
    isValid
    isEditable
    updatedAt
    updatedBy {
      firstname
      surname
    }
    languages {
      id
      code
    }
    startingQuestion {
      id
    }
    allQuestions {
      id
      text
      selectedRange
      index
      reportIndex
      reportOrder
      optional
      randomizeOrder
      isRankingScale
      showEscapeOption
      answersToHighlight
      isFirstInSectionWithNumber
      translations {
        choices
        statements
        isDefault
        text
        translationStatus
        language {
          id
          code
        }
      }
      rules {
        id
        nextQuestion {
          id
          index
        }
        origValue
        operator
        order
        isFromDefault
      }
      positionX
      positionY
      metrics
      isQuestionTrigger
    }
    commentGroups {
      id
      positionX
      positionY
      topicId
      comments {
        id
        text
        originator {
          id
          firstname
          surname
        }
        createdAt
        updatedAt
      }
    }
    topicGroup {
      id
      name
      organization {
        id
      }
      accessKeys {
        id
        level
        accessKey
      }
      containsSteps
      translations {
        language {
          id
          code
        }
        value
        id
        description
      }
      languages {
        id
        code
      }
      description
      questionOrderManuallyModified
      questionOrderModified
    }
  }
}
    `;

/**
 * __useTopicDetailQuery__
 *
 * To run a query within a React component, call `useTopicDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicDetailQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      topicGroupId: // value for 'topicGroupId'
 *   },
 * });
 */
export function useTopicDetailQuery(baseOptions?: Apollo.QueryHookOptions<TopicDetailQuery, TopicDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicDetailQuery, TopicDetailQueryVariables>(TopicDetailDocument, options);
      }
export function useTopicDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicDetailQuery, TopicDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicDetailQuery, TopicDetailQueryVariables>(TopicDetailDocument, options);
        }
export function useTopicDetailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopicDetailQuery, TopicDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicDetailQuery, TopicDetailQueryVariables>(TopicDetailDocument, options);
        }
export type TopicDetailQueryHookResult = ReturnType<typeof useTopicDetailQuery>;
export type TopicDetailLazyQueryHookResult = ReturnType<typeof useTopicDetailLazyQuery>;
export type TopicDetailSuspenseQueryHookResult = ReturnType<typeof useTopicDetailSuspenseQuery>;
export type TopicDetailQueryResult = Apollo.QueryResult<TopicDetailQuery, TopicDetailQueryVariables>;
export const SurveyDocument = gql`
    query survey($surveyId: ID!) {
  survey(surveyId: $surveyId) {
    id
    status
    public
    accessKey
    topicGroup {
      id
      name
      lastValidTopic {
        id
      }
      translations {
        language {
          code
        }
        id
        value
        description
      }
      languages {
        id
        code
      }
      description
    }
    topic {
      id
    }
    channels {
      respondent {
        id
        firstname
        surname
      }
      lastRemindedAt
      isFinished
      answered
      alert
    }
    whitelistedRespondents {
      id
      preferredContactType
      firstname
      surname
      team {
        id
        name
      }
      contacts {
        type
        source
        value
      }
      language {
        id
        code
      }
    }
    resultsInfo {
      total
      answered
      finished
    }
    reports {
      respondent {
        id
      }
      accessKey
    }
    isReportPendingApproval
    teamsResultInfo {
      team {
        id
        name
        leader {
          firstname
          surname
        }
      }
      resultInfo {
        total
        answered
        anonymous
      }
      teamMemberIdsFromChannels
    }
    sendAt
    endsAt
    reminders {
      reminderAt
    }
    sendEmailSms
    anonymitySettings {
      default
      allowedLevels
    }
  }
}
    `;

/**
 * __useSurveyQuery__
 *
 * To run a query within a React component, call `useSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useSurveyQuery(baseOptions: Apollo.QueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
      }
export function useSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export function useSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyQuery, SurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyQuery, SurveyQueryVariables>(SurveyDocument, options);
        }
export type SurveyQueryHookResult = ReturnType<typeof useSurveyQuery>;
export type SurveyLazyQueryHookResult = ReturnType<typeof useSurveyLazyQuery>;
export type SurveySuspenseQueryHookResult = ReturnType<typeof useSurveySuspenseQuery>;
export type SurveyQueryResult = Apollo.QueryResult<SurveyQuery, SurveyQueryVariables>;
export const SurveyAttachmentsDocument = gql`
    query surveyAttachments($surveyId: ID!) {
  survey(surveyId: $surveyId) {
    id
    attachments {
      id
      originalName
      mimeType
      sizeBytes
      createdAt
    }
  }
}
    `;

/**
 * __useSurveyAttachmentsQuery__
 *
 * To run a query within a React component, call `useSurveyAttachmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAttachmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAttachmentsQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useSurveyAttachmentsQuery(baseOptions: Apollo.QueryHookOptions<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>(SurveyAttachmentsDocument, options);
      }
export function useSurveyAttachmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>(SurveyAttachmentsDocument, options);
        }
export function useSurveyAttachmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>(SurveyAttachmentsDocument, options);
        }
export type SurveyAttachmentsQueryHookResult = ReturnType<typeof useSurveyAttachmentsQuery>;
export type SurveyAttachmentsLazyQueryHookResult = ReturnType<typeof useSurveyAttachmentsLazyQuery>;
export type SurveyAttachmentsSuspenseQueryHookResult = ReturnType<typeof useSurveyAttachmentsSuspenseQuery>;
export type SurveyAttachmentsQueryResult = Apollo.QueryResult<SurveyAttachmentsQuery, SurveyAttachmentsQueryVariables>;
export const SurveyAttachmentDownloadUrlDocument = gql`
    query surveyAttachmentDownloadUrl($attachmentId: ID!) {
  surveyAttachmentDownloadUrl(attachmentId: $attachmentId)
}
    `;

/**
 * __useSurveyAttachmentDownloadUrlQuery__
 *
 * To run a query within a React component, call `useSurveyAttachmentDownloadUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyAttachmentDownloadUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyAttachmentDownloadUrlQuery({
 *   variables: {
 *      attachmentId: // value for 'attachmentId'
 *   },
 * });
 */
export function useSurveyAttachmentDownloadUrlQuery(baseOptions: Apollo.QueryHookOptions<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>(SurveyAttachmentDownloadUrlDocument, options);
      }
export function useSurveyAttachmentDownloadUrlLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>(SurveyAttachmentDownloadUrlDocument, options);
        }
export function useSurveyAttachmentDownloadUrlSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>(SurveyAttachmentDownloadUrlDocument, options);
        }
export type SurveyAttachmentDownloadUrlQueryHookResult = ReturnType<typeof useSurveyAttachmentDownloadUrlQuery>;
export type SurveyAttachmentDownloadUrlLazyQueryHookResult = ReturnType<typeof useSurveyAttachmentDownloadUrlLazyQuery>;
export type SurveyAttachmentDownloadUrlSuspenseQueryHookResult = ReturnType<typeof useSurveyAttachmentDownloadUrlSuspenseQuery>;
export type SurveyAttachmentDownloadUrlQueryResult = Apollo.QueryResult<SurveyAttachmentDownloadUrlQuery, SurveyAttachmentDownloadUrlQueryVariables>;
export const SurveyGroupWithRespondentsDocument = gql`
    query surveyGroupWithRespondents($surveyGroupId: ID!) {
  surveyGroup(surveyGroupId: $surveyGroupId) {
    id
    surveyGroupRespondents {
      respondentId
      addedOn
      deleted
      isCompleted
      numberOfSurveys
    }
  }
}
    `;

/**
 * __useSurveyGroupWithRespondentsQuery__
 *
 * To run a query within a React component, call `useSurveyGroupWithRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyGroupWithRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyGroupWithRespondentsQuery({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useSurveyGroupWithRespondentsQuery(baseOptions: Apollo.QueryHookOptions<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>(SurveyGroupWithRespondentsDocument, options);
      }
export function useSurveyGroupWithRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>(SurveyGroupWithRespondentsDocument, options);
        }
export function useSurveyGroupWithRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>(SurveyGroupWithRespondentsDocument, options);
        }
export type SurveyGroupWithRespondentsQueryHookResult = ReturnType<typeof useSurveyGroupWithRespondentsQuery>;
export type SurveyGroupWithRespondentsLazyQueryHookResult = ReturnType<typeof useSurveyGroupWithRespondentsLazyQuery>;
export type SurveyGroupWithRespondentsSuspenseQueryHookResult = ReturnType<typeof useSurveyGroupWithRespondentsSuspenseQuery>;
export type SurveyGroupWithRespondentsQueryResult = Apollo.QueryResult<SurveyGroupWithRespondentsQuery, SurveyGroupWithRespondentsQueryVariables>;
export const SurveyGroupWithoutRespondentsDocument = gql`
    query surveyGroupWithoutRespondents($surveyGroupId: ID!) {
  surveyGroup(surveyGroupId: $surveyGroupId) {
    id
    name
    topicGroup {
      id
      name
      translations {
        language {
          code
        }
        id
        value
        description
      }
      categoryCode
      typeCode
      languages {
        id
        code
      }
      steps {
        id
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        triggeredOn
        endOffsetMins
        stepTopicGroup {
          id
          translations {
            value
            description
            language {
              code
            }
          }
        }
      }
      description
    }
    status
    steps {
      processStep {
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        endOffsetMins
        triggeredOn
        stepTopicGroup {
          id
          name
          allowedAnonymities
          defaultAnonymity
          translations {
            id
            language {
              code
            }
            value
          }
          lastValidTopic {
            id
          }
        }
      }
      hasMetricQuestion
      surveys {
        id
        status
      }
    }
    topLevelReport {
      id
      accessKey
    }
  }
}
    `;

/**
 * __useSurveyGroupWithoutRespondentsQuery__
 *
 * To run a query within a React component, call `useSurveyGroupWithoutRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyGroupWithoutRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyGroupWithoutRespondentsQuery({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useSurveyGroupWithoutRespondentsQuery(baseOptions: Apollo.QueryHookOptions<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>(SurveyGroupWithoutRespondentsDocument, options);
      }
export function useSurveyGroupWithoutRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>(SurveyGroupWithoutRespondentsDocument, options);
        }
export function useSurveyGroupWithoutRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>(SurveyGroupWithoutRespondentsDocument, options);
        }
export type SurveyGroupWithoutRespondentsQueryHookResult = ReturnType<typeof useSurveyGroupWithoutRespondentsQuery>;
export type SurveyGroupWithoutRespondentsLazyQueryHookResult = ReturnType<typeof useSurveyGroupWithoutRespondentsLazyQuery>;
export type SurveyGroupWithoutRespondentsSuspenseQueryHookResult = ReturnType<typeof useSurveyGroupWithoutRespondentsSuspenseQuery>;
export type SurveyGroupWithoutRespondentsQueryResult = Apollo.QueryResult<SurveyGroupWithoutRespondentsQuery, SurveyGroupWithoutRespondentsQueryVariables>;
export const SurveyGroupStepStatisticsDocument = gql`
    query surveyGroupStepStatistics($surveyGroupId: ID!) {
  surveyGroup(surveyGroupId: $surveyGroupId) {
    id
    steps {
      processStep {
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        endOffsetMins
        stepTopicGroup {
          id
          name
          translations {
            id
            language {
              code
            }
            value
          }
          lastValidTopic {
            id
          }
        }
      }
      daysFromStart
      status
      hasNotStarted
      notstartedReason
      statistics {
        answered
        total
        withProblems
      }
      avgMetric
    }
  }
}
    `;

/**
 * __useSurveyGroupStepStatisticsQuery__
 *
 * To run a query within a React component, call `useSurveyGroupStepStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyGroupStepStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyGroupStepStatisticsQuery({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useSurveyGroupStepStatisticsQuery(baseOptions: Apollo.QueryHookOptions<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>(SurveyGroupStepStatisticsDocument, options);
      }
export function useSurveyGroupStepStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>(SurveyGroupStepStatisticsDocument, options);
        }
export function useSurveyGroupStepStatisticsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>(SurveyGroupStepStatisticsDocument, options);
        }
export type SurveyGroupStepStatisticsQueryHookResult = ReturnType<typeof useSurveyGroupStepStatisticsQuery>;
export type SurveyGroupStepStatisticsLazyQueryHookResult = ReturnType<typeof useSurveyGroupStepStatisticsLazyQuery>;
export type SurveyGroupStepStatisticsSuspenseQueryHookResult = ReturnType<typeof useSurveyGroupStepStatisticsSuspenseQuery>;
export type SurveyGroupStepStatisticsQueryResult = Apollo.QueryResult<SurveyGroupStepStatisticsQuery, SurveyGroupStepStatisticsQueryVariables>;
export const SurveyGroupRespondentsDocument = gql`
    query surveyGroupRespondents($surveyGroupId: ID!, $pagination: Pagination, $searchQuery: String, $withoutDeleted: Boolean) {
  surveyGroupRespondents(
    surveyGroupId: $surveyGroupId
    pagination: $pagination
    searchQuery: $searchQuery
    withoutDeleted: $withoutDeleted
  ) {
    data {
      respondent {
        id
        preferredContactType
        firstname
        surname
        deleted
        team {
          id
          name
        }
        contacts {
          type
          source
          value
          phoneNumber {
            countryCallingCode
            nationalNumber
          }
        }
      }
      addedOn
      isLastRun
      isCreatingSurveys
      recruiterName
      recruitmentId
      creditsToReturn
      surveys {
        id
        status
        notstartedReason
        sendAt
        endsAt
        topicGroup {
          id
          name
          translations {
            id
            language {
              code
            }
            value
          }
        }
      }
      channels {
        survey {
          id
        }
        finishedAt
        lastRemindedAt
        isFinishedByRespondent
        allowedAnonymities
        respondent {
          id
        }
        answered
        slug
      }
      hiringSurveys {
        id
        status
        notstartedReason
        sendAt
        endsAt
        topicGroup {
          id
          name
          translations {
            id
            language {
              code
            }
            value
          }
        }
        whitelistedRespondents {
          id
        }
      }
      deleted
      deletedAt
      undeliveredInvitations {
        respondentId
        undeliveredSurveyInvitations {
          surveyId
          contact
          status
        }
      }
      answers {
        topicGroupId
        value
      }
    }
    totalCount
  }
}
    `;

/**
 * __useSurveyGroupRespondentsQuery__
 *
 * To run a query within a React component, call `useSurveyGroupRespondentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyGroupRespondentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyGroupRespondentsQuery({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *      pagination: // value for 'pagination'
 *      searchQuery: // value for 'searchQuery'
 *      withoutDeleted: // value for 'withoutDeleted'
 *   },
 * });
 */
export function useSurveyGroupRespondentsQuery(baseOptions: Apollo.QueryHookOptions<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>(SurveyGroupRespondentsDocument, options);
      }
export function useSurveyGroupRespondentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>(SurveyGroupRespondentsDocument, options);
        }
export function useSurveyGroupRespondentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>(SurveyGroupRespondentsDocument, options);
        }
export type SurveyGroupRespondentsQueryHookResult = ReturnType<typeof useSurveyGroupRespondentsQuery>;
export type SurveyGroupRespondentsLazyQueryHookResult = ReturnType<typeof useSurveyGroupRespondentsLazyQuery>;
export type SurveyGroupRespondentsSuspenseQueryHookResult = ReturnType<typeof useSurveyGroupRespondentsSuspenseQuery>;
export type SurveyGroupRespondentsQueryResult = Apollo.QueryResult<SurveyGroupRespondentsQuery, SurveyGroupRespondentsQueryVariables>;
export const DatesForNewSurveyDocument = gql`
    query datesForNewSurvey($organizationId: ID!) {
  datesForNewSurvey(organizationId: $organizationId) {
    sendAt
    endsAt
    reminderAt
    secondReminderAt
  }
}
    `;

/**
 * __useDatesForNewSurveyQuery__
 *
 * To run a query within a React component, call `useDatesForNewSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useDatesForNewSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDatesForNewSurveyQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDatesForNewSurveyQuery(baseOptions: Apollo.QueryHookOptions<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>(DatesForNewSurveyDocument, options);
      }
export function useDatesForNewSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>(DatesForNewSurveyDocument, options);
        }
export function useDatesForNewSurveySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>(DatesForNewSurveyDocument, options);
        }
export type DatesForNewSurveyQueryHookResult = ReturnType<typeof useDatesForNewSurveyQuery>;
export type DatesForNewSurveyLazyQueryHookResult = ReturnType<typeof useDatesForNewSurveyLazyQuery>;
export type DatesForNewSurveySuspenseQueryHookResult = ReturnType<typeof useDatesForNewSurveySuspenseQuery>;
export type DatesForNewSurveyQueryResult = Apollo.QueryResult<DatesForNewSurveyQuery, DatesForNewSurveyQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: ID) {
  organization(organizationId: $organizationId) {
    id
    name
    systemName
    companyId
    primaryLanguageId
    primaryLanguageCode
    languages {
      id
      code
    }
    enabledRespondentsCount
    respondentsCount
    activeRespondentsInCurrentPeriodCount
    productVersion {
      id
      product
      validTo
      licenceCount
      validFrom
      activePeriodEnd
      usedCredits
      boughtCredits
      transferredCredits
    }
    config {
      countryCode
    }
    productVersionHistory {
      id
      product
      licenceCount
      validFrom
      validTo
      boughtCredits
      transferredCredits
      activePeriodEnd
    }
    featureNames
    hasProcessSurveys
    lastSuccessfulApiUpdate
    lastFailedApiUpdate
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export function useOrganizationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationSuspenseQueryHookResult = ReturnType<typeof useOrganizationSuspenseQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const SurveyGroupsDocument = gql`
    query surveyGroups($organizationId: ID) {
  organization(organizationId: $organizationId) {
    surveyGroups {
      id
      name
      status
      from
      topicGroup {
        typeCode
        name
        organization {
          id
        }
        translations {
          value
          language {
            code
          }
        }
        steps {
          id
          startOffsetMins
          reminders {
            reminderOffsetMins
          }
          endOffsetMins
          triggeredOn
          stepTopicGroup {
            id
            translations {
              value
              description
              language {
                code
              }
            }
          }
        }
      }
      statistics {
        total
        answered
      }
    }
  }
}
    `;

/**
 * __useSurveyGroupsQuery__
 *
 * To run a query within a React component, call `useSurveyGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyGroupsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useSurveyGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SurveyGroupsQuery, SurveyGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveyGroupsQuery, SurveyGroupsQueryVariables>(SurveyGroupsDocument, options);
      }
export function useSurveyGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveyGroupsQuery, SurveyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveyGroupsQuery, SurveyGroupsQueryVariables>(SurveyGroupsDocument, options);
        }
export function useSurveyGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveyGroupsQuery, SurveyGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveyGroupsQuery, SurveyGroupsQueryVariables>(SurveyGroupsDocument, options);
        }
export type SurveyGroupsQueryHookResult = ReturnType<typeof useSurveyGroupsQuery>;
export type SurveyGroupsLazyQueryHookResult = ReturnType<typeof useSurveyGroupsLazyQuery>;
export type SurveyGroupsSuspenseQueryHookResult = ReturnType<typeof useSurveyGroupsSuspenseQuery>;
export type SurveyGroupsQueryResult = Apollo.QueryResult<SurveyGroupsQuery, SurveyGroupsQueryVariables>;
export const OrganizationTeamsDocument = gql`
    query organizationTeams($organizationId: ID!) {
  organizationTeams(organizationId: $organizationId) {
    id
    name
    rootTeam
    structureId
    supervisorTeam {
      id
    }
    leader {
      id
      firstname
      surname
      originator
      contacts {
        type
        source
        value
      }
    }
    supervisorTeam {
      id
    }
    members {
      id
      firstname
      surname
      preferredContactType
      originator
      createdAt
      notificationTeamIds
      contacts {
        type
        source
        value
        phoneNumber {
          countryCallingCode
          nationalNumber
        }
      }
      language {
        id
        code
      }
      disabled
    }
  }
}
    `;

/**
 * __useOrganizationTeamsQuery__
 *
 * To run a query within a React component, call `useOrganizationTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationTeamsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationTeamsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
      }
export function useOrganizationTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
export function useOrganizationTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>(OrganizationTeamsDocument, options);
        }
export type OrganizationTeamsQueryHookResult = ReturnType<typeof useOrganizationTeamsQuery>;
export type OrganizationTeamsLazyQueryHookResult = ReturnType<typeof useOrganizationTeamsLazyQuery>;
export type OrganizationTeamsSuspenseQueryHookResult = ReturnType<typeof useOrganizationTeamsSuspenseQuery>;
export type OrganizationTeamsQueryResult = Apollo.QueryResult<OrganizationTeamsQuery, OrganizationTeamsQueryVariables>;
export const OrganizationAdminsDocument = gql`
    query organizationAdmins($organizationId: ID!) {
  organizationAdmins(organizationId: $organizationId) {
    id
    user {
      id
    }
    contacts {
      source
      type
      value
    }
  }
}
    `;

/**
 * __useOrganizationAdminsQuery__
 *
 * To run a query within a React component, call `useOrganizationAdminsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationAdminsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationAdminsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationAdminsQuery(baseOptions: Apollo.QueryHookOptions<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>(OrganizationAdminsDocument, options);
      }
export function useOrganizationAdminsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>(OrganizationAdminsDocument, options);
        }
export function useOrganizationAdminsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>(OrganizationAdminsDocument, options);
        }
export type OrganizationAdminsQueryHookResult = ReturnType<typeof useOrganizationAdminsQuery>;
export type OrganizationAdminsLazyQueryHookResult = ReturnType<typeof useOrganizationAdminsLazyQuery>;
export type OrganizationAdminsSuspenseQueryHookResult = ReturnType<typeof useOrganizationAdminsSuspenseQuery>;
export type OrganizationAdminsQueryResult = Apollo.QueryResult<OrganizationAdminsQuery, OrganizationAdminsQueryVariables>;
export const OrganizationSettingDocument = gql`
    query OrganizationSetting($organizationId: ID!) {
  organization(organizationId: $organizationId) {
    id
    name
    systemName
    primaryLanguageCode
    processNotificationsDefault
    processNotificationsLocked
    activeRespondentsInCurrentPeriodCount
    productVersion {
      product
      id
    }
    productVersionHistory {
      id
      product
      licenceCount
      transferredCredits
      boughtCredits
      activePeriodEnd
      validFrom
      validTo
      usedCredits
    }
    organizationAdmins {
      id
      firstname
      surname
      user {
        id
        username
      }
    }
    languages {
      id
      code
    }
    allRespondents {
      id
      firstname
      surname
      organizationRole
      contacts {
        type
        value
        source
      }
    }
    config {
      timezone
      countryCode
      countryCallingCode
    }
    featureNames
    logo {
      id
      url
      originalName
      createdAt
    }
  }
}
    `;

/**
 * __useOrganizationSettingQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSettingQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSettingQuery, OrganizationSettingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSettingQuery, OrganizationSettingQueryVariables>(OrganizationSettingDocument, options);
      }
export function useOrganizationSettingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSettingQuery, OrganizationSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSettingQuery, OrganizationSettingQueryVariables>(OrganizationSettingDocument, options);
        }
export function useOrganizationSettingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSettingQuery, OrganizationSettingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSettingQuery, OrganizationSettingQueryVariables>(OrganizationSettingDocument, options);
        }
export type OrganizationSettingQueryHookResult = ReturnType<typeof useOrganizationSettingQuery>;
export type OrganizationSettingLazyQueryHookResult = ReturnType<typeof useOrganizationSettingLazyQuery>;
export type OrganizationSettingSuspenseQueryHookResult = ReturnType<typeof useOrganizationSettingSuspenseQuery>;
export type OrganizationSettingQueryResult = Apollo.QueryResult<OrganizationSettingQuery, OrganizationSettingQueryVariables>;
export const OrganizationSettingReportDocument = gql`
    query OrganizationSettingReport($organizationId: ID!) {
  organization(organizationId: $organizationId) {
    id
    name
    primaryLanguageId
    primaryLanguageCode
    teams {
      id
      name
      members {
        id
        firstname
        surname
        contacts {
          type
          value
        }
      }
    }
    languages {
      id
      code
    }
    allRespondents {
      id
      firstname
      surname
      organizationRole
      team {
        id
      }
      disabled
      contacts {
        type
        value
      }
    }
  }
}
    `;

/**
 * __useOrganizationSettingReportQuery__
 *
 * To run a query within a React component, call `useOrganizationSettingReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSettingReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSettingReportQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationSettingReportQuery(baseOptions: Apollo.QueryHookOptions<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>(OrganizationSettingReportDocument, options);
      }
export function useOrganizationSettingReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>(OrganizationSettingReportDocument, options);
        }
export function useOrganizationSettingReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>(OrganizationSettingReportDocument, options);
        }
export type OrganizationSettingReportQueryHookResult = ReturnType<typeof useOrganizationSettingReportQuery>;
export type OrganizationSettingReportLazyQueryHookResult = ReturnType<typeof useOrganizationSettingReportLazyQuery>;
export type OrganizationSettingReportSuspenseQueryHookResult = ReturnType<typeof useOrganizationSettingReportSuspenseQuery>;
export type OrganizationSettingReportQueryResult = Apollo.QueryResult<OrganizationSettingReportQuery, OrganizationSettingReportQueryVariables>;
export const LanguagesDocument = gql`
    query Languages($filter: LanguageFilterInput) {
  languages(filter: $filter) {
    id
    code
  }
}
    `;

/**
 * __useLanguagesQuery__
 *
 * To run a query within a React component, call `useLanguagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useLanguagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLanguagesQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useLanguagesQuery(baseOptions?: Apollo.QueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
      }
export function useLanguagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export function useLanguagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LanguagesQuery, LanguagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LanguagesQuery, LanguagesQueryVariables>(LanguagesDocument, options);
        }
export type LanguagesQueryHookResult = ReturnType<typeof useLanguagesQuery>;
export type LanguagesLazyQueryHookResult = ReturnType<typeof useLanguagesLazyQuery>;
export type LanguagesSuspenseQueryHookResult = ReturnType<typeof useLanguagesSuspenseQuery>;
export type LanguagesQueryResult = Apollo.QueryResult<LanguagesQuery, LanguagesQueryVariables>;
export const ReportRecipientsDocument = gql`
    query ReportRecipients($organizationId: ID!) {
  reportRecipients(organizationId: $organizationId) {
    id
    respondentDeleted
    teamDeleted
    respondent {
      id
      firstname
      surname
      contacts {
        type
        value
      }
    }
    team {
      id
      name
    }
    language {
      id
      code
    }
    type
  }
}
    `;

/**
 * __useReportRecipientsQuery__
 *
 * To run a query within a React component, call `useReportRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportRecipientsQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useReportRecipientsQuery(baseOptions: Apollo.QueryHookOptions<ReportRecipientsQuery, ReportRecipientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportRecipientsQuery, ReportRecipientsQueryVariables>(ReportRecipientsDocument, options);
      }
export function useReportRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportRecipientsQuery, ReportRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportRecipientsQuery, ReportRecipientsQueryVariables>(ReportRecipientsDocument, options);
        }
export function useReportRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportRecipientsQuery, ReportRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportRecipientsQuery, ReportRecipientsQueryVariables>(ReportRecipientsDocument, options);
        }
export type ReportRecipientsQueryHookResult = ReturnType<typeof useReportRecipientsQuery>;
export type ReportRecipientsLazyQueryHookResult = ReturnType<typeof useReportRecipientsLazyQuery>;
export type ReportRecipientsSuspenseQueryHookResult = ReturnType<typeof useReportRecipientsSuspenseQuery>;
export type ReportRecipientsQueryResult = Apollo.QueryResult<ReportRecipientsQuery, ReportRecipientsQueryVariables>;
export const GetOrganizationRespondentsCountDocument = gql`
    query getOrganizationRespondentsCount($organizationId: ID!) {
  organization(organizationId: $organizationId) {
    respondentsCount
  }
}
    `;

/**
 * __useGetOrganizationRespondentsCountQuery__
 *
 * To run a query within a React component, call `useGetOrganizationRespondentsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationRespondentsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationRespondentsCountQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetOrganizationRespondentsCountQuery(baseOptions: Apollo.QueryHookOptions<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>(GetOrganizationRespondentsCountDocument, options);
      }
export function useGetOrganizationRespondentsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>(GetOrganizationRespondentsCountDocument, options);
        }
export function useGetOrganizationRespondentsCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>(GetOrganizationRespondentsCountDocument, options);
        }
export type GetOrganizationRespondentsCountQueryHookResult = ReturnType<typeof useGetOrganizationRespondentsCountQuery>;
export type GetOrganizationRespondentsCountLazyQueryHookResult = ReturnType<typeof useGetOrganizationRespondentsCountLazyQuery>;
export type GetOrganizationRespondentsCountSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationRespondentsCountSuspenseQuery>;
export type GetOrganizationRespondentsCountQueryResult = Apollo.QueryResult<GetOrganizationRespondentsCountQuery, GetOrganizationRespondentsCountQueryVariables>;
export const GetOrganizationsDocument = gql`
    query getOrganizations {
  user {
    id
    allowedOrganizations {
      id
      name
      systemName
    }
    organization {
      id
      name
      systemName
    }
  }
}
    `;

/**
 * __useGetOrganizationsQuery__
 *
 * To run a query within a React component, call `useGetOrganizationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrganizationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrganizationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrganizationsQuery(baseOptions?: Apollo.QueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
      }
export function useGetOrganizationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export function useGetOrganizationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrganizationsQuery, GetOrganizationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrganizationsQuery, GetOrganizationsQueryVariables>(GetOrganizationsDocument, options);
        }
export type GetOrganizationsQueryHookResult = ReturnType<typeof useGetOrganizationsQuery>;
export type GetOrganizationsLazyQueryHookResult = ReturnType<typeof useGetOrganizationsLazyQuery>;
export type GetOrganizationsSuspenseQueryHookResult = ReturnType<typeof useGetOrganizationsSuspenseQuery>;
export type GetOrganizationsQueryResult = Apollo.QueryResult<GetOrganizationsQuery, GetOrganizationsQueryVariables>;
export const ReportAccessDocument = gql`
    query ReportAccess($surveyId: ID!) {
  survey(surveyId: $surveyId) {
    sendAt
    endsAt
    isReportPendingApproval
    topic {
      name
      topicGroup {
        name
        translations {
          id
          language {
            code
          }
          value
        }
      }
    }
    status
    reports {
      id
      accessKey
      respondent {
        id
        firstname
        surname
        contacts {
          type
          value
        }
      }
      accepted
      sent
      teams {
        id
        name
        leader {
          id
        }
      }
      readAt
      resultsInfo {
        answered
        total
      }
    }
    resultsInfo {
      answered
      total
    }
    reportRecipients {
      team {
        id
      }
      validFrom
      validTo
      respondent {
        id
      }
    }
  }
}
    `;

/**
 * __useReportAccessQuery__
 *
 * To run a query within a React component, call `useReportAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useReportAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReportAccessQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useReportAccessQuery(baseOptions: Apollo.QueryHookOptions<ReportAccessQuery, ReportAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReportAccessQuery, ReportAccessQueryVariables>(ReportAccessDocument, options);
      }
export function useReportAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReportAccessQuery, ReportAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReportAccessQuery, ReportAccessQueryVariables>(ReportAccessDocument, options);
        }
export function useReportAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ReportAccessQuery, ReportAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReportAccessQuery, ReportAccessQueryVariables>(ReportAccessDocument, options);
        }
export type ReportAccessQueryHookResult = ReturnType<typeof useReportAccessQuery>;
export type ReportAccessLazyQueryHookResult = ReturnType<typeof useReportAccessLazyQuery>;
export type ReportAccessSuspenseQueryHookResult = ReturnType<typeof useReportAccessSuspenseQuery>;
export type ReportAccessQueryResult = Apollo.QueryResult<ReportAccessQuery, ReportAccessQueryVariables>;
export const SequenceReportAccessesDocument = gql`
    query SequenceReportAccesses($surveyGroupId: ID!) {
  surveyGroup(surveyGroupId: $surveyGroupId) {
    from
    topicGroup {
      id
      name
      translations {
        id
        language {
          code
        }
        value
      }
    }
    status
    isAnySurveyComplete
    steps {
      processStep {
        startOffsetMins
        reminders {
          reminderOffsetMins
        }
        endOffsetMins
        stepTopicGroup {
          id
          name
          translations {
            id
            language {
              code
            }
            value
          }
        }
      }
      daysFromStart
      status
      hasNotStarted
      notstartedReason
      statistics {
        answered
        total
      }
    }
    reports {
      id
      accessKey
      respondent {
        id
        firstname
        surname
        contacts {
          type
          value
        }
      }
      accepted
      sent
      teams {
        id
        name
        leader {
          id
        }
      }
      readAt
      visitsInLastYear
      totalCount
      unreadCount
    }
    reportRecipients {
      team {
        id
      }
      validFrom
      validTo
      respondent {
        id
      }
    }
  }
}
    `;

/**
 * __useSequenceReportAccessesQuery__
 *
 * To run a query within a React component, call `useSequenceReportAccessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSequenceReportAccessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSequenceReportAccessesQuery({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useSequenceReportAccessesQuery(baseOptions: Apollo.QueryHookOptions<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>(SequenceReportAccessesDocument, options);
      }
export function useSequenceReportAccessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>(SequenceReportAccessesDocument, options);
        }
export function useSequenceReportAccessesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>(SequenceReportAccessesDocument, options);
        }
export type SequenceReportAccessesQueryHookResult = ReturnType<typeof useSequenceReportAccessesQuery>;
export type SequenceReportAccessesLazyQueryHookResult = ReturnType<typeof useSequenceReportAccessesLazyQuery>;
export type SequenceReportAccessesSuspenseQueryHookResult = ReturnType<typeof useSequenceReportAccessesSuspenseQuery>;
export type SequenceReportAccessesQueryResult = Apollo.QueryResult<SequenceReportAccessesQuery, SequenceReportAccessesQueryVariables>;
export const TopicGroupDocument = gql`
    query topicGroup($topicGroupId: ID!, $language: ID) {
  topicGroup(topicGroupId: $topicGroupId, language: $language) {
    id
    name
    description
    organization {
      id
    }
    translations {
      value
      description
      language {
        id
      }
    }
    steps {
      id
      startOffsetMins
      reminders {
        reminderOffsetMins
      }
      endOffsetMins
      stepTopicGroup {
        id
        organization {
          id
        }
        lastValidTopic {
          id
          name
        }
        lastValidTopic {
          id
        }
        translations {
          value
          description
          language {
            id
            code
          }
        }
      }
    }
    name
    description
    translations {
      language {
        id
        code
      }
      value
      id
      description
    }
    typeCode
  }
}
    `;

/**
 * __useTopicGroupQuery__
 *
 * To run a query within a React component, call `useTopicGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTopicGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTopicGroupQuery({
 *   variables: {
 *      topicGroupId: // value for 'topicGroupId'
 *      language: // value for 'language'
 *   },
 * });
 */
export function useTopicGroupQuery(baseOptions: Apollo.QueryHookOptions<TopicGroupQuery, TopicGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TopicGroupQuery, TopicGroupQueryVariables>(TopicGroupDocument, options);
      }
export function useTopicGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TopicGroupQuery, TopicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TopicGroupQuery, TopicGroupQueryVariables>(TopicGroupDocument, options);
        }
export function useTopicGroupSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<TopicGroupQuery, TopicGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TopicGroupQuery, TopicGroupQueryVariables>(TopicGroupDocument, options);
        }
export type TopicGroupQueryHookResult = ReturnType<typeof useTopicGroupQuery>;
export type TopicGroupLazyQueryHookResult = ReturnType<typeof useTopicGroupLazyQuery>;
export type TopicGroupSuspenseQueryHookResult = ReturnType<typeof useTopicGroupSuspenseQuery>;
export type TopicGroupQueryResult = Apollo.QueryResult<TopicGroupQuery, TopicGroupQueryVariables>;
export const ExportTranslationsDocument = gql`
    query exportTranslations($topicId: ID!, $languageCode: String, $topicGroupId: ID) {
  exportTranslations(
    topicId: $topicId
    languageCode: $languageCode
    topicGroupId: $topicGroupId
  ) {
    mimetype
    name
    contents
  }
}
    `;

/**
 * __useExportTranslationsQuery__
 *
 * To run a query within a React component, call `useExportTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExportTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExportTranslationsQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      languageCode: // value for 'languageCode'
 *      topicGroupId: // value for 'topicGroupId'
 *   },
 * });
 */
export function useExportTranslationsQuery(baseOptions: Apollo.QueryHookOptions<ExportTranslationsQuery, ExportTranslationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExportTranslationsQuery, ExportTranslationsQueryVariables>(ExportTranslationsDocument, options);
      }
export function useExportTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExportTranslationsQuery, ExportTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExportTranslationsQuery, ExportTranslationsQueryVariables>(ExportTranslationsDocument, options);
        }
export function useExportTranslationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ExportTranslationsQuery, ExportTranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExportTranslationsQuery, ExportTranslationsQueryVariables>(ExportTranslationsDocument, options);
        }
export type ExportTranslationsQueryHookResult = ReturnType<typeof useExportTranslationsQuery>;
export type ExportTranslationsLazyQueryHookResult = ReturnType<typeof useExportTranslationsLazyQuery>;
export type ExportTranslationsSuspenseQueryHookResult = ReturnType<typeof useExportTranslationsSuspenseQuery>;
export type ExportTranslationsQueryResult = Apollo.QueryResult<ExportTranslationsQuery, ExportTranslationsQueryVariables>;
export const SurveysDocument = gql`
    query surveys($languageCode: String) {
  user(languageCode: $languageCode) {
    organization {
      surveys {
        id
        public
        status
        whitelistedRespondents {
          id
        }
        resultsInfo {
          answered
          total
        }
        topic {
          name
        }
        topicGroup {
          name
          typeCode
        }
        sendAt
      }
    }
  }
}
    `;

/**
 * __useSurveysQuery__
 *
 * To run a query within a React component, call `useSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveysQuery({
 *   variables: {
 *      languageCode: // value for 'languageCode'
 *   },
 * });
 */
export function useSurveysQuery(baseOptions?: Apollo.QueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
      }
export function useSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
        }
export function useSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SurveysQuery, SurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SurveysQuery, SurveysQueryVariables>(SurveysDocument, options);
        }
export type SurveysQueryHookResult = ReturnType<typeof useSurveysQuery>;
export type SurveysLazyQueryHookResult = ReturnType<typeof useSurveysLazyQuery>;
export type SurveysSuspenseQueryHookResult = ReturnType<typeof useSurveysSuspenseQuery>;
export type SurveysQueryResult = Apollo.QueryResult<SurveysQuery, SurveysQueryVariables>;
export const PublicTopicGroupsDocument = gql`
    query publicTopicGroups($language: String!, $product: String) {
  publicTopicGroups(language: $language, product: $product) {
    id
    name
  }
}
    `;

/**
 * __usePublicTopicGroupsQuery__
 *
 * To run a query within a React component, call `usePublicTopicGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePublicTopicGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePublicTopicGroupsQuery({
 *   variables: {
 *      language: // value for 'language'
 *      product: // value for 'product'
 *   },
 * });
 */
export function usePublicTopicGroupsQuery(baseOptions: Apollo.QueryHookOptions<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>(PublicTopicGroupsDocument, options);
      }
export function usePublicTopicGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>(PublicTopicGroupsDocument, options);
        }
export function usePublicTopicGroupsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>(PublicTopicGroupsDocument, options);
        }
export type PublicTopicGroupsQueryHookResult = ReturnType<typeof usePublicTopicGroupsQuery>;
export type PublicTopicGroupsLazyQueryHookResult = ReturnType<typeof usePublicTopicGroupsLazyQuery>;
export type PublicTopicGroupsSuspenseQueryHookResult = ReturnType<typeof usePublicTopicGroupsSuspenseQuery>;
export type PublicTopicGroupsQueryResult = Apollo.QueryResult<PublicTopicGroupsQuery, PublicTopicGroupsQueryVariables>;
export const LastMessagesForRespondentDocument = gql`
    query lastMessagesForRespondent($surveyIds: [ID!]!, $respondentIds: [ID!]!) {
  lastMessagesForRespondent(surveyIds: $surveyIds, respondentIds: $respondentIds) {
    id
    messageStatus
    processed
    createdAt
    error
    surveyId
  }
}
    `;

/**
 * __useLastMessagesForRespondentQuery__
 *
 * To run a query within a React component, call `useLastMessagesForRespondentQuery` and pass it any options that fit your needs.
 * When your component renders, `useLastMessagesForRespondentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLastMessagesForRespondentQuery({
 *   variables: {
 *      surveyIds: // value for 'surveyIds'
 *      respondentIds: // value for 'respondentIds'
 *   },
 * });
 */
export function useLastMessagesForRespondentQuery(baseOptions: Apollo.QueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
      }
export function useLastMessagesForRespondentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
        }
export function useLastMessagesForRespondentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>(LastMessagesForRespondentDocument, options);
        }
export type LastMessagesForRespondentQueryHookResult = ReturnType<typeof useLastMessagesForRespondentQuery>;
export type LastMessagesForRespondentLazyQueryHookResult = ReturnType<typeof useLastMessagesForRespondentLazyQuery>;
export type LastMessagesForRespondentSuspenseQueryHookResult = ReturnType<typeof useLastMessagesForRespondentSuspenseQuery>;
export type LastMessagesForRespondentQueryResult = Apollo.QueryResult<LastMessagesForRespondentQuery, LastMessagesForRespondentQueryVariables>;
export const GetCreditHistoryDocument = gql`
    query getCreditHistory($productId: ID!) {
  getCreditHistory(productId: $productId) {
    id
    organization {
      id
      name
    }
    type
    creditsUsed
    createdAt
    user {
      id
      firstname
      surname
    }
  }
}
    `;

/**
 * __useGetCreditHistoryQuery__
 *
 * To run a query within a React component, call `useGetCreditHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditHistoryQuery({
 *   variables: {
 *      productId: // value for 'productId'
 *   },
 * });
 */
export function useGetCreditHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>(GetCreditHistoryDocument, options);
      }
export function useGetCreditHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>(GetCreditHistoryDocument, options);
        }
export function useGetCreditHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>(GetCreditHistoryDocument, options);
        }
export type GetCreditHistoryQueryHookResult = ReturnType<typeof useGetCreditHistoryQuery>;
export type GetCreditHistoryLazyQueryHookResult = ReturnType<typeof useGetCreditHistoryLazyQuery>;
export type GetCreditHistorySuspenseQueryHookResult = ReturnType<typeof useGetCreditHistorySuspenseQuery>;
export type GetCreditHistoryQueryResult = Apollo.QueryResult<GetCreditHistoryQuery, GetCreditHistoryQueryVariables>;
export const GetCompletedSurveysDocument = gql`
    query getCompletedSurveys($organizationId: ID!) {
  getCompletedSurveys(organizationId: $organizationId) {
    id
    topic {
      name
    }
    topicGroup {
      name
    }
    sendAt
    endsAt
    teamIds
    reports {
      id
      accessKey
      respondent {
        id
      }
      teams {
        id
      }
    }
  }
}
    `;

/**
 * __useGetCompletedSurveysQuery__
 *
 * To run a query within a React component, call `useGetCompletedSurveysQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompletedSurveysQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompletedSurveysQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetCompletedSurveysQuery(baseOptions: Apollo.QueryHookOptions<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>(GetCompletedSurveysDocument, options);
      }
export function useGetCompletedSurveysLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>(GetCompletedSurveysDocument, options);
        }
export function useGetCompletedSurveysSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>(GetCompletedSurveysDocument, options);
        }
export type GetCompletedSurveysQueryHookResult = ReturnType<typeof useGetCompletedSurveysQuery>;
export type GetCompletedSurveysLazyQueryHookResult = ReturnType<typeof useGetCompletedSurveysLazyQuery>;
export type GetCompletedSurveysSuspenseQueryHookResult = ReturnType<typeof useGetCompletedSurveysSuspenseQuery>;
export type GetCompletedSurveysQueryResult = Apollo.QueryResult<GetCompletedSurveysQuery, GetCompletedSurveysQueryVariables>;
export const WatchSurveyGroupChangesDocument = gql`
    subscription WatchSurveyGroupChanges($surveyGroupId: ID!) {
  watchSurveyGroupChanges(surveyGroupId: $surveyGroupId) {
    surveyGroupId
  }
}
    `;

/**
 * __useWatchSurveyGroupChangesSubscription__
 *
 * To run a query within a React component, call `useWatchSurveyGroupChangesSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchSurveyGroupChangesSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchSurveyGroupChangesSubscription({
 *   variables: {
 *      surveyGroupId: // value for 'surveyGroupId'
 *   },
 * });
 */
export function useWatchSurveyGroupChangesSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchSurveyGroupChangesSubscription, WatchSurveyGroupChangesSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchSurveyGroupChangesSubscription, WatchSurveyGroupChangesSubscriptionVariables>(WatchSurveyGroupChangesDocument, options);
      }
export type WatchSurveyGroupChangesSubscriptionHookResult = ReturnType<typeof useWatchSurveyGroupChangesSubscription>;
export type WatchSurveyGroupChangesSubscriptionResult = Apollo.SubscriptionResult<WatchSurveyGroupChangesSubscription>;
export const ArielAiChatDocument = gql`
    subscription ArielAiChat($topicId: ID!, $languageCode: String!, $messages: [ArielAiChatMessageInput!]!, $graph: [ArielAiNodeDataInput!]!) {
  arielAiChat(
    topicId: $topicId
    languageCode: $languageCode
    messages: $messages
    graph: $graph
  ) {
    text
    done
    patch {
      questionIndex
      questionText
      isRequired
      metrics
      isQuestionTrigger
      choices {
        key
        value
      }
      statements
      statementIds
      randomizeOrder
      isRankingScale
      showEscapeOption
      type
      range {
        min
        max
      }
      answersToHighlight {
        key
        value
      }
      input
      outputs {
        key
        targetQuestionIndex
      }
      position
      reportOrder
      comments {
        id
        text
        originator
      }
      commentGroupId
    }
    error {
      code
      message
      validationErrors
    }
  }
}
    `;

/**
 * __useArielAiChatSubscription__
 *
 * To run a query within a React component, call `useArielAiChatSubscription` and pass it any options that fit your needs.
 * When your component renders, `useArielAiChatSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArielAiChatSubscription({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      languageCode: // value for 'languageCode'
 *      messages: // value for 'messages'
 *      graph: // value for 'graph'
 *   },
 * });
 */
export function useArielAiChatSubscription(baseOptions: Apollo.SubscriptionHookOptions<ArielAiChatSubscription, ArielAiChatSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<ArielAiChatSubscription, ArielAiChatSubscriptionVariables>(ArielAiChatDocument, options);
      }
export type ArielAiChatSubscriptionHookResult = ReturnType<typeof useArielAiChatSubscription>;
export type ArielAiChatSubscriptionResult = Apollo.SubscriptionResult<ArielAiChatSubscription>;